"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8154],{

/***/ 92235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(579);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42227);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19546);
/* harmony import */ var _tests_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(376);





function RoomItemAvatar(param) {
    var type = param.type, src = param.src, name = param.name, shortName = param.shortName, isDeactive = param.isDeactive;
    if (type === "ROOM_TYPE_PERSONAL") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .AvatarContainer */ .mw, {
            "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_4__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR */ .IB,
            children: isDeactive ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                src: "/images/avatar.png",
                alt: "User Not Found Avatar"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                alt: name,
                src: (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .transformAvatarUrl */ .rK)(src),
                onError: function(e) {
                    return (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .handleErrorAvatar */ .Tk)(e, name);
                }
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .AvatarContainer */ .mw, {
        "data-cy": _tests_constant__WEBPACK_IMPORTED_MODULE_4__/* .DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR */ .IB,
        children: src === "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .GroupAvatar */ .NS, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                "data-username": name,
                children: shortName
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            alt: name,
            src: src,
            onError: function(e) {
                return (0,utils_general__WEBPACK_IMPORTED_MODULE_2__/* .handleErrorAvatar */ .Tk)(e, name);
            }
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (RoomItemAvatar);


/***/ }),

/***/ 376:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION_COUNT; },
/* harmony export */   "F9": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER; },
/* harmony export */   "IB": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR; },
/* harmony export */   "Jf": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED; },
/* harmony export */   "QB": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION; },
/* harmony export */   "X3": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_ACCEPT; },
/* harmony export */   "XY": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION; },
/* harmony export */   "c2": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW; },
/* harmony export */   "dI": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED; },
/* harmony export */   "dh": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST; },
/* harmony export */   "e3": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_DELETE; },
/* harmony export */   "e9": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_CANCEL_BUTTON; },
/* harmony export */   "eO": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_TOOLTIP_CREATE_GROUP; },
/* harmony export */   "h5": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM; },
/* harmony export */   "hK": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_INPUT_SEARCH; },
/* harmony export */   "i4": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_BUTTON; },
/* harmony export */   "iu": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER; },
/* harmony export */   "jL": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CANCEL; },
/* harmony export */   "nJ": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED; },
/* harmony export */   "o2": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED_EMPTY; },
/* harmony export */   "oG": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CONFIRM; },
/* harmony export */   "pD": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_SEARCHED_RESULT; },
/* harmony export */   "q9": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED_EMPTY; },
/* harmony export */   "tw": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_EDIT_BUTTON; },
/* harmony export */   "v6": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM; }
/* harmony export */ });
/* unused harmony exports TEST_CASE_MESSAGE_COMPONENTS, QUERY_STRING_TYPE_INVTED */
var TEST_CASE_MESSAGE_COMPONENTS = function(comp) {
    return {
        SHOULD_RENDER_SUCCESSFULLY: "Component ".concat(comp, " should render successfully")
    };
};
// ListRoom
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM = "chat-page-left-panel-room-list-index";
// RoomList
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED = "chat-page-left-panel-room-list-accepted";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED = "chat-page-left-panel-room-list-invited";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_ACCEPTED_EMPTY = "chat-page-left-panel-room-list-accepted-empty";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_LIST_INVITED_EMPTY = "chat-page-left-panel-room-list-invited-empty";
// RoomItem
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM = "chat-page-left-panel-room-item";
// New Message Searched Result
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_SEARCHED_RESULT = "chat-page-left-panel-new-message-searched-result";
// RoomItemAvatar
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_ROOM_ITEM_AVATAR = "chat-page-left-panel-room-item-avatar";
// MessageRequestCount
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION = "chat-page-left-panel-message-request-section";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MESSAGE_REQUEST_SECTION_COUNT = "chat-page-left-panel-message-request-section-count";
// LastMessagePreview
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW = "chat-page-left-panel-last-message-preview";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_LAST_MESSAGE_PREVIEW_DELETED = "chat-page-left-panel-last-message-preview-deleted";
// Header
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER = "chat-page-left-panel-header";
// HeaderRequest
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST = "chat-page-left-panel-header-request";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_CANCEL_BUTTON = "chat-page-left-panel-header-request-cancel-button";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_HEADER_REQUEST_EDIT_BUTTON = "chat-page-left-panel-header-request-edit-button";
// Footer
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER = "chat-page-left-panel-footer";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_DELETE = "chat-page-left-panel-footer-delete";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_FOOTER_ACCEPT = "chat-page-left-panel-footer-accept";
// InputSearch
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_INPUT_SEARCH = "chat-page-left-panel-input-search";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_NEW_MESSAGE_BUTTON = "chat-page-left-panel-new-message-button";
// ModalConfirmation
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION = "chat-page-left-panel-modal-confirmation";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CANCEL = "chat-page-left-panel-modal-confirmation-cancel-button";
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_MODAL_CONFIRMATION_CONFIRM = "chat-page-left-panel-modal-confirmation-confirm-button";
// Tooltip create group
var DATA_CY_NAME_CHAT_PAGE_LEFT_PANEL_TOOLTIP_CREATE_GROUP = "chat-page-left-panel-tooltip-create-group";
var QUERY_STRING_TYPE_INVTED = "request";


/***/ }),

/***/ 19546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cu": function() { return /* binding */ InputSearchContainer; },
/* harmony export */   "E": function() { return /* binding */ FooterActionButton; },
/* harmony export */   "EG": function() { return /* binding */ RoomItemContent; },
/* harmony export */   "KY": function() { return /* binding */ RoomItemBody; },
/* harmony export */   "M3": function() { return /* binding */ RoomListContainer; },
/* harmony export */   "Mj": function() { return /* binding */ SearchInput; },
/* harmony export */   "NS": function() { return /* binding */ GroupAvatar; },
/* harmony export */   "Og": function() { return /* binding */ RoomItemStatus; },
/* harmony export */   "V9": function() { return /* binding */ PanelHeader; },
/* harmony export */   "WR": function() { return /* binding */ ButtonHeaderRequestAction; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "Z4": function() { return /* binding */ LoadingMore; },
/* harmony export */   "_c": function() { return /* binding */ DeletedLastMessage; },
/* harmony export */   "bk": function() { return /* binding */ FooterContainer; },
/* harmony export */   "c": function() { return /* binding */ NewChatCount; },
/* harmony export */   "lk": function() { return /* binding */ PanelContainer; },
/* harmony export */   "mw": function() { return /* binding */ AvatarContainer; },
/* harmony export */   "s6": function() { return /* binding */ IconNewChat; },
/* harmony export */   "sd": function() { return /* binding */ RequestHeaderContainer; },
/* harmony export */   "xn": function() { return /* binding */ WebHeaderContainer; },
/* harmony export */   "yV": function() { return /* binding */ ButtonUnstyled; },
/* harmony export */   "z5": function() { return /* binding */ ChatItem; }
/* harmony export */ });
/* unused harmony exports ShimmerListRoomContainer, Shimmer, RequestNumberContainer, LeftMobileHeaderContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41080);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 90%;\n  display: flex;\n  align-items: center;\n  font-style: italic;\n  color: #858585;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: ",
        ";\n  width: 100vw;\n  max-width: 100%;\n  height: 100%;\n  position: relative;\n  @media ",
        " {\n    border-right: solid 1px ",
        ";\n    display: block;\n    width: 350px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n  height: calc(100% - 61px);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border-left: 5px solid ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  /* height : 75px; */\n  border-bottom: 1px solid ",
        ";\n  cursor : pointer;\n  padding-left: ",
        ";\n  padding-right: 20px;\n  padding-top: 14px;\n  padding-bottom: 15px;\n\n  &:hover, &:active, &:focus {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 50%;\n  height: 24px;\n  min-width: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 24px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-skeleton-title {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .ant-skeleton-paragraph {\n    margin-top: 10px !important;\n    margin-bottom: 0px !important;\n  }\n  margin-bottom: 36px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 21px 24px;\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  top: 0;\n  height: auto;\n  transition: 0.5s;\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: min-content;\n  overflow: visible;\n  background: transparent;\n  cursor: pointer;\n\n  :hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n\n  button {\n    height: 32px;\n  }\n\n  #chat-search-back-button {\n    position: absolute;\n    left: -35px;\n    transition: 0.2s;\n  }\n\n  #chat-search-new-chat-button {\n    position: relative;\n    right: 0;\n    transition: 0.5s;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 100px;\n  min-height: 100px;\n  position: relative;\n  :before {\n    content: 'Loading…';\n    position: absolute;\n    top: calc(50% - 15px);\n    left: calc(50% - 15px);\n    width: 30px;\n    height: 30px;\n    margin-top: 0;\n    margin-left: 0;\n  }\n  :before {\n    content: '';\n    border-radius: 50%;\n    border-top: 2px solid #ccc;\n    border-right: 2px solid transparent;\n    animation: ",
        " 0.7s linear infinite;\n    -webkit-animation: ",
        " 0.7s linear infinite;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: 'space-between';\n  align-items: 'center';\n  flex-grow: 1;\n\n  p > img {\n    margin-right: 5px;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: calc(100% - 100px);\n    "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: calc(100% - 60px);\n\n  ",
        "\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  img {\n    width: 16px;\n  }\n  & > :last-child {\n    margin-left: 5px;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 46px;\n  height: 46px;\n  line-height: 46px;\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n  text-transform: uppercase;\n  text-align: center;\n  border-radius: 100%;\n  overflow: hidden;\n  background: #ebf8f3;\n  color: #00ab6b;\n  i {\n    font-style: normal;\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-right: 12px;\n\n  & > img {\n    border-radius: 50%;\n    width: 46px;\n    height: 46px;\n    border: 1px solid ",
        ";\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  height: 32px;\n\n  :hover {\n    border-color: ",
        " !important;\n  }\n\n  input::placeholder,\n  input::-webkit-input-placeholder {\n    color: #e4e4e4 !important;\n  }\n\n  .ant-input-prefix {\n    margin-right: 10px;\n  }\n\n  .ant-input-clear-icon {\n    display: flex;\n    color: rgba(0, 0, 0, 0.5);\n  }\n\n  #chat-left-contact-search-close {\n    width: 16px;\n    height: 16px;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  height: min-content;\n  overflow: visible;\n  background: transparent;\n  color: ",
        ";\n  width: 55px;\n  text-align: right;\n  cursor: pointer;\n\n  :hover {\n    background: none;\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 15px;\n  .ant-checkbox-inner {\n    border-radius: 100% !important;\n    width: 18px;\n    height: 18px;\n    position: relative;\n\n    :after {\n      left: 3.5px !important;\n      top: 7px !important;\n    }\n  }\n  .ant-checkbox-checked .ant-checkbox-inner {\n    background: ",
        ";\n    border-color: ",
        "!important;\n  }\n  .ant-checkbox-disabled .ant-checkbox-inner {\n    border-color: ",
        "!important;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-around;\n  border-top: 1px solid ",
        ";\n  background-color: ",
        ";\n  padding: 20px;\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  margin: 0;\n  padding: 0;\n  height: min-content;\n  overflow: visible;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  font-family: var(--font-bold);\n  cursor: pointer;\n\n  img {\n    margin-right: 10px;\n  }\n\n  :hover {\n    background: none;\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, IconBase64 = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.IconBase64 */ .Gn.IconBase64, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, Avatar = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Avatar */ .Gn.Avatar, CheckboxAntd = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Checkbox */ .Gn.Checkbox, AntdInput = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Input */ .Gn.Input;
var DeletedLastMessage = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).withConfig({
    componentId: "sc-8082db7c-0"
})(_templateObject());
var PanelContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.attrs(function(props) {
    return {
        visible: props.visible
    };
}).withConfig({
    componentId: "sc-8082db7c-1"
})(_templateObject1(), function(param) {
    var visible = param.visible;
    return visible ? "block" : "none";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.tablet */ .Uh.tablet, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray);
var PanelHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    padding: "14px 20px",
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-8082db7c-2"
})(_templateObject2(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.whisper */ .$_.whisper);
var IconNewChat = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(IconBase64).withConfig({
    componentId: "sc-8082db7c-3"
})(_templateObject3(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.whisper */ .$_.whisper);
var RoomListContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-4"
})(_templateObject4());
var ChatItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    shouldForwardProp: function(prop) {
        return ![
            "active"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        active: props.active,
        align: "center"
    };
}).withConfig({
    componentId: "sc-8082db7c-5"
})(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.whisper */ .$_.whisper, function(param) {
    var active = param.active;
    return active ? "16px" : "20px";
}, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue, function(param) {
    var active = param.active;
    return active && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject5(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue);
}, function(param) {
    var cursorActive = param.cursorActive;
    return cursorActive && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject6(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue);
});
var NewChatCount = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs({
    color: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light,
    size: "11px",
    align: "center",
    padding: "2px"
}).withConfig({
    componentId: "sc-8082db7c-6"
})(_templateObject8(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var ShimmerListRoomContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-7"
})(_templateObject9());
var Shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    avatar: true,
    paragraph: {
        rows: 1
    },
    loading: true
}).withConfig({
    componentId: "sc-8082db7c-8"
})(_templateObject10());
var RequestHeaderContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-8082db7c-9"
})(_templateObject11(), function(param) {
    var visible = param.visible;
    return !visible && "\n    top: -50px;\n    transition: .5s;\n    width: 100%;\n    background-color: #fff;\n    height: 0;\n    padding: 0 16px;\n  ";
});
var LeftMobileHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-10"
})(_templateObject12(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileL */ .Uh.mobileL);
var ButtonUnstyled = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].button.withConfig({
    componentId: "sc-8082db7c-11"
})(_templateObject13(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray);
var InputSearchContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-12"
})(_templateObject14(), function(param) {
    var isFocus = param.isFocus;
    return isFocus && "\n    #chat-search-back-button {\n      position: relative;\n      left: 0;\n      transition: 0.5s;\n    }\n    #chat-search-new-chat-button {\n      position: absolute;\n      right: -90px;\n      transition: .5s;\n    }\n  ";
});
var RequestNumberContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-13"
})(_templateObject15(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .device.mobileL */ .Uh.mobileL);
var WebHeaderContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-14"
})(_templateObject16());
var loadingAnimation = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.keyframes)(_templateObject17());
var LoadingMore = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-15"
})(_templateObject18(), loadingAnimation, loadingAnimation);
var RoomItemContent = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-8082db7c-16"
})(_templateObject19());
var RoomItemBody = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-17"
})(_templateObject21(), function(param) {
    var hasCheckbox = param.hasCheckbox;
    return hasCheckbox && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject20());
});
var RoomItemStatus = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-8082db7c-18"
})(_templateObject22());
var GroupAvatar = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.withConfig({
    componentId: "sc-8082db7c-19"
})(_templateObject23());
var AvatarContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Avatar).withConfig({
    componentId: "sc-8082db7c-20"
})(_templateObject24(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.component */ .$_.component, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lowgray */ .$_.lowgray);
var SearchInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(AntdInput).attrs({
    type: "text"
}).withConfig({
    componentId: "sc-8082db7c-21"
})(_templateObject25(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var ButtonHeaderRequestAction = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].button.withConfig({
    componentId: "sc-8082db7c-22"
})(_templateObject26(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(CheckboxAntd).withConfig({
    componentId: "sc-8082db7c-23"
})(_templateObject27(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lowgray */ .$_.lowgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lowgray */ .$_.lowgray);
var FooterContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-8082db7c-24"
})(_templateObject28(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.whisper */ .$_.whisper, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.light */ .$_.light);
var FooterActionButton = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].button.withConfig({
    componentId: "sc-8082db7c-25"
})(_templateObject29());



/***/ }),

/***/ 40927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61876);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41208);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_setting__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45621);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63699);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1955);
/* harmony import */ var lib_api_trade__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65141);
/* harmony import */ var utils_uploadFile__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78603);








// APIs




// Utils

// Initial state
var initialState = {
    getChangePasswordToken: {
        data: {
            change_token: ""
        },
        isLoading: false,
        message: "",
        error: null
    },
    updatePassword: {
        data: {},
        isLoading: false,
        message: "",
        error: null
    },
    blockedUsers: {
        data: [],
        isLoading: false,
        message: "",
        error: null,
        isLastPage: true
    },
    notifications: {
        data: [],
        isLoading: false,
        message: "",
        error: null
    },
    changePhone: {
        phone: "",
        successVerify: false,
        isLoading: false,
        error: null
    },
    changeAvatar: {
        avatar: "",
        message: "",
        error: null,
        isLoading: false
    },
    tradingAccounts: {
        data: {},
        message: "",
        error: null,
        isLoading: false
    },
    avatar3DList: {
        data: [],
        message: "",
        error: null,
        isLoading: false
    },
    invitationSetting: {
        data: {
            group_setting: ""
        },
        message: "",
        error: null,
        isLoading: false
    },
    blacklistStatus: {
        status: false,
        message: "",
        error: null,
        isLoading: false
    }
};
// Reducers
var reducers = {
    changePhoneNumber: function(state, action) {
        state.changePhone.phone = action.payload;
    }
};
// Selectors
var editProfile = function(state) {
    return state.editProfile;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(editProfile, function(profile) {
    return {
        getChangePasswordToken: profile.getChangePasswordToken,
        updatePassword: profile.updatePassword,
        blockedUsers: profile.blockedUsers,
        notifications: profile.notifications,
        changePhone: profile.changePhone,
        avatar3DList: profile.avatar3DList,
        changeAvatar: profile.changeAvatar,
        tradingAccounts: profile.tradingAccounts,
        invitationSetting: profile.invitationSetting,
        blacklistStatus: profile.blacklistStatus
    };
});
// Action types
var CONTEXT = "@feature/edit-profile";
var actionType = {
    GET_CHANGE_PASSWORD_TOKEN: "".concat(CONTEXT, "/GET_CHANGE_PASSWORD_TOKEN"),
    UPDATE_PASSWORD: "".concat(CONTEXT, "/UPDATE_PASSWORD"),
    UPDATE_DISCOVERABLE_PRIVACY: "".concat(CONTEXT, "/UPDATE_DISCOVERABLE_PRIVACY"),
    GET_BLOCKED_USER: "".concat(CONTEXT, "/GET_BLOCKED_USER"),
    UNBLOCK_USER: "".concat(CONTEXT, "/UNBLOCK_USER"),
    DISCONNECT_SOCIAL_MEDIA: "".concat(CONTEXT, "/DISCONNECT_SOCIAL_MEDIA"),
    GET_NOTIFICATIONS: "".concat(CONTEXT, "/GET_NOTIFICATIONS"),
    UPDATE_NOTIFICATION: "".concat(CONTEXT, "/UPDATE_NOTIFICATION"),
    CHANGE_PHONE_NUMBER: "".concat(CONTEXT, "/CHANGE_PHONE_NUMBER"),
    VERIFY_PHONE_NUMBER: "".concat(CONTEXT, "/VERIFY_PHONE_NUMBER"),
    GET_AVATAR3D_LIST: "".concat(CONTEXT, "/GET_AVATAR3D_LIST"),
    CHANGE_AVATAR: "".concat(CONTEXT, "/CHANGE_AVATAR"),
    GET_TRADING_ACCOUNTS: "".concat(CONTEXT, "/GET_TRADING_ACCOUNTS"),
    UNLINK_TRADING_ACCOUNT: "".concat(CONTEXT, "/UNLINK_TRADING_ACCOUNT"),
    GET_INVITATION_SETTING: "".concat(CONTEXT, "/GET_INVITATION_SETTING"),
    UPDATE_INVITATION_SETTING: "".concat(CONTEXT, "/UPDATE_INVITATION_SETTING"),
    GET_BLOCKLIST_STATUS: "".concat(CONTEXT, "/GET_BLOCKLIST_STATUS"),
    UPDATE_BLOCKLIST_STATUS: "".concat(CONTEXT, "/UPDATE_BLOCKLIST_STATUS")
};
// Helper
var handleUploadAvatar = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var avatarUrl, upload, uploadedUrl;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    avatarUrl = "";
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return (0,utils_uploadFile__WEBPACK_IMPORTED_MODULE_7__/* .uploadFiles */ .IL)([
                        file
                    ], "avatar");
                case 4:
                    upload = _ctx.sent;
                    if (!upload.error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(upload);
                case 7:
                    uploadedUrl = upload.map(function(res) {
                        return res.data.url;
                    });
                    avatarUrl = uploadedUrl.join();
                    _ctx.next = 14;
                    break;
                case 11:
                    _ctx.prev = 11;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 14:
                    return _ctx.abrupt("return", {
                        data: avatarUrl
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return function handleUploadAvatar(file) {
        return _ref.apply(this, arguments);
    };
}();
var effects = {
    getChangePasswordToken: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_CHANGE_PASSWORD_TOKEN, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(password) {
            var requestTokenData, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        requestTokenData = {
                            password: password,
                            req_type: "CHANGE_TOKEN_REQ_TYPE_EDIT",
                            type: "CHANGE_TOKEN_TYPE_PASSWORD"
                        };
                        _ctx.next = 4;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getChangePasswordToken */ .Z.getChangePasswordToken(requestTokenData);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update password failed");
                    case 7:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(password) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePassword: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_PASSWORD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(passwordData) {
            var response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updatePassword */ .Z.updatePassword(passwordData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to update password failed");
                    case 6:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PASSWORD_CHANGED */ .Z.PASSWORD_CHANGED, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(passwordData) {
            return _ref.apply(this, arguments);
        };
    }()),
    updatePrivacy: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_DISCOVERABLE_PRIVACY, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_4__/* ["default"].updateBlacklistStatus */ .Z.updateBlacklistStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to update discoverable privacy failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    getBlockedUsers: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_BLOCKED_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(page) {
            var response, _data, _$error, message, data, sanitizedData;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getBlockedUser */ .Z.getBlockedUser(page);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get blocked user failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        sanitizedData = data.blocked_list;
                        return _ctx.abrupt("return", {
                            data: sanitizedData,
                            message: message,
                            more: data.more
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(page) {
            return _ref.apply(this, arguments);
        };
    }()),
    unblockUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UNBLOCK_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(userid) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].unblockUser */ .Z.unblockUser(userid);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to unblock user failed");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(message, constants_successMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_GREEN */ .Z.ALERT_GREEN);
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            userid: userid
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(userid) {
            return _ref.apply(this, arguments);
        };
    }()),
    disconnectSocialMedia: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.DISCONNECT_SOCIAL_MEDIA, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var socialMedia, password, requestBody, response, _data, _$error, data, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        socialMedia = param.socialMedia, password = param.password;
                        _ctx.prev = 1;
                        requestBody = {
                            password: password
                        };
                        _ctx.next = 5;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].disconnectSocialMedia */ .Z.disconnectSocialMedia(socialMedia, requestBody);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to disconnect social media failed");
                    case 8:
                        _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 11:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getNotifications: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_NOTIFICATIONS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getNotificationSettings */ .Z.getNotificationSettings();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get user notifications failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    updateNotification: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_NOTIFICATION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody, param) {
            var getState, response, _data, data, _$error, message, ref, _editProfile, _notifications, notifData, dataUpdated;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        getState = param.getState;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateNotificationSetting */ .Z.updateNotificationSetting(requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update notification setting failed");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        ref = getState(), _editProfile = ref.editProfile, _notifications = _editProfile.notifications, notifData = _notifications.data;
                        dataUpdated = notifData.map(function(notifList) {
                            var currentData = notifList.notifications;
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, notifList), {
                                notifications: currentData.map(function(currNotifData) {
                                    if (currNotifData.type === data.type) {
                                        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, data);
                                    }
                                    return currNotifData;
                                })
                            });
                        });
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 12:
                        return _ctx.abrupt("return", {
                            message: message,
                            dataUpdated: dataUpdated
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(requestBody, _) {
            return _ref.apply(this, arguments);
        };
    }()),
    // @ts-ignore
    getAvatar3DList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_AVATAR3D_LIST, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_user__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getAvatar3DList */ .Z.getAvatar3DList();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get avatar 3D list failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    changeAvatar: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.CHANGE_AVATAR, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
            var dataUpload, _$error, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return handleUploadAvatar(file);
                    case 3:
                        dataUpload = _ctx.sent;
                        _$error = dataUpload.error, data = dataUpload.data;
                        if (!_$error) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error
                        });
                    case 7:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    10
                ]
            ]);
        }));
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }()),
    getTradingAccounts: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_TRADING_ACCOUNTS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, data, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_trade__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getTradingConfig */ .Z.getTradingConfig();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get trading config failed");
                case 6:
                    _data = response.data, _$error = _data.error, data = _data.data, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    unlinkTradingAccount: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UNLINK_TRADING_ACCOUNT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(brokerKey) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_trade__WEBPACK_IMPORTED_MODULE_6__/* ["default"].unlinkTradingAccount */ .Z.unlinkTradingAccount(brokerKey);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to unlink trading account failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message,
                            brokerKey: brokerKey
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(brokerKey) {
            return _ref.apply(this, arguments);
        };
    }()),
    getInvitationSetting: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_INVITATION_SETTING, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, message, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getInvitationSetting */ .Z.getInvitationSetting();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get invitation setting failed");
                case 6:
                    _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        error: _$error,
                        message: message
                    });
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    updateInvitationSetting: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_INVITATION_SETTING, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(groupSetting) {
            var requestPayload, response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        requestPayload = {
                            group_setting: groupSetting
                        };
                        _ctx.next = 4;
                        return lib_api_setting__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateInvitationSetting */ .Z.updateInvitationSetting(requestPayload);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to update invitation setting failed");
                    case 7:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        }));
        return function(groupSetting) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBlacklistStatus: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.GET_BLOCKLIST_STATUS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, error_type, message, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getBlacklistStatus */ .Z.getBlacklistStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get blacklist status failed");
                case 6:
                    _data = response.data, _$error = _data.error, error_type = _data.error_type, message = _data.message, data = _data.data;
                    if (!(_$error || error_type)) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(message);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    updateBlacklistStatus: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.UPDATE_BLOCKLIST_STATUS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, error_type, message, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_friends__WEBPACK_IMPORTED_MODULE_4__/* ["default"].updateBlacklistStatus */ .Z.updateBlacklistStatus();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to set blacklist status failed");
                case 6:
                    _data = response.data, _$error = _data.error, error_type = _data.error_type, message = _data.message, data = _data.data;
                    if (!(_$error || error_type)) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(message);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        error: _ctx.t0
                    });
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    })))
};
var extraReducers = function(builder) {
    builder.addCase(effects.getChangePasswordToken.pending, function(state) {
        state.getChangePasswordToken.isLoading = true;
        state.getChangePasswordToken.error = null;
    }).addCase(effects.getChangePasswordToken.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.getChangePasswordToken.error = error;
        } else {
            state.getChangePasswordToken.data = data;
        }
        state.getChangePasswordToken.message = message;
        state.getChangePasswordToken.isLoading = false;
    }).addCase(effects.getChangePasswordToken.rejected, function(state, action) {
        state.getChangePasswordToken.isLoading = false;
        state.getChangePasswordToken.error = action.payload.error;
    }).addCase(effects.updatePassword.pending, function(state) {
        state.updatePassword.isLoading = true;
        state.updatePassword.error = null;
    }).addCase(effects.updatePassword.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.updatePassword.error = error;
        } else {
            state.updatePassword.data = data;
        }
        state.updatePassword.message = message;
        state.updatePassword.isLoading = false;
    }).addCase(effects.updatePassword.rejected, function(state, action) {
        state.updatePassword.isLoading = false;
        state.updatePassword.error = action.payload.error;
    })// update discoverable privacy doesn't affect reducer
    .addCase(effects.getBlockedUsers.pending, function(state, action) {
        state.blockedUsers.isLoading = true;
        state.blockedUsers.error = null;
        // reset list
        if (action.meta.arg === 1) {
            state.blockedUsers.data = initialState.blockedUsers.data;
        }
    }).addCase(effects.getBlockedUsers.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message, more = _payload.more;
        if (error) {
            state.blockedUsers.error = error;
        } else {
            var _data;
            (_data = state.blockedUsers.data).push.apply(_data, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(data));
            state.blockedUsers.isLastPage = !more;
        }
        state.blockedUsers.isLoading = false;
        state.blockedUsers.message = message;
    }).addCase(effects.getBlockedUsers.rejected, function(state, action) {
        state.blockedUsers.error = action.payload.error;
        state.blockedUsers.isLoading = false;
    })// only handle if unblock success
    .addCase(effects.unblockUser.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, userid = _payload.userid;
        if (!error) {
            var newUserList = state.blockedUsers.data.filter(function(user) {
                return user.user_id !== userid;
            });
            state.blockedUsers.data = newUserList;
        }
    }).addCase(effects.getNotifications.pending, function(state) {
        state.notifications.isLoading = true;
        state.notifications.error = null;
    }).addCase(effects.getNotifications.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, message = _payload.message, data = _payload.data;
        if (error) {
            state.notifications.error = error;
        } else {
            state.notifications.data = data;
        }
        state.notifications.message = message;
        state.notifications.isLoading = false;
    }).addCase(effects.getNotifications.rejected, function(state, action) {
        state.notifications.error = action.payload.error;
        state.notifications.isLoading = false;
    }).addCase(effects.updateNotification.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, dataUpdated = _payload.dataUpdated;
        if (error) {
            state.notifications.error = error;
        } else {
            state.notifications.data = dataUpdated;
        }
    }).addCase(effects.changeAvatar.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error;
        if (!error) {
            state.changeAvatar.avatar = data;
        }
    }).addCase(effects.getTradingAccounts.pending, function(state) {
        state.tradingAccounts.isLoading = true;
        state.tradingAccounts.error = null;
    }).addCase(effects.getTradingAccounts.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.tradingAccounts.error = error;
        } else {
            state.tradingAccounts.data = data;
        }
        state.tradingAccounts.message = message;
        state.tradingAccounts.isLoading = false;
    }).addCase(effects.getTradingAccounts.rejected, function(state, action) {
        state.tradingAccounts.error = action.payload.error;
        state.tradingAccounts.isLoading = false;
    }).addCase(effects.unlinkTradingAccount.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, brokerKey = _payload.brokerKey;
        if (!error) {
            var ref, ref1;
            // @ts-ignore
            var brokerList = ((ref = state.tradingAccounts.data) === null || ref === void 0 ? void 0 : (ref1 = ref.brokers) === null || ref1 === void 0 ? void 0 : ref1.list) || [];
            var brokerIdx = brokerList.findIndex(function(broker) {
                return broker.key === brokerKey;
            });
            if (brokerIdx > -1) {
                // @ts-ignore
                state.tradingAccounts.data.brokers.list[brokerIdx].link = null;
            }
        }
    }).addCase(effects.getAvatar3DList.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.avatar3DList.error = error;
        } else {
            state.avatar3DList.data = data;
        }
        state.avatar3DList.message = message;
        state.avatar3DList.isLoading = false;
    }).addCase(effects.getInvitationSetting.pending, function(state) {
        state.invitationSetting.isLoading = true;
        state.invitationSetting.error = null;
    }).addCase(effects.getInvitationSetting.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.invitationSetting.error = error;
        } else {
            state.invitationSetting.data = data;
        }
        state.invitationSetting.message = message;
        state.invitationSetting.isLoading = false;
    }).addCase(effects.getInvitationSetting.rejected, function(state, action) {
        state.invitationSetting.isLoading = false;
        state.invitationSetting.error = action.payload.error;
    }).addCase(effects.updateInvitationSetting.pending, function(state) {
        state.invitationSetting.isLoading = true;
        state.invitationSetting.error = null;
    }).addCase(effects.updateInvitationSetting.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (error) {
            state.invitationSetting.error = error;
        } else {
            state.invitationSetting.data = data;
        }
        state.invitationSetting.message = message;
        state.invitationSetting.isLoading = false;
    }).addCase(effects.updateInvitationSetting.rejected, function(state, action) {
        state.invitationSetting.isLoading = false;
        state.invitationSetting.error = action.payload.error;
    }).addCase(effects.getBlacklistStatus.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (!error) {
            state.blacklistStatus.status = data.status;
        }
        state.blacklistStatus.message = message;
    }).addCase(effects.updateBlacklistStatus.fulfilled, function(state, action) {
        var _payload = action.payload, error = _payload.error, data = _payload.data, message = _payload.message;
        if (!error) {
            state.blacklistStatus.status = data.status;
        }
        state.blacklistStatus.message = message;
    });
};
var editProfileSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSlice */ .oM)({
    name: "editProfile",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (editProfileSlice);


/***/ }),

/***/ 86033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ DISCOVER_PEOPLE_STATE; }
/* harmony export */ });
// this state name follows the naming in the './slice' `initialState`
var DISCOVER_PEOPLE_STATE = {
    SUGGEST: "getSuggestFriends",
    SEARCH: "getSearchPeople"
};
// eslint-disable-next-line import/prefer-default-export



/***/ }),

/***/ 36203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_friends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63699);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44590);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86033);



// APIs



// Models

// initial state
var initialState = {
    getSuggestFriends: {
        data: [],
        isLoading: true,
        error: null,
        message: ""
    },
    followUser: {
        data: {},
        isLoading: true,
        error: null,
        message: ""
    },
    getSearchPeople: {
        data: {
            company: [],
            sector: [],
            insider: [],
            chat: [],
            user_more: 0,
            company_more: 0,
            people: []
        },
        isLoading: true,
        error: null,
        message: ""
    }
};
// selectors
var discoverPeopleState = function(state) {
    return state.onboarding.discoverPeople;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(discoverPeopleState, function(discoverPeopleState) {
    return {
        getSuggestFriends: discoverPeopleState.getSuggestFriends,
        postFollowUser: discoverPeopleState.followUser,
        getSearchPeople: discoverPeopleState.getSearchPeople
    };
}, function(state) {
    return state;
});
// action types
var CONTEXT = "@onboarding/discoverPeople";
var actionType = {
    GET_SUGGEST_FRIENDS: "".concat(CONTEXT, "/GET_SUGGEST_FRIENDS"),
    FOLLOW_USER: "".concat(CONTEXT, "/FOLLOW_USER"),
    GET_SEARCH_PEOPLE: "".concat(CONTEXT, "/GET_SEARCH_PEOPLE")
};
// side effects
var effects = {
    // getSuggestFriends -------------------------------------------------------------------
    getSuggestFriends: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SUGGEST_FRIENDS, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_friends__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSuggestFriends */ .Z.getSuggestFriends(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 9;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 9:
                        throw new Error("Attempt to get friends suggest Failed");
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postFollowUser -------------------------------------------------------------------
    toggleFollowUser: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.FOLLOW_USER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var index, userid, stateKey, _type, type, targetAPI, response, _data, data, message, _$error, dataUserChanged;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        index = param.index, userid = param.userid, stateKey = param.stateKey, _type = param.type, type = _type === void 0 ? "FOLLOW" : _type;
                        _ctx.prev = 1;
                        if (userid) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("userid is required");
                    case 4:
                        targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postFollowUser */ .Z.postFollowUser;
                        if (type === "UNFOLLOW") {
                            targetAPI = lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postUnfollowUser */ .Z.postUnfollowUser;
                        }
                        _ctx.next = 8;
                        return targetAPI(userid);
                    case 8:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (response.data) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error("Cannot perform request");
                    case 12:
                        dataUserChanged = {
                            userid: userid,
                            followed: type
                        };
                        return _ctx.abrupt("return", {
                            data: data,
                            error: _$error,
                            message: message,
                            index: index,
                            stateKey: stateKey,
                            dataUserChanged: dataUserChanged
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // getSearchPeople -------------------------------------------------------------------
    getSearchPeople: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_PEOPLE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var keyword, page, response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = param.keyword, page = param.page;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSearchPeople */ .Z.getSearchPeople(keyword, page);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        throw new Error("Attempt to search friends Failed");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// reducers
var reducers = {
    clearSearch: function(state) {
        state.getSearchPeople.data = {
            company: [],
            sector: [],
            insider: [],
            chat: [],
            user_more: 0,
            company_more: 0,
            people: []
        };
    }
};
// extra reducers
var extraReducers = function(builder) {
    builder.addCase(effects.getSuggestFriends.pending, function(state) {
        state.getSuggestFriends.isLoading = true;
    }).addCase(effects.getSuggestFriends.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.getSuggestFriends.error = error;
        } else {
            state.getSuggestFriends.data = data;
        }
        state.getSuggestFriends.message = message;
        state.getSuggestFriends.isLoading = false;
    }).addCase(effects.getSuggestFriends.rejected, function(state, action) {
        state.getSuggestFriends.error = action.payload.error;
        state.getSuggestFriends.isLoading = false;
    }).addCase(effects.toggleFollowUser.pending, function(state) {
        state.followUser.isLoading = true;
    }).addCase(effects.toggleFollowUser.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error, index = _payload.index, stateKey = _payload.stateKey, dataUserChanged = _payload.dataUserChanged;
        if (error) {
            state.followUser.error = error;
        } else {
            var isFollowed = dataUserChanged.followed === "FOLLOW";
            var selectedState = state[stateKey].data;
            if (stateKey === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DISCOVER_PEOPLE_STATE.SUGGEST */ .v.SUGGEST) {
                selectedState[index].user.follow = isFollowed;
            } else if (stateKey === _constants__WEBPACK_IMPORTED_MODULE_4__/* .DISCOVER_PEOPLE_STATE.SEARCH */ .v.SEARCH) {
                selectedState.people[index].is_following = isFollowed;
            }
            state.followUser.data = data;
        }
        state.followUser.message = message;
        state.followUser.isLoading = false;
    }).addCase(effects.toggleFollowUser.rejected, function(state, action) {
        state.followUser.error = action.payload.error;
        state.followUser.isLoading = false;
    }).addCase(effects.getSearchPeople.pending, function(state) {
        state.getSearchPeople.isLoading = true;
    }).addCase(effects.getSearchPeople.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.getSearchPeople.error = error;
        } else {
            state.getSearchPeople.data = data;
        }
        state.getSearchPeople.message = message;
        state.getSearchPeople.isLoading = false;
    }).addCase(effects.getSearchPeople.rejected, function(state, action) {
        state.getSearchPeople.error = action.payload.error;
        state.getSearchPeople.isLoading = false;
    });
};
// Create the slice
var discoverPeopleSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "discoverPeople",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (discoverPeopleSlice);


/***/ }),

/***/ 9073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var lib_entities_company__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74645);




// API

// Company reducer

// Initial State
var initialState = {
    suggestions: {
        data: [],
        isLoading: false,
        error: null,
        message: ""
    }
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(function(state) {
    return {
        suggestions: state.onboarding.discoverStock.suggestions
    };
}, function(state) {
    return state;
});
// Action Types
var CONTEXT = "@onboarding/discoverStock";
var actionType = {
    FETCH_SUGGESTION: "".concat(CONTEXT, "/FETCH_SUGGESTION")
};
// Effects
var effects = {
    getSuggestionCompany: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.FETCH_SUGGESTION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(watchlistId) {
            var response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getCompanySuggestions */ .Z.getCompanySuggestions(watchlistId);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 9;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 9:
                        throw new Error("Attempt to fetch Suggestion company Failed");
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(watchlistId) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var _obj;
// Extra reducers
var extraReducers = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, effects.getSuggestionCompany.pending, function(state) {
    state.suggestions.isLoading = true;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, effects.getSuggestionCompany.fulfilled, function(state, action) {
    var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
    if (error) {
        state.suggestions.error = error;
    } else {
        state.suggestions.data = data;
    }
    state.suggestions.isLoading = false;
    state.suggestions.message = message;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, effects.getSuggestionCompany.rejected, function(state, action) {
    state.suggestions.error = action.payload.error;
    state.suggestions.isLoading = false;
}), // TODO: Listen only if given parameter to update
// success follow company
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .effects.postFollowCompany.fulfilled */ .Sz.postFollowCompany.fulfilled, function(state, action) {
    // find index of company by id
    // update followed value to `1`
    var STATUS_FOLLOWING = 1;
    var _payload = action.payload, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
    if (data && stateToUpdate === lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .STATE_SUGGESTION */ .IN) {
        var companyid = data.companyid;
        // const newSuggestions = state.suggestions.data.map((s) => ({ ...s }));
        var newSuggestions = state.suggestions.data;
        var companyIndex = newSuggestions.findIndex(function(param) {
            var id = param.id;
            return Number(id) === Number(companyid);
        });
        // there's company in suggestion list
        if (companyIndex > -1) {
            // update `companyData` following status to `1` alias followed
            state.suggestions.data[companyIndex].followed = STATUS_FOLLOWING;
        }
    }
}), // success unfollow company
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_obj, lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .effects.postUnfollowCompany.fulfilled */ .Sz.postUnfollowCompany.fulfilled, function(state, action) {
    // find index of company by id
    // update followed value to 0
    var STATUS_UNFOLLOWING = 0;
    var _payload = action.payload, data = _payload.data, stateToUpdate = _payload.stateToUpdate;
    if (data && stateToUpdate === lib_entities_company__WEBPACK_IMPORTED_MODULE_2__/* .STATE_SUGGESTION */ .IN) {
        var companyid = data.companyid;
        // const newSuggestions = state.suggestions.data.map((s) => ({ ...s }));
        var newSuggestions = state.suggestions.data;
        var companyIndex = newSuggestions.findIndex(function(param) {
            var id = param.id;
            return Number(id) === Number(companyid);
        });
        // there's company in suggestion list
        if (companyIndex > -1) {
            // update `companyData` following status to `0` alias unfollowed
            state.suggestions.data[companyIndex].followed = STATUS_UNFOLLOWING;
        }
    }
}), _obj);
var discoverStockSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "discoverStock",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (discoverStockSlice);


/***/ }),

/***/ 12229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61876);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1955);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);



// APIs

// alert error message

// constant

// Initial state
var initialState = {
    uploadImage: {
        isLoading: false,
        error: null
    },
    uploadToken: {
        data: {
            bucketUrl: "",
            key: "",
            xAmzCredential: "",
            xAmzAlgorithm: "",
            xAmzDate: "",
            xAmzSecurityToken: "",
            policy: "",
            xAmzSignature: ""
        },
        isLoading: false,
        error: null,
        message: ""
    }
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(function(state) {
    return {
        uploadImageAvatar: state.onboarding.uploadImageAvatar.uploadImage,
        uploadToken: state.onboarding.uploadImageAvatar.uploadToken
    };
}, function(state) {
    return state;
});
// Action types
var CONTEXT = "@onboarding/uploadImageAvatar";
var actionType = {
    UPLOAD_IMAGE_AVATAR: "".concat(CONTEXT, "/UPLOAD_IMAGE_AVATAR"),
    RETRIEVE_UPLOAD_TOKEN: "".concat(CONTEXT, "/RETRIEVE_UPLOAD_TOKEN")
};
var effects = {
    retrieveUploadToken: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.RETRIEVE_UPLOAD_TOKEN, function() {
        var _ref = // @ts-ignore
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(fileName) {
            var response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"].retrieveUploadToken */ .Z.retrieveUploadToken(fileName);
                    case 3:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].UPLOAD_FAILED */ .Z.UPLOAD_FAILED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 10:
                        _ctx.next = 15;
                        break;
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(fileName) {
            return _ref.apply(this, arguments);
        };
    }()),
    // uploadImageAvatar -------------------------------------------------------------------
    uploadImageAvatar: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createAsyncThunk */ .hg)(actionType.UPLOAD_IMAGE_AVATAR, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dataFile, param) {
            var dispatch, getState, state, file, fd, formerFile, _data, key, xAmzCredential, xAmzAlgorithm, xAmzDate, xAmzSecurityToken, policy, xAmzSignature;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch = param.dispatch, getState = param.getState;
                        state = getState();
                        file = dataFile.file;
                        _ctx.prev = 3;
                        fd = new FormData();
                        formerFile = null;
                        /* eslint no-underscore-dangle: 0 */ if (file._file) formerFile = file._file;
                        _data = state.onboarding.uploadImageAvatar.uploadToken.data, key = _data.key, xAmzCredential = _data.xAmzCredential, xAmzAlgorithm = _data.xAmzAlgorithm, xAmzDate = _data.xAmzDate, xAmzSecurityToken = _data.xAmzSecurityToken, policy = _data.policy, xAmzSignature = _data.xAmzSignature;
                        fd.append("key", key);
                        fd.append("content-type", "image/jpeg");
                        fd.append("x-amz-credential", xAmzCredential);
                        fd.append("x-amz-algorithm", xAmzAlgorithm);
                        fd.append("x-amz-date", xAmzDate);
                        fd.append("x-amz-security-token", xAmzSecurityToken);
                        fd.append("policy", policy);
                        fd.append("x-amz-signature", xAmzSignature);
                        if (!formerFile) {
                            fd.append("file", file);
                        } else {
                            fd.append("file", formerFile);
                        }
                        return _ctx.abrupt("return", fetch(state.onboarding.uploadImageAvatar.uploadToken.data.bucketUrl, {
                            method: "POST",
                            cache: "default",
                            body: fd,
                            mode: "cors"
                        }).then(function(response) {
                            if (response.status === 204) {
                                return {
                                    message: "ok"
                                };
                            }
                            (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].UPLOAD_FAILED */ .Z.UPLOAD_FAILED, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
                            throw new Error("error while trying to upload image");
                        }));
                    case 20:
                        _ctx.prev = 20;
                        _ctx.t0 = _ctx["catch"](3);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 23:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    20
                ]
            ]);
        }));
        return function(dataFile, _) {
            return _ref.apply(this, arguments);
        };
    }())
};
// reducers
var reducers = {};
var extraReducers = function(builder) {
    builder.addCase(effects.retrieveUploadToken.pending, function(state, action) {
        state.uploadToken.isLoading = true;
    }).addCase(effects.retrieveUploadToken.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        var url = data.url, fields = data.fields;
        if (error) {
            state.uploadToken.error = error;
        } else {
            state.uploadToken.data.bucketUrl = url;
            state.uploadToken.data.key = fields[0].value;
            state.uploadToken.data.xAmzCredential = fields[2].value;
            state.uploadToken.data.xAmzAlgorithm = fields[3].value;
            state.uploadToken.data.xAmzDate = fields[4].value;
            state.uploadToken.data.xAmzSecurityToken = fields[5].value;
            state.uploadToken.data.policy = fields[6].value;
            state.uploadToken.data.xAmzSignature = fields[7].value;
        }
        state.uploadToken.message = message;
        state.uploadToken.isLoading = false;
    }).addCase(effects.retrieveUploadToken.rejected, function(state, action) {
        state.uploadToken.error = action.payload.error;
        state.uploadToken.isLoading = false;
    }).addCase(effects.uploadImageAvatar.pending, function(state, action) {
        state.uploadImage.isLoading = true;
    }).addCase(effects.uploadImageAvatar.fulfilled, function(state, action) {
        var error = action.payload.error;
        if (error) {
            state.uploadImage.error = error;
        }
        state.uploadImage.isLoading = false;
    }).addCase(effects.uploadImageAvatar.rejected, function(state, action) {
        state.uploadImage.error = action.payload.error;
        state.uploadImage.isLoading = false;
    });
};
// Create slice
var uploadAvatarSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSlice */ .oM)({
    name: "uploadImageAvatar",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (uploadAvatarSlice);


/***/ }),

/***/ 30690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Es": function() { return /* binding */ OA_REGISTER_STATUS; },
/* harmony export */   "Gj": function() { return /* binding */ SUBSCRIPTION_ALIAS; },
/* harmony export */   "f2": function() { return /* binding */ SUBSCRIPTION_PACKAGE; },
/* harmony export */   "z": function() { return /* binding */ PAYMENT_OPTION; }
/* harmony export */ });
/* unused harmony export PAYMENT_METHOD */
var PAYMENT_METHOD;
(function(PAYMENT_METHOD) {
    PAYMENT_METHOD["PAYMENT_METHOD_GOPAY"] = "PAYMENT_METHOD_GOPAY";
    PAYMENT_METHOD["PAYMENT_METHOD_BCA_VA"] = "PAYMENT_METHOD_BCA_VA";
    PAYMENT_METHOD["PAYMENT_METHOD_CREDIT_CARD"] = "PAYMENT_METHOD_CREDIT_CARD";
    PAYMENT_METHOD["PAYMENT_METHOD_BANK_TRANSFER"] = "PAYMENT_METHOD_BANK_TRANSFER";
    PAYMENT_METHOD["PAYMENT_METHOD_CIMB_CLICKS"] = "PAYMENT_METHOD_CIMB_CLICKS";
    PAYMENT_METHOD["PAYMENT_METHOD_BRI_EPAY"] = "PAYMENT_METHOD_BRI_EPAY";
    PAYMENT_METHOD["PAYMENT_METHOD_MIDTRANS"] = "PAYMENT_METHOD_MIDTRANS";
})(PAYMENT_METHOD || (PAYMENT_METHOD = {}));
var PAYMENT_OPTION = [
    {
        id: 0,
        name: "Gopay",
        code: PAYMENT_METHOD.PAYMENT_METHOD_GOPAY,
        description: "gopay",
        icon: "gopay_round"
    },
    {
        id: 1,
        name: "BCA Virtual Account",
        code: PAYMENT_METHOD.PAYMENT_METHOD_BCA_VA,
        description: "bca_va",
        icon: "bca_va"
    },
    {
        id: 2,
        name: "Credit Card / Transfer ATM / Mandiri Clickpay",
        code: PAYMENT_METHOD.PAYMENT_METHOD_MIDTRANS,
        description: "veritrans",
        icon: "veritrans"
    }, 
];
var SUBSCRIPTION_ALIAS = {
    SUBSCRIPTION_ONE_YEAR: "1 Tahun Berlangganan",
    SUBSCRIPTION_SIX_MONTHS: "6 Bulan Berlangganan",
    SUBSCRIPTION_ONE_MONTH: "1 Bulan Berlangganan",
    SUBSCRIPTION_ONE_DAY: "1 Hari Berlangganan"
};
var SUBSCRIPTION_PACKAGE = {
    SUBSCRIPTION_ONE_YEAR: "1 Tahun Stockbit Pro",
    SUBSCRIPTION_SIX_MONTHS: "6 Bulan Stockbit Pro",
    SUBSCRIPTION_ONE_MONTH: "1 Bulan Stockbit Pro",
    SUBSCRIPTION_ONE_DAY: "1 Hari Stockbit Pro"
};
var OA_REGISTER_STATUS;
(function(OA_REGISTER_STATUS) {
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["HAS_NOT_STARTED"] = 0] = "HAS_NOT_STARTED";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["INCOMPLETE"] = 1] = "INCOMPLETE";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["CS_PROGRESS"] = 2] = "CS_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["KSEI_PROGRESS"] = 3] = "KSEI_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["RDN_PROGRESS"] = 4] = "RDN_PROGRESS";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["SUBMIT_REGISTRATION"] = 5] = "SUBMIT_REGISTRATION";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["DOCUMENT_VERIFICATION"] = 88] = "DOCUMENT_VERIFICATION";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["REJECTED"] = 99] = "REJECTED";
    OA_REGISTER_STATUS[OA_REGISTER_STATUS["OTHERS"] = -1] = "OTHERS";
})(OA_REGISTER_STATUS || (OA_REGISTER_STATUS = {}));


/***/ }),

/***/ 31366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XP": function() { return /* binding */ translatePackageOption; },
/* harmony export */   "fX": function() { return /* binding */ checkIsWaitingAccount; },
/* harmony export */   "gs": function() { return /* binding */ createMonthlyStatements; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30690);



var createMonthlyStatements = function(orders) {
    var dict = {};
    orders.forEach(function(order) {
        var month = moment__WEBPACK_IMPORTED_MODULE_0___default()(order.date).format("MMMM YYYY");
        if (Array.isArray(dict[month])) {
            dict[month].push(order);
        } else {
            dict[month] = [
                order
            ];
        }
    });
    return dict;
};
var translatePackageOption = function() {
    var packageItem = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", dateOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(packageItem === null || packageItem === void 0 ? void 0 : packageItem.split(" "), 2), tmp = ref[0], packageDuration = tmp === void 0 ? "" : tmp, tmp1 = ref[1], packageType = tmp1 === void 0 ? "" : tmp1;
    switch(packageType.toLowerCase()){
        case "month":
            {
                if (Number(packageDuration) >= 12) {
                    return "1 Tahun ".concat(dateOnly && "Stockbit Pro");
                }
                return "".concat(packageDuration, " Bulan ").concat(dateOnly ? "Stockbit Pro" : "");
            }
        case "day":
            {
                return "".concat(packageDuration, " Hari ").concat(dateOnly ? "Stockbit Pro" : "");
            }
        default:
            {
                return "".concat(packageDuration, " Tahun ").concat(dateOnly ? "Stockbit Pro" : "");
            }
    }
};
var checkIsWaitingAccount = function(status) {
    var waitingStatuses = [
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.CS_PROGRESS */ .Es.CS_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.KSEI_PROGRESS */ .Es.KSEI_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.RDN_PROGRESS */ .Es.RDN_PROGRESS,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.SUBMIT_REGISTRATION */ .Es.SUBMIT_REGISTRATION,
        _constants__WEBPACK_IMPORTED_MODULE_1__/* .OA_REGISTER_STATUS.DOCUMENT_VERIFICATION */ .Es.DOCUMENT_VERIFICATION, 
    ];
    return waitingStatuses.includes(status);
};


/***/ }),

/***/ 83100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14671);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38597);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(331);








var initialState = {
    tab: "order",
    isFilterActive: false,
    orderSearchValue: {
        action: "",
        stock: "",
        text: ""
    },
    orderSearchOptions: [],
    orderFilterValue: {
        status: [],
        orderType: [],
        expiry: [],
        accountType: []
    },
    orderSearchFilterResult: []
};
var orderTableStore = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)()((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .devtools */ .mW)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_3__/* .persist */ .tJ)(function(set, get) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        setOrderTab: function(tab) {
            set({
                tab: tab
            });
        },
        setOrderSearchValue: function(orderSearchValue) {
            if (orderSearchValue === null) {
                set({
                    orderSearchValue: initialState.orderSearchValue
                });
                return;
            }
            set({
                orderSearchValue: orderSearchValue
            });
        },
        setOrderSearchOptions: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(stock) {
                var ref, data;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(stock === null)) {
                                _ctx.next = 3;
                                break;
                            }
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                            return _ctx.abrupt("return");
                        case 3:
                            _ctx.prev = 3;
                            ;
                            _ctx.next = 7;
                            return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearchEmiten */ .Z.getSearchEmiten(stock);
                        case 7:
                            data = _ctx.sent.data;
                            if (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.company) {
                                set({
                                    orderSearchOptions: data.data.company.map(function(d) {
                                        return {
                                            name: d === null || d === void 0 ? void 0 : d.name,
                                            desc: d === null || d === void 0 ? void 0 : d.desc
                                        };
                                    })
                                });
                            }
                            _ctx.next = 14;
                            break;
                        case 11:
                            _ctx.prev = 11;
                            _ctx.t0 = _ctx["catch"](3);
                            set({
                                orderSearchOptions: initialState.orderSearchOptions
                            });
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        11
                    ]
                ]);
            }));
            return function(stock) {
                return _ref.apply(this, arguments);
            };
        }(),
        setOrderFilterValue: function(orderFilterValue) {
            if (orderFilterValue === null) {
                set({
                    orderFilterValue: initialState.orderFilterValue
                });
                return;
            }
            set({
                orderFilterValue: orderFilterValue
            });
        },
        searchAndFilter: function(source) {
            if (source === null) {
                set({
                    orderSearchFilterResult: source
                });
                return;
            }
            var ref = get(), orderSearchValue = ref.orderSearchValue, orderFilterValue = ref.orderFilterValue;
            var searchResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .search */ .yC)(source, orderSearchValue);
            var searchFilterResult = (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .filter */ .hX)(searchResult, orderFilterValue);
            set({
                orderSearchFilterResult: searchFilterResult,
                isFilterActive: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .checkFilterAvailability */ .XI)(orderFilterValue)
            });
        },
        resetOrderTableStore: function() {
            set(initialState);
        }
    });
}, {
    name: "zustandOrderTableStore",
    getStorage: function() {
        return localStorage;
    },
    partialize: function(state) {
        return {
            isFilterActive: state.isFilterActive,
            orderSearchValue: state.orderSearchValue,
            orderFilterValue: state.orderFilterValue
        };
    }
})));
/* harmony default export */ __webpack_exports__["Z"] = (orderTableStore);


/***/ }),

/***/ 331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E2": function() { return /* binding */ splitSearch; },
/* harmony export */   "XI": function() { return /* binding */ checkFilterAvailability; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "yC": function() { return /* binding */ search; }
/* harmony export */ });
var pipe = function() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++){
        fns[_key] = arguments[_key];
    }
    return function(x) {
        return fns.reduce(function(v, f) {
            return f(v);
        }, x);
    };
};
var splitSearch = function() {
    var search = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedStock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var arrSearch = search.split(" ");
    if (arrSearch.length === 1) {
        return {
            action: selectedStock || arrSearch[0],
            stock: selectedStock || arrSearch[0],
            text: selectedStock || arrSearch[0]
        };
    }
    if (arrSearch.length > 1) {
        return {
            action: arrSearch[0],
            stock: selectedStock || arrSearch[1],
            text: [
                arrSearch[0],
                selectedStock || arrSearch[1]
            ].join(" ")
        };
    }
    return {
        action: "",
        stock: "",
        text: ""
    };
};
var search = function(source, searchValue) {
    if (!searchValue) {
        return source;
    }
    var action = searchValue.action, stock = searchValue.stock;
    if (action !== "" && action === stock) {
        return source.filter(function(e) {
            return e.action.startsWith(action.toLocaleUpperCase()) || e.symbol.startsWith(action.toLocaleUpperCase());
        });
    }
    if (action !== "" && stock !== "") {
        return source.filter(function(e) {
            return action.toLocaleUpperCase() === e.action && e.symbol.startsWith(stock.toLocaleUpperCase());
        });
    }
    return source;
};
var filter = function(source, filterValue) {
    if (!filterValue) {
        return source;
    }
    var status = filterValue.status, orderType = filterValue.orderType, expiry = filterValue.expiry, _accountType = filterValue.accountType, accountType = _accountType === void 0 ? [] : _accountType;
    var filterFn = function(valueToCheck) {
        var filterValueItem = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
        if ((filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.length) === 0) {
            return true;
        }
        return filterValueItem === null || filterValueItem === void 0 ? void 0 : filterValueItem.includes(valueToCheck);
    };
    var filterStatus = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.status) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase(), status);
        });
    };
    var filterOrderType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.label) === null || ref === void 0 ? void 0 : ref.toUpperCase(), orderType);
        });
    };
    var filterExpiry = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.gtc) === null || ref === void 0 ? void 0 : ref.toString(), expiry);
        });
    };
    var filterAccountType = function(s) {
        return s.filter(function(i) {
            var ref;
            return filterFn((ref = i.day_trade_is_day_trade) === null || ref === void 0 ? void 0 : ref.toString(), accountType);
        });
    };
    return pipe(filterStatus, filterOrderType, filterExpiry, filterAccountType)(source);
};
var checkFilterAvailability = function(filterValue) {
    var filterArr = Object.keys(filterValue).map(function(k) {
        var ref;
        return (ref = filterValue[k]) === null || ref === void 0 ? void 0 : ref.length;
    });
    return filterArr.some(function(i) {
        return i > 0;
    });
};



/***/ }),

/***/ 66620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useLivePriceStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var livePriceState = {
    symbols: {}
};
var livePriceActions = function(set) {
    return {
        setLivePriceSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useLivePriceStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, livePriceState, livePriceActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 23782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useOrderbookStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);



var orderbookState = {
    symbols: {}
};
var orderbookActions = function(set) {
    return {
        setOrderbookSymbols: function(key, symbols) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.symbols[key] = symbols.filter(function(v, i, a) {
                        return a.indexOf(v) === i;
                    });
                });
            });
        }
    };
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, orderbookState, orderbookActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 87637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ DatafeedContext; },
  "l": function() { return /* binding */ DatafeedProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/lib/api/ws.ts
var ws = __webpack_require__(66679);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/@stockbitgroup/protos/securities/transactional/datafeed/v1/websocket_pb.js + 13 modules
var websocket_pb = __webpack_require__(83077);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/global/Datafeed/store/index.ts



var datafeedState = {
    channel: {},
    error: undefined
};
var datafeedActions = function(set) {
    return {
        setChannel: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.channel = (0,_object_spread/* default */.Z)({}, draft.channel, value);
                });
            });
        },
        setError: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.error = value;
                });
            });
        }
    };
};
var useDatafeedStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, datafeedState, datafeedActions(set, get, store, storeMutation));
});

// EXTERNAL MODULE: ./src/global/Datafeed/UseLivePrice/liveprice.store.ts
var liveprice_store = __webpack_require__(66620);
// EXTERNAL MODULE: ./src/global/Datafeed/UseOrderbook/orderbook.store.ts
var orderbook_store = __webpack_require__(23782);
;// CONCATENATED MODULE: ./src/global/Datafeed/index.tsx

















var DatafeedContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var MAX_RECONNECT_COUNTER = 5;
var routesBlacklist = [
    "/logout"
];
var DatafeedProvider = function(param) {
    var _heartbeatDuration = param.heartbeatDuration, heartbeatDuration = _heartbeatDuration === void 0 ? 10000 : _heartbeatDuration, isLoggedIn = param.isLoggedIn, children = param.children;
    var router = (0,next_router.useRouter)();
    var socket = (0,react.useRef)();
    var actionsRef = (0,react.useRef)({});
    var reconnectCounter = (0,react.useRef)(1);
    var isLoggedInRef = (0,react.useRef)(false);
    var authRetries = (0,react.useRef)(0);
    var ref = (0,react.useState)(), authToken = ref[0], setAuthToken = ref[1];
    var ref1 = (0,react.useState)(false), isSocketConnected = ref1[0], setConnectionStatus = ref1[1];
    var isBlacklisted = (0,react.useMemo)(function() {
        return routesBlacklist.includes(router.pathname);
    }, [
        router.pathname
    ]);
    var ref2 = useDatafeedStore(function(state) {
        return {
            setChannel: state.setChannel,
            setError: state.setError,
            error: state.error,
            channel: state.channel
        };
    }), setChannel = ref2.setChannel, setError = ref2.setError, error = ref2.error, channel = ref2.channel;
    var livePriceStoreSymbols = (0,liveprice_store/* useLivePriceStore */.H)(function(s) {
        return s.symbols;
    });
    var orderbookStoreSymbols = (0,orderbook_store/* useOrderbookStore */.a)(function(s) {
        return s.symbols;
    });
    var initSocket = function() {
        setAuthToken(undefined);
        socket.current = new WebSocket("wss://wss-trading.stockbit.com/ws");
        socket.current.binaryType = "arraybuffer";
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("open", handleAuth, {
            once: true
        });
        // eslint-disable-next-line no-use-before-define
        socket.current.addEventListener("close", handleReconnection, {
            once: true
        });
        window.datafeedSocket = socket.current;
    };
    var resetSocket = function() {
        socket.current.close();
        socket.current = undefined;
        window.datafeedSocket = undefined;
        setAuthToken(undefined);
    };
    var sendMessageChannel = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(authToken, messageChannel) {
            var ref, ref1, userId, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current && ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        console.warn("Failed to send Channel, Socket not ready");
                        return _ctx.abrupt("return");
                    case 4:
                        ref1 = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref1.id;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            channel: messageChannel,
                            key: authToken,
                            userId: userId
                        }).toBinary();
                        socket.current.send(buffer);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(authToken, messageChannel) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var sendPingHeartbeat = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(!socket.current && ((ref = socket.current) === null || ref === void 0 ? void 0 : ref.readyState) !== WebSocket.OPEN)) {
                            _ctx.next = 4;
                            break;
                        }
                        console.warn("Failed to send Ping, Socket not ready");
                        return _ctx.abrupt("return");
                    case 4:
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            ping: {
                                message: "ping"
                            }
                        }).toBinary();
                        socket.current.send(buffer);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function sendPingHeartbeat() {
            return _ref.apply(this, arguments);
        };
    }();
    var combinedChannel = (0,react.useMemo)(function() {
        var flattenedLivePriceStoreSymbols = Object.values(livePriceStoreSymbols).flat();
        var flattenedOrderbookStoreSymbols = Object.values(orderbookStoreSymbols).flat();
        var _liveprice, _orderBook;
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, channel), {
            liveprice: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_liveprice = channel.liveprice) !== null && _liveprice !== void 0 ? _liveprice : []).concat((0,_to_consumable_array/* default */.Z)(flattenedLivePriceStoreSymbols)))),
            orderBook: Array.from(new Set((0,_to_consumable_array/* default */.Z)((_orderBook = channel.orderBook) !== null && _orderBook !== void 0 ? _orderBook : []).concat((0,_to_consumable_array/* default */.Z)(flattenedOrderbookStoreSymbols))))
        });
    }, [
        channel,
        livePriceStoreSymbols,
        orderbookStoreSymbols
    ]);
    var handleSendChannel = (0,react.useCallback)(lodash_debounce_default()(sendMessageChannel, 100), []);
    var setAction = function(channelKey, actionKey, callbackFn) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            if (!draft[channelKey]) draft[channelKey] = {};
            draft[channelKey][actionKey] = callbackFn;
        });
    };
    var removeAction = function(channelKey, actionKey) {
        actionsRef.current = (0,immer_esm/* default */.ZP)(actionsRef.current, function(draft) {
            var ref;
            if (draft === null || draft === void 0 ? void 0 : (ref = draft[channelKey]) === null || ref === void 0 ? void 0 : ref[actionKey]) delete draft[channelKey][actionKey];
        });
    };
    var handleUnauthorized = function(message) {
        if (authRetries.current > 3) {
            setError(message.error);
            return;
        }
        authRetries.current += 1;
        setAuthToken(undefined);
        // eslint-disable-next-line no-use-before-define
        handleAuth();
    };
    var handleErrorMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        // Consider moving the error handling code to a separate 'utils' module
                        // if the amount of error handling logic is increasing
                        if ((message === null || message === void 0 ? void 0 : (ref = message.error) === null || ref === void 0 ? void 0 : ref.code) === 401) handleUnauthorized(message);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleErrorMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleMessage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(message) {
            var dataRaw, messageChannel, messageCase, value, decodedMessage;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dataRaw = websocket_pb/* WebsocketWrapMessageChannel.fromBinary */.iU.fromBinary(new Uint8Array(message.data));
                        messageChannel = dataRaw.messageChannel;
                        messageCase = messageChannel.case, value = messageChannel.value;
                        decodedMessage = (0,_define_property/* default */.Z)({}, messageCase, value);
                        if (decodedMessage === null || decodedMessage === void 0 ? void 0 : decodedMessage.error) handleErrorMessage(decodedMessage);
                        Object.keys(decodedMessage).forEach(function(messageChannelKey) {
                            Object.values(actionsRef.current[messageChannelKey] || {}).forEach(function(callbackFn) {
                                callbackFn(decodedMessage);
                            });
                        });
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleMessage(message) {
            return _ref.apply(this, arguments);
        };
    }();
    // handleHeartbeatMessage will only called when ping message available
    // filtered on handleMessage
    var handleHeartbeatMessage = function() {
        setTimeout(function() {
            return sendPingHeartbeat();
        }, heartbeatDuration);
    };
    var handleAuth = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, userId, data, bodyData, key, buffer;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ref = auth/* default.getUserAccess */.Z.getUserAccess(), userId = ref.id;
                        _ctx.next = 3;
                        return ws/* default.getWSTradingKey */.Z.getWSTradingKey();
                    case 3:
                        data = _ctx.sent.data;
                        bodyData = data.data;
                        key = bodyData.key;
                        buffer = new websocket_pb/* WebsocketRequest */.vC({
                            key: key,
                            userId: userId
                        }).toBinary();
                        socket.current.send(buffer);
                        setAuthToken(key);
                        setAction("ping", "pingResponse", handleHeartbeatMessage);
                        sendPingHeartbeat();
                        socket.current.addEventListener("message", handleMessage);
                        setConnectionStatus(true);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleAuth() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReconnection = function() {
        if (!isLoggedInRef.current) return;
        if (reconnectCounter.current > MAX_RECONNECT_COUNTER) {
            setError({
                code: 503,
                message: "Maximum reconnection"
            });
            return;
        }
        reconnectCounter.current += 1;
        setConnectionStatus(false);
        initSocket();
    };
    (0,react.useEffect)(function() {
        if (isBlacklisted) return;
        isLoggedInRef.current = isLoggedIn;
        if (!socket.current && isLoggedIn) initSocket();
        else if (socket.current && !isLoggedIn) resetSocket();
    }, [
        isLoggedIn,
        isBlacklisted
    ]);
    (0,react.useEffect)(function() {
        if (authToken) handleSendChannel(authToken, combinedChannel);
    }, [
        authToken,
        handleSendChannel,
        combinedChannel
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatafeedContext.Provider, {
        value: {
            socket: socket.current,
            isSocketConnected: isSocketConnected,
            error: error,
            setChannel: setChannel,
            setAction: setAction,
            removeAction: removeAction,
            isAuthorized: !!authToken
        },
        children: children
    });
};


/***/ }),

/***/ 59016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ slice; },
  "Sz": function() { return /* binding */ effects; },
  "wl": function() { return /* binding */ selectors; }
});

// UNUSED EXPORTS: initialState

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./src/lib/api/search.ts
var search = __webpack_require__(44590);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
;// CONCATENATED MODULE: ./src/lib/models/search/index.js

var schema = {
    company: [],
    sector: [],
    insider: [],
    chat: [],
    user_more: 0,
    company_more: 0,
    people: []
};
var propTypesPeople = (0,prop_types.shape)({
    id: prop_types.number,
    img: prop_types.string,
    followed: prop_types.number,
    official: prop_types.number,
    name: prop_types.string,
    desc: prop_types.string,
    url: prop_types.string,
    type: prop_types.string,
    other: prop_types.string,
    total_followers: prop_types.number
});
var propTypes = {
    company: (0,prop_types.arrayOf)(prop_types.object),
    sector: (0,prop_types.arrayOf)(prop_types.object),
    insider: (0,prop_types.arrayOf)(prop_types.object),
    chat: (0,prop_types.arrayOf)(prop_types.object),
    user_more: prop_types.number,
    company_more: prop_types.number,
    people: (0,prop_types.arrayOf)(propTypesPeople)
};
/* harmony default export */ var models_search = ({
    schema: schema,
    propTypes: propTypes,
    propTypesPeople: propTypesPeople
});

;// CONCATENATED MODULE: ./src/global/Header/Search/slice.ts







// Action type
var CONTEXT = "@global/search";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT"),
    POST_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/POST_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: schema,
    recent: {
        list: []
    }
};
// Selectors
var selectors = (0,es/* createSelector */.P1)(function(state) {
    return state.search;
}, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result,
        recent: state.recent
    };
});
// Effects
var effects = {
    getSearchResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(keyword) {
            var response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return search/* default.getSearch */.Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }()),
    getSearchRecentResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_SEARCH_RECENT_RESULT, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return search/* default.getSearchRecent */.Z.getSearchRecent();
                case 3:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response.data);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", _ctx.t0.message);
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }))),
    postSearchRecentResult: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.POST_SEARCH_RECENT_RESULT, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var keyword, target, type, response;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        keyword = param.keyword, target = param.target, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return search/* default.postSearchRecent */.Z.postSearchRecent(keyword, target, type);
                    case 4:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            result: action.payload.data
        });
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            error: action.payload
        });
    }).addCase(effects.getSearchRecentResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.getSearchRecentResult.fulfilled, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            recent: {
                list: action.payload.data
            }
        });
    }).addCase(effects.getSearchRecentResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false,
            error: action.payload
        });
    }).addCase(effects.postSearchRecentResult.pending, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: true
        });
    }).addCase(effects.postSearchRecentResult.fulfilled, function(state) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            isLoading: false
        });
    }).addCase(effects.postSearchRecentResult.rejected, function(state, action) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            error: action.payload
        });
    });
};
// Slice
var searchSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    name: "search",
    initialState: initialState,
    reducers: {},
    extraReducers: extraReducers
});
/* harmony default export */ var slice = (searchSlice);


/***/ }),

/***/ 13180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O$": function() { return /* binding */ accDistColor; },
/* harmony export */   "RB": function() { return /* binding */ transactionTypeList; },
/* harmony export */   "XF": function() { return /* binding */ defaultBrokerData; },
/* harmony export */   "Xt": function() { return /* binding */ defaultTransactionData; },
/* harmony export */   "ez": function() { return /* binding */ marketBoardList; },
/* harmony export */   "k$": function() { return /* binding */ TRANSACTION_TYPE; },
/* harmony export */   "lA": function() { return /* binding */ BANDAR_DETECTOR_MENU_KEY; },
/* harmony export */   "l_": function() { return /* binding */ defaultSummaryData; },
/* harmony export */   "nJ": function() { return /* binding */ brokerType; },
/* harmony export */   "x$": function() { return /* binding */ investorTypeList; }
/* harmony export */ });
/* unused harmony exports defaultTransactionListData, MARKET_BOARD, INVESTOR_TYPE */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63914);



var percentToHex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .utils.hexOpacity */ .P6.hexOpacity;
var cellBgType = {
    green: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lightGreen */ .$_.lightGreen,
    red: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.monaLisa */ .$_.monaLisa,
    lightGreen: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.lightGreen */ .$_.lightGreen + percentToHex(50),
    lightRed: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.monaLisa */ .$_.monaLisa + percentToHex(50),
    grey: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro
};
var accDistColor = {
    Neutral: cellBgType.grey,
    Dist: cellBgType.lightRed,
    "Small Dist": cellBgType.red,
    "Normal Dist": cellBgType.red,
    "Big Dist": cellBgType.red,
    Acc: cellBgType.lightGreen,
    "Small Acc": cellBgType.green,
    "Normal Acc": cellBgType.green,
    "Big Acc": cellBgType.green
};
var brokerType = {
    Lokal: "local",
    Pemerintah: "bumn",
    Asing: "foreign",
    GROUP_LOCAL: "local",
    GROUP_GOVERNMENT: "bumn",
    GROUP_FOREIGN: "foreign"
};
var defaultTransactionData = [
    {
        key: "top1",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Top 1"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    },
    {
        key: "top3",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Top 3"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    },
    {
        key: "top5",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Top 5"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    },
    {
        key: "average",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Average"
        }),
        volume: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        percent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        price: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    }, 
];
var defaultBrokerData = [
    {
        key: "broker",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            weight: "bold",
            children: "Broker"
        }),
        buyer: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        seller: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        hash: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        accDist: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            align: "center",
            children: "-"
        })
    }, 
];
var defaultSummaryData = [
    {
        key: "summary_1",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: "Net Volume"
        }),
        value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        empty: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {})
    },
    {
        key: "summary_2",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: "Net Value"
        }),
        value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        empty: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {})
    },
    {
        key: "summary_3",
        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: "Average (Rp)"
        }),
        value: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        empty: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {})
    }, 
];
var defaultTransactionListData = [
    {
        by: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        bval: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        bavg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        sl: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        sval: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        }),
        savg: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_2__.Td, {
            children: " - "
        })
    }, 
];
var BANDAR_DETECTOR_MENU_KEY = {
    BROKER_SUMMARY: "BROKER_SUMMARY",
    TOP_BROKER: "TOP_BROKER",
    BROKER_ACTIVITY: "BROKER_ACTIVITY"
};
var TRANSACTION_TYPE = {
    UNSPECIFIED: "TRANSACTION_TYPE_UNSPECIFIED",
    NET: "TRANSACTION_TYPE_NET",
    GROSS: "TRANSACTION_TYPE_GROSS"
};
var MARKET_BOARD = {
    UNSPECIFIED: "MARKET_BOARD_UNSPECIFIED",
    ALL: "MARKET_BOARD_ALL",
    REGULER: "MARKET_BOARD_REGULER",
    TUNAI: "MARKET_BOARD_TUNAI",
    NEGO: "MARKET_BOARD_NEGO"
};
var INVESTOR_TYPE = {
    UNSPECIFIED: "INVESTOR_TYPE_UNSPECIFIED",
    ALL: "INVESTOR_TYPE_ALL",
    FOREIGN: "INVESTOR_TYPE_FOREIGN",
    DOMESTIC: "INVESTOR_TYPE_DOMESTIC"
};
var transactionTypeList = [
    {
        label: "Net",
        value: TRANSACTION_TYPE.NET
    },
    {
        label: "Gross",
        value: TRANSACTION_TYPE.GROSS
    }, 
];
var marketBoardList = [
    {
        label: "All Market",
        value: MARKET_BOARD.ALL
    },
    {
        label: "Regular",
        value: MARKET_BOARD.REGULER
    },
    {
        label: "Tunai",
        value: MARKET_BOARD.TUNAI
    },
    {
        label: "Nego",
        value: MARKET_BOARD.NEGO
    }, 
];
var investorTypeList = [
    {
        label: "All Investor",
        value: INVESTOR_TYPE.ALL
    },
    {
        label: "Domestic",
        value: INVESTOR_TYPE.DOMESTIC
    },
    {
        label: "Foreign",
        value: INVESTOR_TYPE.FOREIGN
    }, 
];



/***/ }),

/***/ 46881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13180);
/* eslint-disable no-undef */ 







var defaultSummary = {
    brokers_buy: [],
    brokers_sell: [],
    symbol: ""
};
var defaultPagination = {
    page: 1,
    limit: 50,
    isScrollable: true
};
// Initial state
var initialState = {
    brokerSummary: {
        detector: {},
        summary: defaultSummary,
        from: "",
        to: ""
    },
    data: {
        detector: {},
        summary: defaultSummary,
        from: "",
        to: ""
    },
    brokerActivity: {
        summary: defaultSummary,
        from: "",
        to: "",
        activeBroker: "",
        brokerList: [],
        pagination: defaultPagination,
        transactionType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .transactionTypeList[0].value */ .RB[0].value,
        marketBoard: _constants__WEBPACK_IMPORTED_MODULE_2__/* .marketBoardList[1].value */ .ez[1].value,
        investorType: _constants__WEBPACK_IMPORTED_MODULE_2__/* .investorTypeList[0].value */ .x$[0].value
    },
    topBrokers: {
        date: "",
        data: []
    },
    isLoading: true,
    error: null,
    message: "",
    // TODO: Remove this object when permanent solution applied to the pages
    brokerSummaryForm: {
        from: "",
        to: ""
    }
};
// Selector
var bandarDetectorState = function(state) {
    return state.mainLayout.bandarDetector;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(bandarDetectorState, function(state) {
    return {
        data: state.data,
        detector: state.data.detector,
        summary: state.data.summary,
        brokerSummary: state.brokerSummary,
        brokerActivity: state.brokerActivity,
        topBrokers: state.topBrokers.data,
        topBrokerDate: state.topBrokers.date,
        isLoading: state.isLoading,
        // TODO: Remove this line when permanent solution applied to the pages
        brokerSummaryForm: state.brokerSummaryForm
    };
});
// Action types
var CONTEXT = "@side-widget/bandarDetector";
var actionType = {
    GET_BANDAR_DETECTOR: "".concat(CONTEXT, "/GET_BANDAR_DETECTOR"),
    GET_BROKER_LIST: "".concat(CONTEXT, "/GET_BROKER_LIST"),
    GET_BROKER_ACTIVITY: "".concat(CONTEXT, "/GET_BROKER_ACTIVITY"),
    GET_BROKER_ACTIVITY_NEXT_PAGE: "".concat(CONTEXT, "/GET_BROKER_ACTIVITY_NEXT_PAGE"),
    GET_TOP_BROKER: "".concat(CONTEXT, "/GET_TOP_BROKER")
};
// Side effects
var effects = {
    getBandarDetector: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BANDAR_DETECTOR, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var symbol, params, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        symbol = param.symbol, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMarketDetector */ .Z.getMarketDetector(symbol, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get market detector failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getTopBroker: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_TOP_BROKER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTopBroker */ .Z.getTopBroker(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get top broker failed!");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBrokerList: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BROKER_LIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getBrokerList */ .Z.getBrokerList(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to get broker list failed!");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBrokerActivity: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BROKER_ACTIVITY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var brokerCode, params, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        brokerCode = param.brokerCode, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMarketDetectorActivity */ .Z.getMarketDetectorActivity(brokerCode, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get broker activity failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    getBrokerActivityNextPage: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_BROKER_ACTIVITY_NEXT_PAGE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var brokerCode, params, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        brokerCode = param.brokerCode, params = param.params;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMarketDetectorActivity */ .Z.getMarketDetectorActivity(brokerCode, params);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Attempt to get broker activity failed!");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {
    setActiveBroker: function(state, action) {
        state.brokerActivity.activeBroker = action.payload;
        // reset pagination to default when active broker is changed
        if (state.brokerActivity.pagination.page !== 1) {
            state.brokerActivity.pagination = defaultPagination;
        }
    },
    setPagination: function(state) {
        var _summary = state.brokerActivity.summary, brokersBuy = _summary.brokers_buy, brokersSell = _summary.brokers_sell;
        var sizeData = Math.max(brokersBuy.length, brokersSell.length);
        var _pagination = state.brokerActivity.pagination, page = _pagination.page, isScrollable = _pagination.isScrollable;
        if (isScrollable && sizeData >= 50) {
            state.brokerActivity.pagination = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state.brokerActivity.pagination), {
                page: page + 1
            });
        }
    },
    resetPagination: function(state) {
        state.brokerActivity.pagination = defaultPagination;
    },
    // TODO: Remove this reducer when permanent solution applied to the pages
    setBrokerSummaryForm: function(state, action) {
        var _payload = action.payload, key = _payload.key, value = _payload.value;
        state.brokerSummaryForm[key] = value;
    },
    setTransactionType: function(state, action) {
        state.brokerActivity.transactionType = action.payload;
    },
    setMarketBoard: function(state, action) {
        state.brokerActivity.marketBoard = action.payload;
    },
    setInvestorType: function(state, action) {
        state.brokerActivity.investorType = action.payload;
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getBandarDetector.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getBandarDetector.fulfilled, function(state, action) {
        var _payload = action.payload, _data = _payload.data, data = _data === void 0 ? {} : _data, error = _payload.error, message = _payload.message;
        if (error) {
            state.error = error;
        }
        if (!data.bandar_detector || !data.broker_summary) {
            state.brokerSummary.detector = {};
            state.brokerSummary.summary = defaultSummary;
            state.brokerSummary.from = "";
            state.brokerSummary.to = "";
            state.error = null;
        }
        if (data.bandar_detector && data.broker_summary) {
            state.brokerSummary.detector = data.bandar_detector;
            state.brokerSummary.summary = data.broker_summary;
            state.brokerSummary.from = data.from;
            state.brokerSummary.to = data.to;
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBandarDetector.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    }).addCase(effects.getBrokerList.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) state.error = error;
        if (data) {
            state.brokerActivity.brokerList = data;
            if (!state.brokerActivity.activeBroker) {
                state.brokerActivity.activeBroker = data[0].code;
            }
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivity.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getBrokerActivity.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        var newSummary = data.broker_summary;
        if (error) {
            state.error = error;
        }
        if (!newSummary) {
            state.brokerActivity.summary = defaultSummary;
            state.brokerActivity.from = "";
            state.brokerActivity.to = "";
        } else {
            state.brokerActivity.summary = newSummary;
            state.brokerActivity.from = data.from;
            state.brokerActivity.to = data.to;
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivity.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivityNextPage.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getBrokerActivityNextPage.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        var newSummary = data.broker_summary;
        if (error) state.error = error;
        if (!newSummary) {
            state.brokerActivity.pagination = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state.brokerActivity.pagination), {
                isScrollable: false
            });
        } else {
            var sizeBrokersBuy = newSummary.brokers_buy.length;
            var sizeBrokersSell = newSummary.brokers_sell.length;
            if (sizeBrokersBuy || sizeBrokersSell) {
                state.brokerActivity.summary = {
                    brokers_buy: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.brokerActivity.summary.brokers_buy).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newSummary.brokers_buy)),
                    brokers_sell: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(state.brokerActivity.summary.brokers_sell).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(newSummary.brokers_sell)),
                    symbol: ""
                };
            } else {
                state.brokerActivity.pagination.isScrollable = false;
            }
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getBrokerActivityNextPage.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    }).addCase(effects.getTopBroker.pending, function(state) {
        state.isLoading = true;
        state.error = null;
    }).addCase(effects.getTopBroker.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, error = _payload.error, message = _payload.message;
        if (error) {
            state.error = error;
        }
        if (!data) {
            state.topBrokers.data = [];
            state.topBrokers.date = "";
            state.error = null;
        } else {
            state.topBrokers.data = data.data;
            state.topBrokers.date = data.date;
            state.error = null;
        }
        state.message = message;
        state.isLoading = false;
    }).addCase(effects.getTopBroker.rejected, function(state, action) {
        state.error = action.payload.error;
        state.isLoading = false;
    });
};
var bandarDetectorSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "bandarDetector",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (bandarDetectorSlice);


/***/ }),

/***/ 63914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$q": function() { return /* binding */ BandarSearchCompanyWrapper; },
/* harmony export */   "AB": function() { return /* binding */ ModalWrapper; },
/* harmony export */   "Bb": function() { return /* binding */ DatePickerWrapper; },
/* harmony export */   "Ds": function() { return /* binding */ TableTransactionBroker; },
/* harmony export */   "Fq": function() { return /* binding */ TableListTransaction; },
/* harmony export */   "Hu": function() { return /* binding */ BrokActivityText; },
/* harmony export */   "Mt": function() { return /* binding */ DatePicker; },
/* harmony export */   "Nr": function() { return /* binding */ CodeTag; },
/* harmony export */   "QU": function() { return /* binding */ TableTopBroker; },
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; },
/* harmony export */   "Wb": function() { return /* binding */ ButtonOpenModal; },
/* harmony export */   "Xr": function() { return /* binding */ BrokerListSelect; },
/* harmony export */   "Y9": function() { return /* binding */ TableBrokerAccDist; },
/* harmony export */   "Yt": function() { return /* binding */ StyledTabs; },
/* harmony export */   "_8": function() { return /* binding */ SearchWrapper; },
/* harmony export */   "bL": function() { return /* binding */ SelectWrapper; },
/* harmony export */   "dk": function() { return /* binding */ BrokerActivityWrapper; },
/* harmony export */   "el": function() { return /* binding */ WrapperTransactionList; },
/* harmony export */   "gM": function() { return /* binding */ HeaderContainer; },
/* harmony export */   "gp": function() { return /* binding */ TableBrokerWrapper; },
/* harmony export */   "ln": function() { return /* binding */ BrokerActivityTabelWrap; },
/* harmony export */   "r6": function() { return /* binding */ ModalTitle; },
/* harmony export */   "ry": function() { return /* binding */ TableBrokerSummary; },
/* harmony export */   "xu": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76825);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76750);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n  height: 40px;\n  cursor: pointer;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      font-family: 'ProximaNovaBd';\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    min-width: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex: 1;\n  height: 32px;\n\n  :nth-child(1) {\n    border: none !important;\n  }\n\n  :nth-child(3) {\n    border: none !important;\n  }\n\n  :hover,\n  :focus {\n    :nth-child(1) {\n      border: none !important;\n    }\n\n    :nth-child(3) {\n      border: none !important;\n    }\n  }\n\n  input {\n    color: ",
        ";\n  }\n\n  input::placeholder {\n    color: ",
        ";\n  }\n\n  .ant-picker-content {\n    table-layout: auto;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  overflow-y: auto;\n\n  & > div::-webkit-scrollbar {\n      width: 0px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 12px;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  & {\n    min-height: 100%;\n  }\n\n  .ant-tabs-nav {\n    margin-bottom: 12px;\n\n    &::before {\n      border: none;\n    }\n  }\n\n  .ant-tabs-nav-wrap {\n    .ant-tabs-nav-list {\n      justify-content: space-between;\n      width: 100%;\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    background: transparent;\n\n    &::after {\n      background: #00ab6b;\n      content: ' ';\n      position: absolute;\n      left: 50%;\n      right: 0;\n      bottom: 5px;\n      height: 2px;\n      width: 40px;\n      transform: translateX(-50%);\n    }\n  }\n\n  .ant-tabs-tab {\n    font-size: 13px;\n    margin: 0;\n    padding: 14px 12px;\n\n    &.ant-tabs-tab-active {\n      .ant-tabs-tab-btn {\n        color: ",
        ";\n        text-shadow: none;\n        font-family: 'ProximaNovaBd';\n      }\n    }\n\n    &:hover {\n      color: unset;\n    }\n  }\n\n  .ant-tabs-nav-operations {\n    display: none !important;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  border: 1px solid ",
        ";\n  border-radius: 2px 2px 0 0;\n\n  .ant-picker {\n    padding: 8px;\n  }\n  .ant-picker:last-child .ant-picker-input input {\n    text-align: right;\n  }\n  .ant-picker:last-child .ant-picker-input .ant-picker-suffix {\n    margin-left: 8px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  > :first-child {\n    width: 100%;\n\n    .ant-select-selector {\n      border-top: none;\n      border-bottom-right-radius: 0;\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n\n  > :nth-child(2) {\n    width: 100%;\n\n    .ant-select-selector {\n      border-left: none;\n      border-radius: 0;\n      border-right: none;\n      border-top: none;\n    }\n  }\n\n  > :last-child {\n    width: 80%;\n\n    .ant-select-selector {\n      border-top: none;\n      border-bottom-left-radius: 0;\n      border-top-left-radius: 0;\n      border-top-right-radius: 0;\n    }\n  }\n\n  .ant-select-selector {\n    padding: 0 8px !important;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 12px;\n  min-height: 400px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: 12px;\n  overflow-x: auto;\n\n  thead th {\n    background: transparent;\n    border-bottom: 1px solid ",
        " !important;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 400;\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n    "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  font-family: 'ProximaNovaBd';\n  display: inline-block;\n  width: 30px;\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: auto;\n  }\n  ",
        "::after {\n    content: ' -';\n    margin: 0 4px;\n    color: ",
        ";\n    font-family: 'ProximaNovaRg';\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-table-container {\n    table {\n      tr {\n        th {\n          background-color: transparent;\n          border-bottom: 1px solid ",
        ";\n        }\n\n        .ant-table-cell {\n          white-space: nowrap;\n        }\n\n        th:not(:first-child) p,\n        td:not(:first-child) p {\n          margin-left: 8px;\n        }\n      }\n    }\n  }\n\n  .ant-table-ping-right:not(.ant-table-has-fix-right)\n    .ant-table-container::after {\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  .ant-table-container {\n    table {\n      tbody:before {\n        content: '@';\n        display: block;\n        line-height: 8px;\n        text-indent: -99999px;\n      }\n      tr {\n        th {\n          background-color: transparent;\n          border-bottom: 1px solid ",
        ";\n        }\n\n        th:nth-child(2) p,\n        td:nth-child(2) p,\n        th:nth-child(3) p,\n        td:nth-child(3) p,\n        th:nth-child(4) p,\n        td:nth-child(4) p {\n          text-align: right;\n          padding-right: 8px;\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n\n  .ant-table-container {\n    table {\n      tr {\n        th:nth-child(2) p,\n        th:nth-child(3) p,\n        th:nth-child(4) p,\n        td:nth-child(2) p,\n        td:nth-child(3) p,\n        td:nth-child(4) p {\n          text-align: right;\n        }\n      }\n      tr td:nth-child(4) p {\n        padding-right: 8px;\n      }\n    }\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  padding: 0 12px;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 12px;\n\n  .ant-table-container {\n    padding: 0 12px;\n\n    table {\n      tr {\n        th {\n          background-color: transparent;\n          border-bottom: 1px solid ",
        ";\n        }\n\n        th:nth-child(2) p,\n        td:nth-child(2) p,\n        th:nth-child(3) p,\n        td:nth-child(3) p,\n        th:nth-child(4) p,\n        td:nth-child(4) p {\n          text-align: right;\n        }\n        th:not(:last-child) p,\n        td:not(:last-child) p {\n          padding-right: 8px;\n        }\n      }\n\n      tbody:before {\n        content: '@';\n        display: block;\n        line-height: 8px;\n        text-indent: -99999px;\n      }\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 12px;\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  position: fixed;\n  bottom: 13px;\n  right: 50px;\n  width: 32px;\n  height: 32px;\n  padding: 8px;\n  color: ",
        ";\n  font-weight: 700;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px;\n\n  .ant-modal {\n    padding: 25px;\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 25px 20px 20px 20px;\n\n  .top-broker-title {\n    font-family: 'ProximaNovaBd';\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  .top-broker-subtitle {\n    font-size: 12px;\n    font-weight: 400;\n    color: #858585;\n  }\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-table-ping-left:not(.ant-table-has-fix-left)\n    .ant-table-container::before {\n    box-shadow: none;\n  }\n\n  .ant-table-container {\n    padding: ",
        ";\n\n    table {\n      tr {\n        th {\n          background-color: #ffffff;\n\n          p {\n            padding: 5px 0;\n            font-weight: 700;\n            font-family: 'ProximaNovaBd';\n          }\n\n          &.ant-table-column-has-sorters {\n            &:hover {\n              background-color: #ffffff;\n            }\n\n            .ant-table-column-sorters {\n              padding: 0;\n\n              .ant-table-column-sorter {\n                display: none;\n              }\n            }\n          }\n\n          &.ant-table-column-sort {\n            .ant-table-column-sorters {\n              .ant-table-column-sorter {\n                margin-left: 4px;\n                display: inline-block;\n              }\n            }\n          }\n        }\n\n        td {\n          &.ant-table-column-sort {\n            background-color: #ffffff;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 12px;\n"
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}



var Flex = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Flex */ .Gn.Flex, Text = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Text */ .Gn.Text, DatePickerDefault = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.DatePicker */ .Gn.DatePicker, Button = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Button */ .Gn.Button, Select = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Common.Select */ .Gn.Select;
var Table = _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .Widget.Table */ .$L.Table;
var cellType = {
    up: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary,
    down: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.sunsetOrange */ .$_.sunsetOrange,
    neutral: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.suvaGrey */ .$_.suvaGrey,
    default: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis,
    local: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.purpleHeart */ .$_.purpleHeart,
    bumn: _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.green */ .$_.green,
    // TODO add color to DS
    foreign: "#D73F3C",
    newForeign: "#D73F3C"
};
var HeaderContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).attrs({
    align: "center",
    justify: "space-between",
    px: "10px"
}).withConfig({
    componentId: "sc-98aecb39-0"
})(_templateObject(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.aliceBlue */ .$_.aliceBlue, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var Td = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs(function(props) {
    return {
        height: "auto",
        padding: "6px 0px",
        size: "13px",
        type: props.type || "default"
    };
}).withConfig({
    componentId: "sc-98aecb39-1"
})(_templateObject5(), function(param) {
    var bgType = param.bgType;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1(), bgType);
}, function(param) {
    var type = param.type;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2(), cellType[type]);
}, function(param) {
    var weight = param.weight;
    return weight === "bold" && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject3());
}, function(param) {
    var minWidth = param.minWidth;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject4(), minWidth);
});
var Th = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Td).attrs({
    padding: "6px 0px",
    size: "13px",
    whiteSpace: "nowrap"
}).withConfig({
    componentId: "sc-98aecb39-2"
})(_templateObject6());
var DatePicker = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(DatePickerDefault).withConfig({
    componentId: "sc-98aecb39-3"
})(_templateObject7(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.primary */ .$_.primary);
var Box = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-4"
})(_templateObject8());
var SearchWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-5"
})(_templateObject9());
var StyledTabs = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-98aecb39-6"
})(_templateObject10(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis);
var DatePickerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-98aecb39-7"
})(_templateObject11(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var SelectWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-98aecb39-8"
})(_templateObject12());
var BrokerActivityWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-9"
})(_templateObject13());
var BrokerActivityTabelWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-10"
})(_templateObject14(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var BrokActivityText = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Text).attrs(function(props) {
    return {
        height: "auto",
        size: "13px",
        align: "center",
        padding: "6px 0px",
        type: props.type || "default"
    };
}).withConfig({
    componentId: "sc-98aecb39-11"
})(_templateObject16(), function(param) {
    var type = param.type;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject15(), cellType[type]);
});
var CodeTag = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].span.attrs(function(props) {
    return {
        type: props.className || "default"
    };
}).withConfig({
    componentId: "sc-98aecb39-12"
})(_templateObject18(), function(param) {
    var type = param.type;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject17(), cellType[type]);
});
var BrokerListSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Select).attrs(function() {
    return {
        style: {
            width: "100%",
            marginBottom: 12
        }
    };
}).withConfig({
    componentId: "sc-98aecb39-13"
})(_templateObject19(), CodeTag, CodeTag, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highempahis */ .$_.highempahis);
var TableListTransaction = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Table).withConfig({
    componentId: "sc-98aecb39-14"
})(_templateObject20(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var TableBrokerAccDist = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Table).withConfig({
    componentId: "sc-98aecb39-15"
})(_templateObject21(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var TableBrokerSummary = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Table).withConfig({
    componentId: "sc-98aecb39-16"
})(_templateObject22());
var TableBrokerWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Flex).withConfig({
    componentId: "sc-98aecb39-17"
})(_templateObject23());
var TableTransactionBroker = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Table).withConfig({
    componentId: "sc-98aecb39-18"
})(_templateObject24(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var BandarSearchCompanyWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-19"
})(_templateObject25());
var ButtonOpenModal = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Button).withConfig({
    componentId: "sc-98aecb39-20"
})(_templateObject26(), _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.highgray */ .$_.highgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.downgray */ .$_.downgray, _stockbit_ui__WEBPACK_IMPORTED_MODULE_1__/* .color.gainsboro */ .$_.gainsboro);
var ModalWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-21"
})(_templateObject27());
var ModalTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-22"
})(_templateObject28());
var TableTopBroker = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(Table).withConfig({
    componentId: "sc-98aecb39-23"
})(_templateObject29(), function(props) {
    return props.isModal ? 0 : "0 12px";
});
var WrapperTransactionList = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-98aecb39-24"
})(_templateObject30());



/***/ }),

/***/ 3155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ HOTLIST_TYPE; },
/* harmony export */   "Sz": function() { return /* binding */ effects; }
/* harmony export */ });
/* unused harmony exports selectors, reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1349);






// Auth Related Modules

// Actions
var CONTEXT = "@side-widget/hotlist";
var actionType = {
    GET_HOTLIST: "".concat(CONTEXT, "/GET_HOTLIST")
};
// hotlist type
var HOTLIST_TYPE = {
    TOP_GAINER: "topGainer",
    TOP_LOSER: "topLoser",
    MOST_ACTIVE: "mostActive"
};
var _obj;
// hotlist api
var HOTLIST_API = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, HOTLIST_TYPE.TOP_GAINER, lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTopGainer */ .Z.getTopGainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, HOTLIST_TYPE.TOP_LOSER, lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getTopLoser */ .Z.getTopLoser), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, HOTLIST_TYPE.MOST_ACTIVE, lib_api_company__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getMostActive */ .Z.getMostActive), _obj);
// initial state
var initialState = {
    topGainer: {
        data: [],
        isLoading: false,
        error: null
    },
    topLoser: {
        data: [],
        isLoading: false,
        error: null
    },
    mostActive: {
        data: [],
        isLoading: false,
        error: null
    }
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(function(state) {
    var _hotlist = state.mainLayout.hotlist, topGainer = _hotlist.topGainer, topLoser = _hotlist.topLoser, mostActive = _hotlist.mostActive;
    return {
        // all
        topGainer: topGainer,
        topLoser: topLoser,
        mostActive: mostActive,
        // top gainer
        topGainerError: topGainer.error,
        topGainerData: topGainer.data,
        topGainerLoading: topGainer.isLoading,
        // top loser
        topLoserError: topLoser.error,
        topLoserData: topLoser.data,
        topLoserLoading: topLoser.isLoading,
        // most active
        mostActiveError: mostActive.error,
        mostActiveData: mostActive.data,
        mostActiveLoading: mostActive.isLoading
    };
}, function(state) {
    return state;
});
// Reducer
var reducers = {};
// effects
var effects = {
    // login
    getHotlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_HOTLIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _type, type, targetAPI, response, _data, data, _$error, message, normalized;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _type = param.type, type = _type === void 0 ? HOTLIST_TYPE.TOP_GAINER : _type;
                        _ctx.prev = 1;
                        targetAPI = HOTLIST_API[type] || HOTLIST_API[HOTLIST_TYPE.TOP_GAINER];
                        _ctx.next = 5;
                        return targetAPI();
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Error when changing password, no data recevied");
                    case 8:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(_$error);
                    case 11:
                        normalized = data.map(function(item) {
                            var change = item.change;
                            var changeIndicator = change[0];
                            var changeValue = change;
                            var changeFlow = "neutral";
                            if (changeIndicator === "+") {
                                changeFlow = "up";
                                changeValue = change.substring(1);
                            } else if (changeIndicator === "-") {
                                changeFlow = "down";
                            } else {
                                changeFlow = "neutral";
                            }
                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, item), {
                                changeFlow: changeFlow,
                                changeIndicator: changeIndicator,
                                changeValue: changeValue
                            });
                        });
                        return _ctx.abrupt("return", {
                            data: normalized,
                            message: message
                        });
                    case 15:
                        _ctx.prev = 15;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    15
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }())
};
var _obj1;
// Extra / Async Reducer
var extraReducers = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, effects.getHotlist.pending, function(state, action) {
    var type = action.meta.arg.type;
    state[type].error = null;
    state[type].isLoading = true;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, effects.getHotlist.fulfilled, function(state, action) {
    var type = action.meta.arg.type;
    state[type].data = action.payload.data;
    state[type].error = null;
    state[type].isLoading = true;
    state[type].message = action.payload.message;
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, effects.getHotlist.rejected, function(state, action) {
    var type = action.meta.arg.type;
    state[type].error = action.error;
    state[type].isLoading = true;
}), _obj1);
// Slice
var hotlistSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "hotlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (hotlistSlice);


/***/ }),

/***/ 16835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J$": function() { return /* binding */ editPriceAlertSelector; },
/* harmony export */   "NS": function() { return /* binding */ cancelPriceAlertSelector; },
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "TB": function() { return /* binding */ priceAlertSelector; },
/* harmony export */   "_b": function() { return /* binding */ alertLogSelector; },
/* harmony export */   "az": function() { return /* binding */ addPriceAlertSelector; }
/* harmony export */ });
/* unused harmony exports PRICE_ALERT_TYPE, selectors, reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_alert__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56703);






// Auth Related Modules

// Actions
var CONTEXT = "@side-widget/priceAlert";
var actionType = {
    GET_PRICE_ALERT: "".concat(CONTEXT, "/GET_PRICE_ALERT"),
    ADD_PRICE_ALERT: "".concat(CONTEXT, "/ADD_PRICE_ALERT"),
    EDIT_PRICE_ALERT: "".concat(CONTEXT, "/EDIT_PRICE_ALERT"),
    CANCEL_PRICE_ALERT: "".concat(CONTEXT, "/CANCEL_PRICE_ALERT"),
    GET_ALERT_LOG: "".concat(CONTEXT, "/GET_ALERT_LOG")
};
// price alert type
var PRICE_ALERT_TYPE = {
    PRICE_ALERT: "priceAlert",
    ALERT_LOG: "alertLog"
};
// initial state
var initialState = {
    priceAlert: {
        data: [],
        isLoading: true,
        error: null,
        page: 1,
        reachEnd: false
    },
    addPriceAlert: {
        data: [],
        isLoading: false,
        error: null,
        isSubmit: false
    },
    editPriceAlert: {
        data: [],
        isLoading: false,
        error: null,
        isSubmit: false
    },
    cancelPriceAlert: {
        data: [],
        isLoading: false,
        error: null,
        isCancel: false
    },
    alertLog: {
        data: [],
        isLoading: true,
        error: null
    }
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    var _priceAlert = state.mainLayout.priceAlert, priceAlert = _priceAlert.priceAlert, addPriceAlert = _priceAlert.addPriceAlert, editPriceAlert = _priceAlert.editPriceAlert, cancelPriceAlert = _priceAlert.cancelPriceAlert, alertLog = _priceAlert.alertLog;
    return {
        // all
        priceAlert: priceAlert,
        alertLog: alertLog,
        addPriceAlert: addPriceAlert,
        editPriceAlert: editPriceAlert,
        cancelPriceAlert: cancelPriceAlert,
        // price alert
        priceAlertError: priceAlert.error,
        priceAlertData: priceAlert.data,
        priceAlertLoading: priceAlert.isLoading,
        // alert log
        alertLogError: alertLog.error,
        alertLogData: alertLog.data,
        alertLogLoading: alertLog.isLoading
    };
}, function(state) {
    return state;
});
var priceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.priceAlert;
}, function(state) {
    return state;
});
var addPriceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.addPriceAlert;
}, function(state) {
    return state;
});
var editPriceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.editPriceAlert;
}, function(state) {
    return state;
});
var cancelPriceAlertSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.cancelPriceAlert;
}, function(state) {
    return state;
});
var alertLogSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.priceAlert.alertLog;
}, function(state) {
    return state;
});
// Reducer
var reducers = {
    setPriceAlert: function(state, action) {
        state.priceAlert.data = state.priceAlert.data.filter(function(x) {
            return String(x.alert_id) !== String(action.payload.alert_id);
        });
    }
};
// effects
var effects = {
    // getPriceAlert
    getPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_PRICE_ALERT, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var options, page, limit, opt, response, _data, data, _$error, message, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    options = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {
                        page: 1,
                        limit: 30
                    };
                    _ctx.prev = 1;
                    page = options.page, limit = options.limit;
                    opt = {
                        page: page || 1,
                        limit: limit || 30
                    };
                    _ctx.next = 6;
                    return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDataPriceAlert */ .Z.getDataPriceAlert(opt);
                case 6:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error("Error when get list price alert");
                case 9:
                    _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 12;
                        break;
                    }
                    throw new Error(_$error);
                case 12:
                    return _ctx.abrupt("return", {
                        data: data,
                        options: options,
                        message: message
                    });
                case 15:
                    _ctx.prev = 15;
                    _ctx.t0 = _ctx["catch"](1);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                15
            ]
        ]);
    }))),
    // getAlertLog
    getAlertLog: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_ALERT_LOG, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var opt, response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    opt = {
                        page: 1,
                        limit: 30
                    };
                    _ctx.next = 4;
                    return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDataAlertLog */ .Z.getDataAlertLog(4, opt);
                case 4:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error("Error when get list alert log");
                case 7:
                    _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 10;
                        break;
                    }
                    throw new Error(_$error);
                case 10:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }))),
    // addPriceAlert
    addPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.ADD_PRICE_ALERT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var name, command, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, command = param.command;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].addPriceAlert */ .Z.addPriceAlert(name, command);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when add price alert");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // editPriceAlert
    editPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.EDIT_PRICE_ALERT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var alertId, name, command, response, _data, data, _$error, message, updatedAlert;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        alertId = param.alertId, name = param.name, command = param.command;
                        _ctx.prev = 1;
                        if (alertId) {
                            _ctx.next = 4;
                            break;
                        }
                        throw new Error("Alert ID is required!");
                    case 4:
                        _ctx.next = 6;
                        return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].editPriceAlert */ .Z.editPriceAlert(alertId, name, command);
                    case 6:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error("Error when edit price alert");
                    case 9:
                        _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(_$error);
                    case 12:
                        updatedAlert = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                            command: JSON.parse(command)
                        });
                        return _ctx.abrupt("return", {
                            updatedAlert: updatedAlert,
                            data: data,
                            message: message
                        });
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    16
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // cancelPriceAlert
    cancelPriceAlert: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.CANCEL_PRICE_ALERT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(id) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_alert__WEBPACK_IMPORTED_MODULE_1__/* ["default"].cancelPriceAlert */ .Z.cancelPriceAlert(id);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when cancel price alert");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error_type, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            id: id,
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(id) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra / Async Reducer
var extraReducers = function(builder) {
    builder.addCase(effects.getPriceAlert.pending, function(state) {
        state.priceAlert.error = null;
        state.priceAlert.isLoading = true;
    }).addCase(effects.getPriceAlert.fulfilled, function(state, action) {
        if (action.payload.options.page > 1) {
            state.priceAlert.data = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.priceAlert.data).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(action.payload.data));
        } else {
            // To prevent data duplication when sidemenu is reopened / switching tab
            state.priceAlert.data = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(action.payload.data);
        }
        // Update `page` when data is not empty
        if (action.payload.data.length > 0) {
            state.priceAlert.page = action.payload.options.page;
            state.priceAlert.reachEnd = false;
        } else {
            state.priceAlert.reachEnd = true;
        }
        state.priceAlert.error = null;
        state.priceAlert.isLoading = false;
        state.priceAlert.message = action.payload.message;
    }).addCase(effects.getPriceAlert.rejected, function(state, action) {
        state.priceAlert.error = action.error;
        state.priceAlert.isLoading = false;
    }).addCase(effects.getAlertLog.pending, function(state) {
        state.alertLog.error = null;
        state.alertLog.isLoading = true;
    }).addCase(effects.getAlertLog.fulfilled, function(state, action) {
        state.alertLog.data = action.payload.data;
        state.alertLog.error = null;
        state.alertLog.isLoading = false;
        state.alertLog.message = action.payload.message;
    }).addCase(effects.getAlertLog.rejected, function(state, action) {
        state.alertLog.error = action.error;
        state.alertLog.isLoading = false;
    }).addCase(effects.addPriceAlert.pending, function(state) {
        state.addPriceAlert.error = null;
        state.addPriceAlert.isLoading = true;
        state.addPriceAlert.isSubmit = false;
    }).addCase(effects.addPriceAlert.fulfilled, function(state, action) {
        state.addPriceAlert.data = action.payload.data;
        var alert = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, action.payload.data), {
            command: JSON.parse(action.payload.data.command)
        });
        state.priceAlert.data = [
            alert
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(state.priceAlert.data));
        state.addPriceAlert.error = null;
        state.addPriceAlert.isLoading = false;
        state.addPriceAlert.message = action.payload.message;
        state.addPriceAlert.isSubmit = true;
    }).addCase(effects.addPriceAlert.rejected, function(state, action) {
        state.addPriceAlert.error = action.error;
        state.addPriceAlert.isLoading = false;
        state.addPriceAlert.isSubmit = false;
    }).addCase(effects.editPriceAlert.pending, function(state) {
        state.editPriceAlert.error = null;
        state.editPriceAlert.isLoading = true;
        state.editPriceAlert.isSubmit = false;
    }).addCase(effects.editPriceAlert.fulfilled, function(state, action) {
        state.editPriceAlert.data = action.payload.data;
        var updatedAlert = action.payload.updatedAlert;
        var index = state.priceAlert.data.findIndex(function(x) {
            return x.alert_id === updatedAlert.alert_id;
        });
        if (index > -1) {
            state.priceAlert.data[index] = updatedAlert;
        }
        state.editPriceAlert.error = null;
        state.editPriceAlert.isLoading = false;
        state.editPriceAlert.message = action.payload.message;
        state.editPriceAlert.isSubmit = true;
    }).addCase(effects.editPriceAlert.rejected, function(state, action) {
        state.editPriceAlert.error = action.error;
        state.editPriceAlert.isLoading = false;
        state.editPriceAlert.isSubmit = false;
    }).addCase(effects.cancelPriceAlert.pending, function(state) {
        state.cancelPriceAlert.error = null;
        state.cancelPriceAlert.isLoading = true;
        state.cancelPriceAlert.isCancel = false;
    }).addCase(effects.cancelPriceAlert.fulfilled, function(state, action) {
        state.cancelPriceAlert.data = action.payload.data;
        var id = action.payload.id;
        state.priceAlert.data = state.priceAlert.data.filter(function(x) {
            return x.alert_id !== id;
        });
        state.cancelPriceAlert.error = null;
        state.cancelPriceAlert.isLoading = false;
        state.cancelPriceAlert.message = action.payload.message;
        state.cancelPriceAlert.isCancel = true;
    }).addCase(effects.cancelPriceAlert.rejected, function(state, action) {
        state.cancelPriceAlert.error = action.error;
        state.cancelPriceAlert.isLoading = false;
        state.cancelPriceAlert.isCancel = false;
    });
};
// Slice
var priceAlertSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "priceAlert",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (priceAlertSlice);


/***/ }),

/***/ 36296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N8": function() { return /* binding */ TYPE_CUSTOM_PRESET; },
/* harmony export */   "QR": function() { return /* binding */ DEFAULT_TYPE_PRESET; },
/* harmony export */   "qe": function() { return /* binding */ INITIAL_PAGE; },
/* harmony export */   "rz": function() { return /* binding */ KENNETH_FISHER_PRICE_TO_SALES_ID; }
/* harmony export */ });
var INITIAL_PAGE = 1;
var KENNETH_FISHER_PRICE_TO_SALES_ID = 2;
var DEFAULT_TYPE_PRESET = "TEMPLATE_TYPE_GURU";
var TYPE_CUSTOM_PRESET = "TEMPLATE_TYPE_CUSTOM";


/***/ }),

/***/ 9139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export reducers */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17065);
/* harmony import */ var lib_api_screener__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70735);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36296);




// Related Modules



// Actions
var CONTEXT = "@side-widget/valuation";
var actionType = {
    // valuation
    GET_VALUATION_TEMPLATE: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE"),
    GET_VALUATION_METRICS: "".concat(CONTEXT, "/GET_VALUATION_METRICS"),
    POST_DELETE_VALUATION_TEMPLATE: "".concat(CONTEXT, "/POST_DELETE_VALUATION_TEMPLATE"),
    POST_VALUATION_RESULT: "".concat(CONTEXT, "/POST_VALUATION_RESULT"),
    POST_VALUATION_TEMPLATE_SAVE: "".concat(CONTEXT, "/POST_VALUATION_TEMPLATE_SAVE"),
    POST_VALUATION_TEMPLATE_ADD: "".concat(CONTEXT, "/POST_VALUATION_TEMPLATE_ADD"),
    GET_VALUATION_TEMPLATE_LOAD: "".concat(CONTEXT, "/GET_VALUATION_TEMPLATE_LOAD"),
    GET_VALUATION_METRICS_DEFAULT: "".concat(CONTEXT, "/GET_VALUATION_METRICS_DEFAULT"),
    // screener
    GET_SCREENER_CUSTOM: "".concat(CONTEXT, "/GET_SCREENER_CUSTOM"),
    GET_SCREENER_METRICS: "".concat(CONTEXT, "/GET_SCREENER_METRICS"),
    GET_LOAD_PRESET_SCREENER: "".concat(CONTEXT, "/GET_LOAD_PRESET_SCREENER"),
    POST_SCREENER_LIST_RESULT: "".concat(CONTEXT, "/POST_SCREENER_LIST_RESULT")
};
// initial state
var initialState = {
    // valuation
    getValuationTemplate: {
        data: [],
        isLoading: true,
        error: null
    },
    getValuationMetrics: {
        data: {},
        isLoading: true,
        error: null
    },
    getValuationTemplateLoad: {
        data: {},
        isLoading: false,
        error: null
    },
    getValuationMetricsDefault: {
        data: [],
        isLoading: true,
        error: null
    },
    postDeleteValuationTemplate: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationResult: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationTemplateSave: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    postValuationTemplateAdd: {
        data: {},
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    // screener
    getScreenerCustom: {
        data: [],
        isLoading: true,
        error: null
    },
    getScreenerMetrics: {
        data: [],
        isLoading: true,
        error: null
    },
    getLoadPresetScreener: {
        data: {},
        isLoading: true,
        error: null
    },
    postScreenerListResult: {
        data: [],
        isLoading: false,
        error: null,
        isSubmitted: false
    },
    // TODO: Remove this lines after layout feature has been implemented
    currentScreenerData: {
        page: _constants__WEBPACK_IMPORTED_MODULE_3__/* .INITIAL_PAGE */ .qe,
        presetId: _constants__WEBPACK_IMPORTED_MODULE_3__/* .KENNETH_FISHER_PRICE_TO_SALES_ID */ .rz,
        isDataLoaded: false,
        shouldUpdate: false,
        type: ""
    }
};
// Selectors
var valuationState = function(state) {
    return state.mainLayout.valuation;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSelector */ .P1)(valuationState, function(state) {
    return {
        // valuation
        getValuationTemplate: state.getValuationTemplate,
        getValuationMetrics: state.getValuationMetrics,
        getValuationTemplateLoad: state.getValuationTemplateLoad,
        getValuationMetricsDefault: state.getValuationMetricsDefault,
        postDeleteValuationTemplate: state.postDeleteValuationTemplate,
        postValuationResult: state.postValuationResult,
        postValuationTemplateSave: state.postValuationTemplateSave,
        postValuationTemplateAdd: state.postValuationTemplateAdd,
        // screener
        getScreenerCustom: state.getScreenerCustom,
        getScreenerMetrics: state.getScreenerMetrics,
        getLoadPresetScreener: state.getLoadPresetScreener,
        postScreenerListResult: state.getLoadPresetScreener,
        // TODO: Remove this lines after layout feature has been implemented
        currentScreenerData: state.currentScreenerData
    };
}, function(state) {
    return state;
});
// Reducer
var reducers = {
    // TODO: Remove this lines after layout feature has been implemented
    setCurrentScreenerData: function(state, action) {
        state.currentScreenerData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.currentScreenerData, action.payload);
    }
};
// effects
var effects = {
    // getValuationTemplate
    getValuationTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationTemplate */ .Z.getValuationTemplate();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list valuation template");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getValuationMetrics
    getValuationMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationMetrics */ .Z.getValuationMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list valuation metrics");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getValuationTemplateLoad
    getValuationTemplateLoad: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_TEMPLATE_LOAD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(templateId) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationTemplateLoad */ .Z.getValuationTemplateLoad(templateId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when get detail valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(templateId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // getValuationMetricsDefault
    getValuationMetricsDefault: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_VALUATION_METRICS_DEFAULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(queryString) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getValuationMetricsDefault */ .Z.getValuationMetricsDefault(queryString);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when get valuation metrics default");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(queryString) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationResult
    postValuationResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationResult */ .Z.postValuationResult(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when post valuation result");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationTemplateSave
    postValuationTemplateSave: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_TEMPLATE_SAVE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var templateId, requestBody, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        templateId = param.templateId, requestBody = param.requestBody;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationTemplateSave */ .Z.postValuationTemplateSave(templateId, requestBody);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when save valuation template");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postValuationTemplateAdd
    postValuationTemplateAdd: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_VALUATION_TEMPLATE_ADD, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postValuationTemplateAdd */ .Z.postValuationTemplateAdd(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when add valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }()),
    // screener
    // getScreenerCustom
    getScreenerCustom: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_CUSTOM, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getScreenerCustom */ .Z.getScreenerCustom();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list screener custom");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getScreenerMetrics
    getScreenerMetrics: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_SCREENER_METRICS, (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, _$error, message;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getScreenerMetrics */ .Z.getScreenerMetrics();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Error when get list screener metrics");
                case 6:
                    _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    throw new Error(_$error);
                case 9:
                    return _ctx.abrupt("return", {
                        data: data,
                        message: message
                    });
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                case 15:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                12
            ]
        ]);
    }))),
    // getLoadPresetScreener
    getLoadPresetScreener: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_LOAD_PRESET_SCREENER, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var presetId, type, response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        presetId = param.presetId, type = param.type;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getLoadPresetScreener */ .Z.getLoadPresetScreener(presetId, type);
                    case 4:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 7;
                            break;
                        }
                        throw new Error("Error when get load preset screener");
                    case 7:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error(_$error);
                    case 10:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    13
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postDeleteValuationTemplate
    postDeleteValuationTemplate: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_DELETE_VALUATION_TEMPLATE, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(valuationId) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_valuation__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postDeleteValuationTemplate */ .Z.postDeleteValuationTemplate(valuationId);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when delete valuation template");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(valuationId) {
            return _ref.apply(this, arguments);
        };
    }()),
    // postScreenerListResult
    postScreenerListResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.POST_SCREENER_LIST_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(requestBody) {
            var response, _data, data, _$error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_screener__WEBPACK_IMPORTED_MODULE_2__/* ["default"].postScreenerListResult */ .Z.postScreenerListResult(requestBody);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Error when post screener list result");
                    case 6:
                        _data = response.data, data = _data.data, _$error = _data.error, message = _data.message;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(_$error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", Promise.reject(_ctx.t0));
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(requestBody) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Extra / Async Reducer
var extraReducers = function(builder) {
    // getValuationTemplate
    builder// Extra reducers for fetch suggestions
    .addCase(effects.getValuationTemplate.pending, function(state) {
        state.getValuationTemplate.error = null;
        state.getValuationTemplate.isLoading = true;
    }).addCase(effects.getValuationTemplate.fulfilled, function(state, action) {
        state.getValuationTemplate.data = action.payload.data;
        state.getValuationTemplate.error = null;
        state.getValuationTemplate.isLoading = false;
        state.getValuationTemplate.message = action.payload.message;
    }).addCase(effects.getValuationTemplate.rejected, function(state, action) {
        state.getValuationTemplate.error = action.error;
        state.getValuationTemplate.isLoading = false;
    }).addCase(effects.getValuationMetrics.pending, function(state) {
        state.getValuationMetrics.error = null;
        state.getValuationMetrics.isLoading = true;
    }).addCase(effects.getValuationMetrics.fulfilled, function(state, action) {
        state.getValuationMetrics.data = action.payload.data;
        state.getValuationMetrics.error = null;
        state.getValuationMetrics.isLoading = false;
        state.getValuationMetrics.message = action.payload.message;
    }).addCase(effects.getValuationMetrics.rejected, function(state, action) {
        state.getValuationMetrics.error = action.error;
        state.getValuationMetrics.isLoading = false;
    }).addCase(effects.getValuationTemplateLoad.pending, function(state) {
        state.getValuationTemplateLoad.error = null;
        state.getValuationTemplateLoad.isLoading = true;
    }).addCase(effects.getValuationTemplateLoad.fulfilled, function(state, action) {
        state.getValuationTemplateLoad.data = action.payload.data;
        state.getValuationTemplateLoad.error = null;
        state.getValuationTemplateLoad.isLoading = false;
        state.getValuationTemplateLoad.message = action.payload.message;
    }).addCase(effects.getValuationTemplateLoad.rejected, function(state, action) {
        state.getValuationTemplateLoad.error = action.error;
        state.getValuationTemplateLoad.isLoading = false;
    }).addCase(effects.getValuationMetricsDefault.pending, function(state) {
        state.getValuationMetricsDefault.error = null;
        state.getValuationMetricsDefault.isLoading = true;
    }).addCase(effects.getValuationMetricsDefault.fulfilled, function(state, action) {
        state.getValuationMetricsDefault.data = action.payload.data;
        state.getValuationMetricsDefault.error = null;
        state.getValuationMetricsDefault.isLoading = false;
        state.getValuationMetricsDefault.message = action.payload.message;
    }).addCase(effects.getValuationMetricsDefault.rejected, function(state, action) {
        state.getValuationMetricsDefault.error = action.error;
        state.getValuationMetricsDefault.isLoading = false;
    }).addCase(effects.getScreenerCustom.pending, function(state) {
        state.getScreenerCustom.error = null;
        state.getScreenerCustom.isLoading = true;
    }).addCase(effects.getScreenerCustom.fulfilled, function(state, action) {
        state.getScreenerCustom.data = action.payload.data;
        state.getScreenerCustom.error = null;
        state.getScreenerCustom.isLoading = false;
        state.getScreenerCustom.message = action.payload.message;
    }).addCase(effects.getScreenerCustom.rejected, function(state, action) {
        state.getScreenerCustom.error = action.error;
        state.getScreenerCustom.isLoading = false;
    }).addCase(effects.getScreenerMetrics.pending, function(state) {
        state.getScreenerMetrics.error = null;
        state.getScreenerMetrics.isLoading = true;
    }).addCase(effects.getScreenerMetrics.fulfilled, function(state, action) {
        state.getScreenerMetrics.data = action.payload.data;
        state.getScreenerMetrics.error = null;
        state.getScreenerMetrics.isLoading = false;
        state.getScreenerMetrics.message = action.payload.message;
    }).addCase(effects.getScreenerMetrics.rejected, function(state, action) {
        state.getScreenerMetrics.error = action.error;
        state.getScreenerMetrics.isLoading = false;
    }).addCase(effects.getLoadPresetScreener.pending, function(state) {
        state.getLoadPresetScreener.error = null;
        state.getLoadPresetScreener.isLoading = true;
    }).addCase(effects.getLoadPresetScreener.fulfilled, function(state, action) {
        state.getLoadPresetScreener.data = action.payload.data;
        state.getLoadPresetScreener.error = null;
        state.getLoadPresetScreener.isLoading = false;
        state.getLoadPresetScreener.message = action.payload.message;
        state.currentScreenerData.isDataLoaded = true;
    }).addCase(effects.getLoadPresetScreener.rejected, function(state, action) {
        state.getLoadPresetScreener.error = action.error;
        state.getLoadPresetScreener.isLoading = false;
    }).addCase(effects.postDeleteValuationTemplate.pending, function(state) {
        state.postDeleteValuationTemplate.error = null;
        state.postDeleteValuationTemplate.isLoading = true;
        state.postDeleteValuationTemplate.isSubmitted = false;
    }).addCase(effects.postDeleteValuationTemplate.fulfilled, function(state, action) {
        state.postDeleteValuationTemplate.data = action.payload.data;
        state.postDeleteValuationTemplate.error = null;
        state.postDeleteValuationTemplate.isLoading = false;
        state.postDeleteValuationTemplate.message = action.payload.message;
        state.postDeleteValuationTemplate.isSubmitted = true;
    }).addCase(effects.postDeleteValuationTemplate.rejected, function(state, action) {
        state.postDeleteValuationTemplate.error = action.error;
        state.postDeleteValuationTemplate.isLoading = false;
        state.postDeleteValuationTemplate.isSubmitted = false;
    }).addCase(effects.postScreenerListResult.pending, function(state) {
        state.postScreenerListResult.error = null;
        state.postScreenerListResult.isLoading = true;
    }).addCase(effects.postScreenerListResult.fulfilled, function(state, action) {
        state.postScreenerListResult.data = action.payload.data;
        state.getLoadPresetScreener.data = action.payload.data;
        state.postScreenerListResult.error = null;
        state.postScreenerListResult.isLoading = false;
        state.postScreenerListResult.message = action.payload.message;
    }).addCase(effects.postScreenerListResult.rejected, function(state, action) {
        state.postScreenerListResult.error = action.error;
        state.postScreenerListResult.isLoading = false;
    }).addCase(effects.postValuationResult.pending, function(state) {
        state.postValuationResult.error = null;
        state.postValuationResult.isLoading = true;
        state.postValuationResult.isSubmitted = false;
    }).addCase(effects.postValuationResult.fulfilled, function(state, action) {
        state.postValuationResult.data = action.payload.data;
        state.postValuationResult.error = null;
        state.postValuationResult.isLoading = false;
        state.postValuationResult.message = action.payload.message;
        state.postValuationResult.isSubmitted = true;
    }).addCase(effects.postValuationResult.rejected, function(state, action) {
        state.postValuationResult.error = action.error;
        state.postValuationResult.isLoading = false;
        state.postValuationResult.isSubmitted = false;
    }).addCase(effects.postValuationTemplateSave.pending, function(state) {
        state.postValuationTemplateSave.error = null;
        state.postValuationTemplateSave.isLoading = true;
        state.postValuationTemplateSave.isSubmitted = false;
    }).addCase(effects.postValuationTemplateSave.fulfilled, function(state, action) {
        state.postValuationTemplateSave.data = action.payload.data;
        state.postValuationTemplateSave.error = null;
        state.postValuationTemplateSave.isLoading = false;
        state.postValuationTemplateSave.message = action.payload.message;
        state.postValuationTemplateSave.isSubmitted = true;
    }).addCase(effects.postValuationTemplateSave.rejected, function(state, action) {
        state.postValuationTemplateSave.error = action.error;
        state.postValuationTemplateSave.isLoading = false;
        state.postValuationTemplateSave.isSubmitted = false;
    }).addCase(effects.postValuationTemplateAdd.pending, function(state) {
        state.postValuationTemplateAdd.error = null;
        state.postValuationTemplateAdd.isLoading = true;
        state.postValuationTemplateAdd.isSubmitted = false;
    }).addCase(effects.postValuationTemplateAdd.fulfilled, function(state, action) {
        state.postValuationTemplateAdd.data = action.payload.data;
        state.postValuationTemplateAdd.error = null;
        state.postValuationTemplateAdd.isLoading = false;
        state.postValuationTemplateAdd.message = action.payload.message;
        state.postValuationTemplateAdd.isSubmitted = true;
    }).addCase(effects.postValuationTemplateAdd.rejected, function(state, action) {
        state.postValuationTemplateAdd.error = action.error;
        state.postValuationTemplateAdd.isLoading = false;
        state.postValuationTemplateAdd.isSubmitted = false;
    });
};
// Slice
var valuationSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "valuation",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (valuationSlice);


/***/ }),

/***/ 6767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14229);
/* eslint-disable camelcase */ 




// constants
var CONTEXT = "@sidewidget/companyWatchlist";
var actionType = {
    GET_WATCHLIST: "".concat(CONTEXT, "/GET_WATCHLIST"),
    UNFOLLOW_COMPANY: "".concat(CONTEXT, "/UNFOLLOW_COMPANY")
};
// initial state
var initialState = {
    showList: false,
    list: [],
    isLoading: false,
    error: null
};
// Selectors
var selfSelector = function(state) {
    return state.mainLayout.watchlist.company;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(selfSelector, function(state) {
    return state;
});
// Async Actions / Side Effects
var effects = {
    getCompanyWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.GET_WATCHLIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var watchlistId, ref, watchlistIdCookie, targetWatchlistId, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId;
                        ref = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess(), watchlistIdCookie = ref.watchlist_id;
                        targetWatchlistId = watchlistId || watchlistIdCookie;
                        if (targetWatchlistId) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("watchListId is required");
                    case 5:
                        _ctx.next = 7;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getDetailWatchlist */ .Z.getDetailWatchlist(targetWatchlistId);
                    case 7:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 10:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error(error);
                    case 13:
                        return _ctx.abrupt("return", data.result.map(function(param) {
                            var change = param.change, id = param.id, last = param.last, name = param.name, percent = param.percent, previous = param.previous, symbol = param.symbol, type = param.type, notation = param.notation, uma = param.uma, corp_action = param.corp_action;
                            var direction = "neutral";
                            if (change > 0) {
                                direction = "up";
                            } else if (change < 0) {
                                direction = "down";
                            }
                            return {
                                change: change,
                                id: id,
                                last: last,
                                name: name,
                                percent: percent,
                                previous: previous,
                                symbol: symbol,
                                type: type,
                                direction: direction,
                                notation: notation,
                                uma: uma,
                                corp_action: corp_action
                            };
                        }));
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }()),
    // Unfollow Company
    unfollowCompany: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.UNFOLLOW_COMPANY, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var companyId, watchlistId, dispatch, ref, watchlistIdCookie, targetWatchlistId, response, _data, data, error, message;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        companyId = param.companyId, watchlistId = param.watchlistId, dispatch = param1.dispatch;
                        ref = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getUserAccess */ .Z.getUserAccess(), watchlistIdCookie = ref.watchlist_id;
                        targetWatchlistId = watchlistId || watchlistIdCookie;
                        if (targetWatchlistId) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("watchListId is required");
                    case 5:
                        _ctx.next = 7;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postUnfollowCompany */ .Z.postUnfollowCompany(targetWatchlistId, companyId);
                    case 7:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 10:
                        _data = response.data, data = _data.data, error = _data.error, message = _data.message;
                        if (!error) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error(error);
                    case 13:
                        dispatch(effects.getCompanyWatchlist({
                            watchlistId: watchlistId
                        }));
                        return _ctx.abrupt("return", {
                            message: message,
                            data: data
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    toggleViewType: function(draft) {
        draft.showList = !draft.showList;
    }
};
// Extra Reducer for async actions
var extraReducers = function(builder) {
    builder// get company watchlist
    .addCase(effects.getCompanyWatchlist.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.getCompanyWatchlist.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    }).addCase(effects.getCompanyWatchlist.fulfilled, function(draft, action) {
        draft.list = action.payload;
        draft.isLoading = false;
    })// unfollow
    .addCase(effects.unfollowCompany.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.unfollowCompany.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    }).addCase(effects.unfollowCompany.fulfilled, function(draft) {
        draft.isLoading = false;
    });
};
// Slice
var companyWatchlistSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "companyWatchlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (companyWatchlistSlice);


/***/ }),

/***/ 31390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var _slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78626);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15056);





// constants
var CONTEXT = "@sidewidget/listWatchlist";
// initial state
var initialState = {
    saved: [],
    isLoading: false,
    isCreateModalVisible: false,
    isDeleteModalVisible: false,
    watchlistTobeDeleted: null,
    error: null
};
// Selectors
var selectSelf = function(state) {
    return state.mainLayout.watchlist.listWatchlist;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(selectSelf, function(state) {
    return state;
});
// Async Actions / Side Effects
var effects = {
    getSavedWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/GET_SAVED_WATCHLIST"), (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getAllWatchlist */ .Z.getAllWatchlist();
                case 2:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 5;
                        break;
                    }
                    throw new Error("Attempt to fetch stream failed");
                case 5:
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error(error);
                case 8:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // create new watchlist
    createNewWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/CREATE_NEW_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var name, description, dispatch, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        name = param.name, description = param.description, dispatch = param1.dispatch;
                        if (name) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Watchlist name should be provided");
                    case 3:
                        _ctx.next = 5;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].createNewWatchlist */ .Z.createNewWatchlist(name, description);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to fetch stream failed");
                    case 8:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(error);
                    case 11:
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setCurrentwatchlistId */ .ZP.actions.setCurrentwatchlistId({
                            watchlistId: data.watchlist_id
                        }));
                        dispatch(_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.toggleViewType */ .ZP.actions.toggleViewType({
                            listType: "company"
                        }));
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // delete selected watchlist
    deleteSelectedWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/DELETE_SELECTED_WATCHLIST"), function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var _watchlistid, watchlistid, activeWatchlistId, dispatch, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _watchlistid = param.watchlistid, watchlistid = _watchlistid === void 0 ? null : _watchlistid, activeWatchlistId = param.activeWatchlistId, dispatch = param1.dispatch;
                        if (watchlistid) {
                            _ctx.next = 3;
                            break;
                        }
                        throw new Error("Watchlist id should be provided");
                    case 3:
                        _ctx.next = 5;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_2__/* ["default"].deleteWatchlistById */ .Z.deleteWatchlistById(watchlistid);
                    case 5:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 8;
                            break;
                        }
                        throw new Error("Attempt to delete company watchlist failed");
                    case 8:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 11;
                            break;
                        }
                        throw new Error(error);
                    case 11:
                        if (activeWatchlistId === watchlistid) {
                            dispatch(_slice__WEBPACK_IMPORTED_MODULE_1__/* ["default"].actions.setCurrentwatchlistId */ .ZP.actions.setCurrentwatchlistId({
                                watchlistId: null
                            }));
                        }
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer
var reducers = {
    toggleCreateModal: function(draft) {
        draft.isCreateModalVisible = !draft.isCreateModalVisible;
    },
    toggleDeleteModal: function(draft) {
        draft.isDeleteModalVisible = !draft.isDeleteModalVisible;
    },
    setDeleteId: function(draft, action) {
        draft.watchlistTobeDeleted = action.payload.id;
        draft.isDeleteModalVisible = true;
    }
};
// Extra Reducer for async actions
var extraReducers = function(builder) {
    builder// add new watchlist
    .addCase(effects.createNewWatchlist.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.createNewWatchlist.fulfilled, function(state, action) {
        state.isLoading = false;
        if (action.payload.data) state.saved.push(action.payload.data);
    }).addCase(effects.createNewWatchlist.rejected, function(state, action) {
        state.error = action.error;
    })// get saved watchlists
    .addCase(effects.getSavedWatchlist.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.getSavedWatchlist.fulfilled, function(state, action) {
        state.isLoading = false;
        state.saved = action.payload.data;
    }).addCase(effects.getSavedWatchlist.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.error;
    })// delete watchlist id
    .addCase(effects.deleteSelectedWatchlist.pending, function(state) {
        state.isLoading = true;
    }).addCase(effects.deleteSelectedWatchlist.fulfilled, function(state, action) {
        state.isLoading = false;
        state.isDeleteModalVisible = false;
        state.watchlistTobeDeleted = null;
        if (action.payload.data) {
            state.saved = state.saved.filter(function(x) {
                return x.watchlist_id !== action.payload.data.watchlist_id;
            });
        }
    }).addCase(effects.deleteSelectedWatchlist.rejected, function(state) {
        state.isLoading = false;
        state.isDeleteModalVisible = false;
        state.watchlistTobeDeleted = null;
    });
};
// Slice
var listWatchlistSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "listWatchlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (listWatchlistSlice);


/***/ }),

/***/ 83231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Mb": function() { return /* binding */ symbolSelector; },
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61876);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83384);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44590);
/* harmony import */ var features_orderbook_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51346);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85440);





// libs


// types


var initialState = {
    requestStatus: "idle",
    isSearchbarActive: false,
    offerSectionStatus: "idle",
    symbol: "IHSG",
    name: "Indeks Harga Saham Gabungan",
    lastprice: null,
    change: null,
    percentageChange: null,
    keyword: "",
    searchResult: [],
    ohlc: null,
    offer: null,
    isBidOfferExists: false,
    summary: null,
    priceData: null,
    orderbookPriceData: {},
    error: null,
    previous: 0,
    orderbook: null
};
var reducers = {
    setisSearchbarActive: function(draft, action) {
        draft.isSearchbarActive = action.payload.isOpen;
    },
    setSymbol: function(draft, action) {
        draft.symbol = action.payload.symbol;
    }
};
// selectors
var selfSelector = function(state) {
    return state.mainLayout.watchlist.orderbook;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(selfSelector, function(state) {
    return state;
});
var symbolSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.watchlist.orderbook.symbol;
}, function(state) {
    return state;
});
// thunk actions
var CONTEXT = "ORDERBOOK_WIDGET";
var fetchOrderbook = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/FETCH_ORDERBOOK"), function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var symbol, response, companyResponse, _data, responseData, error, _data1, compData, compError, data, previous, ohlc, isOfferExists, isBidExists, priceData, orderbookPriceData, summary, isBidOfferExists, bid, offer, lastprice, change, percentageChange;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    symbol = param.symbol;
                    _ctx.next = 3;
                    return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getOrderbookPreviewBySymbol */ .Z.getOrderbookPreviewBySymbol(symbol);
                case 3:
                    response = _ctx.sent;
                    _ctx.next = 6;
                    return lib_api_orderbook__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getCompanyInfo */ .Z.getCompanyInfo(symbol);
                case 6:
                    companyResponse = _ctx.sent;
                    _data = response.data, responseData = _data.data, error = _data.error;
                    _data1 = companyResponse.data, compData = _data1.data, compError = _data1.error;
                    data = (0,features_orderbook_utils__WEBPACK_IMPORTED_MODULE_4__/* .transformNewOrderbookListToExisting */ .M6)(responseData);
                    previous = data.previous;
                    if (!(error || compError)) {
                        _ctx.next = 13;
                        break;
                    }
                    throw new Error(error || compError);
                case 13:
                    ohlc = function(param) {
                        var previous = param.previous, change = param.change, percentage_change = param.percentage_change, frequency = param.frequency, open = param.open, high = param.high, low = param.low, fbuy = param.fbuy, volume = param.volume, value = param.value, average = param.average, fsell = param.fsell, close = param.close, lastprice = param.lastprice, symbol = param.symbol, exchange = param.exchange, ara = param.ara, arb = param.arb;
                        return {
                            previous: previous,
                            change: change,
                            percentage_change: percentage_change,
                            frequency: frequency,
                            open: open,
                            high: high,
                            low: low,
                            fbuy: fbuy,
                            volume: volume,
                            value: value,
                            average: average,
                            fsell: fsell,
                            close: close,
                            lastprice: lastprice,
                            symbol: symbol,
                            exchange: exchange,
                            ara: ara,
                            arb: arb
                        };
                    }(data);
                    isOfferExists = Boolean(!!data.offer && typeof data.offer === "object" && Object.keys(data.offer).length > 0);
                    isBidExists = Boolean(!!data.bid && typeof data.bid === "object" && Object.keys(data.bid).length > 0);
                    priceData = null;
                    orderbookPriceData = {};
                    summary = null;
                    isBidOfferExists = isBidExists || isOfferExists;
                    if (isBidOfferExists) {
                        bid = (data === null || data === void 0 ? void 0 : data.bid) || {};
                        offer = (data === null || data === void 0 ? void 0 : data.offer) || {};
                        orderbookPriceData = {
                            bid: bid,
                            offer: offer
                        };
                    }
                    lastprice = numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.lastprice).format("0,0[.]00");
                    change = numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.change).format("0");
                    percentageChange = "".concat(numeral__WEBPACK_IMPORTED_MODULE_1___default()(data.percentage_change).format("0.00"), "%");
                    (0,_store__WEBPACK_IMPORTED_MODULE_5__/* .setValue */ .sO)({
                        key: "liveprice",
                        symbol: data.symbol,
                        type: "update_general_pricedata",
                        value: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, data)
                    });
                    return _ctx.abrupt("return", {
                        isBidOfferExists: isBidOfferExists,
                        ohlc: ohlc,
                        lastprice: lastprice,
                        change: change,
                        percentageChange: percentageChange,
                        name: compData.name,
                        priceData: priceData,
                        summary: summary,
                        previous: previous,
                        orderbookPriceData: orderbookPriceData,
                        orderbook: data
                    });
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var fetchSymbolSuggestions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createAsyncThunk */ .hg)("".concat(CONTEXT, "/FETCH_SUGGESTIONS"), function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var keyword, response, _data, data, error;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    keyword = param.keyword;
                    _ctx.next = 3;
                    return lib_api_search__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getSearchCompany */ .Z.getSearchCompany(keyword);
                case 3:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        company: data.company
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}());
var effects = {
    fetchOrderbook: fetchOrderbook,
    fetchSymbolSuggestions: fetchSymbolSuggestions
};
// thunks reducers
var extraReducers = function(builder) {
    // fetch orderbook details
    builder.addCase(fetchOrderbook.pending, function(draft) {
        draft.requestStatus = "pending";
        draft.error = null;
    }).addCase(fetchOrderbook.fulfilled, function(draft, action) {
        draft.requestStatus = "loaded";
        draft.isBidOfferExists = action.payload.isBidOfferExists;
        draft.ohlc = action.payload.ohlc;
        draft.lastprice = action.payload.lastprice;
        draft.change = action.payload.change;
        draft.percentageChange = action.payload.percentageChange;
        draft.name = action.payload.name;
        draft.priceData = action.payload.priceData;
        draft.summary = action.payload.summary;
        draft.previous = action.payload.previous;
        draft.orderbookPriceData = action.payload.orderbookPriceData;
        draft.orderbook = action.payload.orderbook;
    }).addCase(fetchOrderbook.rejected, function(draft, action) {
        draft.error = action.error;
    })// fetch company suggestions
    .addCase(fetchSymbolSuggestions.pending, function(draft) {
        draft.error = null;
    }).addCase(fetchSymbolSuggestions.fulfilled, function(draft, action) {
        draft.searchResult = action.payload.company;
    }).addCase(fetchSymbolSuggestions.rejected, function(draft, action) {
        draft.error = action.error;
    });
};
var orderbookSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_7__/* .createSlice */ .oM)({
    name: "orderbook",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (orderbookSlice);


/***/ }),

/***/ 85440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ useOrderbookStore; },
/* harmony export */   "sO": function() { return /* binding */ setValue; }
/* harmony export */ });
/* unused harmony exports OrderbookState, setValueBatch */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);




var OrderbookState = {
    liveprice: {}
};
var useOrderbookStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(_set, _get, _store, _storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, OrderbookState);
});
var handleUpdateGeneralPriceData = function(draft, payload, isInit) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft, isInit ? payload : {}), {
        average: payload.average,
        change: payload.change,
        close: payload.close,
        frequency: payload.frequency,
        fsell: payload.fsell,
        high: payload.high,
        id: payload.id,
        lastprice: payload.lastprice,
        low: payload.low,
        open: payload.open,
        percentage_change: payload.percentage_change,
        previous: payload.previous,
        symbol: payload.symbol,
        value: payload.value,
        volume: payload.volume,
        time: payload === null || payload === void 0 ? void 0 : payload.time
    });
};
var handleUpdateOrderbookPriceData = function(draft, payload) {
    if (payload.bid) {
        draft.bid = payload.bid;
    }
    if (payload.offer) {
        draft.offer = payload.offer;
    }
    return draft;
};
var handleUpdateIepIev = function(draft, payload) {
    var ref, ref1;
    draft.iepiev = payload ? (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : draft.iepiev), {
        iep: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref = draft.iepiev) === null || ref === void 0 ? void 0 : ref.iep), {
            raw: payload.iep
        }),
        iev: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, draft === null || draft === void 0 ? void 0 : (ref1 = draft.iepiev) === null || ref1 === void 0 ? void 0 : ref1.iev), {
            raw: payload.iev
        })
    }) : null;
    return draft;
};
var TYPE_SET = {
    "update_general_pricedata_liveprice": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, false);
    },
    "update_orderbook_pricedata_liveprice": function(draft, payload) {
        return handleUpdateOrderbookPriceData(draft, payload);
    },
    "update_general_pricedata": function(draft, payload) {
        return handleUpdateGeneralPriceData(draft, payload, true);
    },
    "update_iepiev": handleUpdateIepIev
};
var setValue = function(param) {
    var key = param.key, value = param.value, symbol = param.symbol, _type = param.type, type = _type === void 0 ? "update_general_pricedata" : _type;
    return useOrderbookStore.setState(function(state) {
        return (0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(state, function(draft) {
            var ref;
            var draftSymbol = ((ref = draft[key]) === null || ref === void 0 ? void 0 : ref[symbol]) || {};
            draft[key][symbol] = TYPE_SET[type](draftSymbol, value);
            return;
        });
    });
};
var setValueBatch = function(payload) {
    return useOrderbookStore.setState(function(state) {
        return produce(state, function(draft) {
            payload.map(function(item) {
                var ref;
                var _payload = item.payload, value = _payload.data, index = _payload.index, type = item.name;
                var draftSymbol = ((ref = draft["liveprice"]) === null || ref === void 0 ? void 0 : ref[index]) || {};
                draft["liveprice"][index] = TYPE_SET[type](draftSymbol, value);
            });
            return draft;
        });
    });
};


/***/ }),

/***/ 78626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "ag": function() { return /* binding */ wlIdSelector; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40872);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61876);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15056);
/* harmony import */ var lib_api_company__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1349);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14229);
/* harmony import */ var _CompanyWatchlist_slice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6767);








// initial state
var initialState = {
    error: null,
    isLoading: false,
    showList: "company",
    suggestions: [],
    watchlistId: null
};
// constants
var CONTEXT = "@sidewidget/Allwatchlist";
var actionType = {
    GET_COMPANY_SUGGESTION: "".concat(CONTEXT, "/GET_COMPANY_SUGGESTION"),
    SAVE_COMPANY_TO_WATCHLIST: "".concat(CONTEXT, "/SAVE_COMPANY_TO_WATCHLIST")
};
// Selectors
var selectSelf = function(state) {
    return state.mainLayout.watchlist.root;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(selectSelf, function(state) {
    return state;
});
var wlIdSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_5__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.watchlist.root.watchlistId;
}, function(state) {
    return state;
});
// Async Actions / Side Effects
var effects = {
    getCompanySuggestions: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.GET_COMPANY_SUGGESTION, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_param) {
            var params, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, _param);
                        _ctx.next = 3;
                        return lib_api_company__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getSearchCompany */ .Z.getSearchCompany(params);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to fetch suggestion company failed");
                    case 6:
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 9;
                            break;
                        }
                        throw new Error(error);
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data.companies
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_param) {
            return _ref.apply(this, arguments);
        };
    }()),
    saveCompanyToWatchlist: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createAsyncThunk */ .hg)(actionType.SAVE_COMPANY_TO_WATCHLIST, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param, param1) {
            var watchlistId, companyid, dispatch, ref, watchlistIdCookie, targetWathclistId, response, _data, data, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        watchlistId = param.watchlistId, companyid = param.companyid, dispatch = param1.dispatch;
                        ref = utils_auth__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUserAccess */ .Z.getUserAccess(), watchlistIdCookie = ref.watchlist_id;
                        targetWathclistId = watchlistId || watchlistIdCookie;
                        if (companyid) {
                            _ctx.next = 5;
                            break;
                        }
                        throw new Error("Company id is not provided");
                    case 5:
                        _ctx.next = 7;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_1__/* ["default"].postFollowCompany */ .Z.postFollowCompany(targetWathclistId, companyid);
                    case 7:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 10;
                            break;
                        }
                        throw new Error("Attempt to follow company failed");
                    case 10:
                        _data = response.data, data = _data.data, error = _data.error_type;
                        if (!error) {
                            _ctx.next = 13;
                            break;
                        }
                        throw new Error(error);
                    case 13:
                        // re-fetch selected watchlist contents
                        dispatch(_CompanyWatchlist_slice__WEBPACK_IMPORTED_MODULE_4__/* .effects.getCompanyWatchlist */ .Sz.getCompanyWatchlist({
                            watchlistId: watchlistId
                        }));
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    toggleViewType: function(draft, action) {
        draft.showList = action.payload.listType;
    },
    setCurrentwatchlistId: function(draft, action) {
        draft.watchlistId = action.payload.watchlistId;
    }
};
// Extra Reducer for async actions
var extraReducers = function(builder) {
    builder// Extra reducers for fetch suggestions
    .addCase(effects.getCompanySuggestions.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.getCompanySuggestions.fulfilled, function(draft, action) {
        draft.isLoading = false;
        draft.suggestions = action.payload.data;
    }).addCase(effects.getCompanySuggestions.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    })// Extra reducers for save company to watchlist
    .addCase(effects.saveCompanyToWatchlist.pending, function(draft) {
        draft.isLoading = true;
    }).addCase(effects.saveCompanyToWatchlist.fulfilled, function(draft) {
        draft.isLoading = false;
    }).addCase(effects.saveCompanyToWatchlist.rejected, function(draft, action) {
        draft.isLoading = false;
        draft.error = action.error;
    });
};
// Slice
var allWatchlistSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_6__/* .createSlice */ .oM)({
    name: "watchlist",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (allWatchlistSlice);


/***/ }),

/***/ 48153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony exports availableMenu, initialState, effects, reducers */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61876);
/* harmony import */ var _SideWidget_BandarDetector_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13180);


// constants
var availableMenu = [
    {
        key: "ALL_WATCHLIST",
        icon: "icon-widget_watchlist",
        text: "Watchlist",
        eventName: "watchlist"
    },
    {
        key: "PRICE_ALERT",
        icon: "icon-widget_alert",
        text: "Price Alert",
        eventName: "price_alert"
    },
    {
        key: "RUNNING_TRADE",
        icon: "icon-widget_runningtrade",
        text: "Running Trade",
        eventName: "running_trade"
    },
    {
        key: "HOTLIST",
        icon: "icon-widget_hotlist",
        text: "Hotlist",
        eventName: "hotlist"
    },
    {
        key: "VALUATION",
        icon: "icon-widget_valuation",
        text: "Valuation",
        eventName: "valuation"
    },
    {
        key: "BANDAR_DETECTOR",
        icon: "icon-widget_bandar",
        text: "Bandar Detector",
        eventName: "bandar_detector"
    }, 
];
// initial state
var initialState = {
    // current: availableMenu[0].key,
    current: null,
    isSideWidgetOpen: false,
    isHeaderMinimized: false,
    isReloginModalOpen: false,
    errorCode: null,
    bandarDetectorActiveKey: _SideWidget_BandarDetector_constants__WEBPACK_IMPORTED_MODULE_0__/* .BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY */ .lA.BROKER_SUMMARY,
    isFromBandarDetector: false
};
// Selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)(function(state) {
    return state.mainLayout.root;
}, function(state) {
    return {
        current: state.current,
        isSideWidgetOpen: state.isSideWidgetOpen,
        isReloginModalOpen: state.isReloginModalOpen,
        isHeaderMinimized: state.isHeaderMinimized,
        errorCode: state.errorCode,
        bandarDetectorActiveKey: state.bandarDetectorActiveKey
    };
});
// Async Actions / Side Effects
var effects = {};
// Reducer
var reducers = {
    setActiveWidget: function(draft, action) {
        if (draft.isSideWidgetOpen && action.payload.key === draft.current && !action.payload.isFromBandarDetector) {
            draft.current = null;
            draft.isSideWidgetOpen = false;
        } else {
            draft.current = action.payload.key;
            draft.isSideWidgetOpen = true;
        }
        if (action.payload.key === availableMenu[5].key) {
            if (action.payload.bandarDetectorActiveKey) {
                draft.bandarDetectorActiveKey = action.payload.bandarDetectorActiveKey;
            } else {
                draft.bandarDetectorActiveKey = _SideWidget_BandarDetector_constants__WEBPACK_IMPORTED_MODULE_0__/* .BANDAR_DETECTOR_MENU_KEY.BROKER_SUMMARY */ .lA.BROKER_SUMMARY;
            }
        }
    },
    setErrorCode: function(state, action) {
        state.errorCode = action.payload;
        state.isReloginModalOpen = true;
    },
    setHeaderMinimized: function(state, action) {
        state.isHeaderMinimized = action.payload;
    },
    resetState: function(state) {
        state.current = null;
        state.isSideWidgetOpen = false;
        state.isHeaderMinimized = false;
        state.isReloginModalOpen = false;
        state.errorCode = null;
    }
};
// Extra Reducer
var extraReducers = {};
// Slice
var mainSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
    name: "mainLayout",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (mainSlice);


/***/ }),

/***/ 77667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fi": function() { return /* binding */ showAlertNotification; },
  "Ac": function() { return /* binding */ showChatNotification; },
  "uw": function() { return /* binding */ showGeneralNotification; }
});

// UNUSED EXPORTS: createPush

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/chat/LeftSidebar/ChatRooms/RoomItemAvatar.tsx
var RoomItemAvatar = __webpack_require__(92235);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 1 modules
var notification = __webpack_require__(13448);
// EXTERNAL MODULE: ./node_modules/push.js/bin/push.min.js
var push_min = __webpack_require__(28874);
var push_min_default = /*#__PURE__*/__webpack_require__.n(push_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/features/chat/constant.ts
var constant = __webpack_require__(52288);
// EXTERNAL MODULE: ./src/features/chat/utils.ts
var utils = __webpack_require__(33037);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./node_modules/react-string-replace-recursively/index.js
var react_string_replace_recursively = __webpack_require__(54253);
var react_string_replace_recursively_default = /*#__PURE__*/__webpack_require__.n(react_string_replace_recursively);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/global/Notification/utils.ts



var parseNotificationMessage = function(text, maskedHtml) {
    var parseHtmlMask = function(mask) {
        if (Array.isArray(maskedHtml)) {
            var parsed = mask.reduce(function(obj, curr) {
                // eslint-disable-next-line no-param-reassign
                obj[curr.mask] = curr;
                return obj;
            }, {});
            return parsed;
        }
        return mask;
    };
    var parsedText = (0,stream/* parseEmoji */.qm)(text);
    var parsedHtml = parseHtmlMask(maskedHtml);
    var config = {
        breaks: {
            pattern: /(\n|\r\n)/g,
            matcherFn: function() {
                return react.createElement("br");
            }
        },
        symbols: {
            pattern: /(\[%[a-z0-9_]*%\])/gi,
            textFn: function(text) {
                var cleanedSymbol = text.match(/\w+/g);
                return cleanedSymbol;
            },
            matcherFn: function(rawText) {
                var htmlData = parsedHtml[rawText];
                var _attr = htmlData.attr, attr = _attr === void 0 ? {} : _attr, _$text = htmlData.text, tag = htmlData.tag;
                return react.createElement(tag, {}, _$text);
            }
        }
    };
    parsedText = react_string_replace_recursively_default()(config)(parsedText);
    return parsedText;
};


;// CONCATENATED MODULE: ./src/global/Notification/index.tsx
/* eslint-disable import/prefer-default-export */ 











var Avatar = ui/* Common.Avatar */.Gn.Avatar;
var prefix = "".concat(app/* assetPrefix */.Vc, "/images");
function createPush() {
    var title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Stockbit", msg = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", ref = arguments.length > 2 ? arguments[2] : void 0, tag = ref.tag, timeout = ref.timeout, icon = ref.icon, callBack = arguments.length > 3 ? arguments[3] : void 0;
    if (!(push_min_default())) throw new Error("push js not exists");
    var configuration = {
        body: msg,
        timeout: 4000,
        onClick: callBack
    };
    if (tag) configuration.tag = tag;
    if (timeout) configuration.timeout = timeout;
    if (icon) configuration.icon = icon;
    push_min_default().create(title, configuration);
}
var showChatNotification = function(param) {
    var title = param.title, description = param.description, isDeactivate = param.isDeactivate, name = param.name, shortName = param.shortName, type = param.type, avatar = param.avatar, id = param.id, _key = param.key, key = _key === void 0 ? "open".concat(Date.now()) : _key, isPersonalChat = param.isPersonalChat, isInvitedChat = param.isInvitedChat, onClose = param.onClose;
    var handleClick = function() {
        notification/* default.close */.Z.close(key);
        var url = new URL("".concat(window.location.origin));
        switch(type){
            case "ROOM_TYPE_GROUP":
                url.pathname = "".concat(app/* PROJECT_FOLDER_PATH */.qV, "/group-chat/").concat(id);
                break;
            case "ROOM_TYPE_BROADCAST":
                url.pathname = "".concat(app/* PROJECT_FOLDER_PATH */.qV, "/broadcast-chat/").concat(id);
                break;
            case "ROOM_TYPE_PERSONAL":
            default:
                url.pathname = "".concat(app/* PROJECT_FOLDER_PATH */.qV, "/chat/").concat(id);
                break;
        }
        window.open(url, "_blank");
    };
    if (!router_default().asPath.includes(id)) {
        // browser push notification
        if (document.hidden) {
            var optional = {
                tag: "notif_chatv2_".concat(id),
                timeout: 4000,
                icon: "".concat(prefix, "/stockbitlogo-notification.png")
            };
            var pushNotifAction = function() {
                var baseURL = "".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV);
                var pathName = isPersonalChat ? "chat" : "group-chat";
                // accepted room chat
                var urlPushNotif = "".concat(baseURL, "/").concat(pathName, "/").concat(id, "?source=").concat(constant/* CHAT_PUSH_NOTIFICATION_INDEX */.bg);
                // requested room chat
                if (isInvitedChat) {
                    urlPushNotif = "".concat(baseURL, "/").concat(pathName, "/").concat(id, "?type=request&source=").concat(constant/* CHAT_PUSH_NOTIFICATION_INDEX */.bg);
                }
                window.focus();
                window.open(urlPushNotif, "_blank");
            };
            return createPush(title, description, optional, function() {
                pushNotifAction();
                if (this && typeof this.close === "function") this.close();
            });
        }
        notification/* default.open */.Z.open({
            key: key,
            className: "float-chat-notification",
            placement: "bottomLeft",
            message: title,
            description: (0,utils/* removeFormat */.Ir)(description),
            duration: 7,
            onClick: handleClick,
            onClose: onClose,
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RoomItemAvatar/* default */.Z, {
                isDeactive: isDeactivate,
                name: name,
                shortName: shortName,
                type: type,
                src: avatar
            })
        });
    }
    return null;
};
var showGeneralNotification = function(notifData, onClose) {
    var ref, ref1;
    var baseURL = "".concat(window.location.origin).concat(app/* PROJECT_FOLDER_PATH */.qV);
    var actionUrl = "";
    var showNotif = true;
    var message = "Stockbit"; // default message
    var icon = "";
    var textValue = "";
    var maskedHtml = notifData === null || notifData === void 0 ? void 0 : (ref = notifData.data) === null || ref === void 0 ? void 0 : ref.message_mask;
    if (showNotif && (notifData === null || notifData === void 0 ? void 0 : (ref1 = notifData.data) === null || ref1 === void 0 ? void 0 : ref1.avatar)) {
        icon = notifData.data.avatar;
    }
    if (maskedHtml) {
        // get the username
        textValue = Object.keys(maskedHtml).reduce(function(_, curr) {
            return maskedHtml ? "".concat(maskedHtml[curr].text) : "";
        }, "");
    }
    switch(parseInt(notifData.type, 10)){
        case 3:
            // Go to user profile
            actionUrl = "/".concat(notifData.data.link_to.identifier);
            break;
        case 4:
            // Go to company page
            actionUrl = "/symbol/".concat(notifData.data.link_to.identifier);
            break;
        case 2:
        case 5:
        case 6:
        case 7:
        case 9:
        case 12:
            // Go to post page
            actionUrl = "/post/".concat(notifData.data.link_to.identifier);
            break;
        // case '22':
        case 21:
        case 23:
            actionUrl = "/tip/".concat(notifData.data.link_to.identifier);
            break;
        case 42:
            showNotif = true;
            if (textValue) {
                actionUrl = "".concat(baseURL, "/community?search=").concat(textValue);
            } else {
                actionUrl = "".concat(baseURL, "/community");
            }
            message = "External Community";
            icon = "/images/stockbit-bubble-white.png";
            break;
        case 44:
        case 45:
            actionUrl = "/securities/portfolio";
            break;
        default:
            actionUrl = "";
            break;
    }
    if (showNotif) {
        var messageText = notifData.data.message;
        var parsedText = parseNotificationMessage(messageText, maskedHtml);
        notification/* default.open */.Z.open({
            key: "notification-".concat(notifData.id),
            className: "float-general-notification",
            placement: "bottomLeft",
            message: message,
            description: parsedText,
            duration: 7,
            onClose: onClose,
            onClick: function() {
                return window.open(actionUrl, "_blank");
            },
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                size: "medium",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: icon,
                    onError: function(e) {
                        return (0,general/* handleErrorAvatar */.Tk)(e, "Stockbit");
                    },
                    style: {
                        width: "48px",
                        height: "48px"
                    }
                })
            })
        });
    }
};
var showAlertNotification = function(notifData, onClose) {
    notification/* default.open */.Z.open({
        key: "notification-".concat(notifData === null || notifData === void 0 ? void 0 : notifData.alert_id),
        className: "float-alert-notification",
        placement: "bottomLeft",
        message: "Stockbit",
        description: notifData === null || notifData === void 0 ? void 0 : notifData.msg,
        duration: 7,
        onClose: onClose,
        onClick: function() {
            return notification/* default.close */.Z.close("notification-".concat(notifData === null || notifData === void 0 ? void 0 : notifData.alert_id));
        },
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: 71,
                height: 71
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/stockbit-logo-notif.png",
                onError: function(e) {
                    return (0,general/* handleErrorAvatar */.Tk)(e, "Stockbit");
                },
                style: {
                    objectFit: "contain"
                }
            })
        })
    });
};



/***/ }),

/***/ 46895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useSecuritiesContext; },
/* harmony export */   "i": function() { return /* binding */ SecuritiesContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SecuritiesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isAuthorized: false,
    token: undefined,
    socket: undefined,
    setChannel: function() {},
    setAction: function() {},
    removeAction: function() {}
});
var useSecuritiesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SecuritiesContext);
    if (context === undefined) {
        throw new Error("useSecuritiesContext must be used within a SecuritiesProvider");
    }
    return context;
};



/***/ }),

/***/ 93313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ ERROR_CODE; },
/* harmony export */   "FJ": function() { return /* binding */ SecuritiesMessageCase; },
/* harmony export */   "S0": function() { return /* binding */ DATA_ACTION; },
/* harmony export */   "aG": function() { return /* binding */ RECONNECT_INTERVAL; },
/* harmony export */   "al": function() { return /* binding */ HEARTBEAT_INTERVAL; },
/* harmony export */   "pm": function() { return /* binding */ MAX_RECONNECT_ATTEMPTS; }
/* harmony export */ });
var RECONNECT_INTERVAL = 30000; // 30 seconds
var HEARTBEAT_INTERVAL = 15000; // 15 seconds
var MAX_RECONNECT_ATTEMPTS = 3;
var SecuritiesMessageCase = {
    SUMMARY: "portfolioSummary",
    PORTFOLIO_LIST: "portfolioList",
    PORTFOLIO_DETAIL: "portfolioDetail",
    PORTFOLIO_DETAIL_DAY_TRADE: "portfolioDetailDayTrade",
    ORDER_LIST: "orderList",
    ORDER_DETAIL: "orderDetail"
};
var DATA_ACTION = {
    UPSERT: 1,
    DELETE: 2
};
var ERROR_CODE;
(function(ERROR_CODE) {
    ERROR_CODE[ERROR_CODE["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    ERROR_CODE[ERROR_CODE["FORBIDDEN"] = 403] = "FORBIDDEN";
    ERROR_CODE[ERROR_CODE["NOT_FOUND"] = 404] = "NOT_FOUND";
    ERROR_CODE[ERROR_CODE["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
})(ERROR_CODE || (ERROR_CODE = {}));


/***/ }),

/***/ 28840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ useSecuritiesStore; }
/* harmony export */ });
/* unused harmony exports securitiesState, securitiesActions */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12902);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14671);





var securitiesState = {
    channel: {},
    isReconnectionFailed: false,
    isSocketOnline: false
};
var securitiesActions = function(set) {
    return {
        setChannel: function(key, value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.channel = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, draft.channel), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, key, value));
                });
            });
        },
        setIsReconnectionFailed: function(value) {
            set(function(state) {
                return (0,immer__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(state, function(draft) {
                    draft.isReconnectionFailed = value;
                });
            });
        },
        setIsSocketOnline: function(isSocketOnline) {
            set({
                isSocketOnline: isSocketOnline
            });
        }
    };
};
var useSecuritiesStore = (0,zustand__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(set, get, store, storeMutation) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, securitiesState, securitiesActions(set, get, store, storeMutation));
});


/***/ }),

/***/ 17985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jd": function() { return /* binding */ SecuritiesChannel; },
/* harmony export */   "e7": function() { return /* binding */ PayloadCase; }
/* harmony export */ });
/* unused harmony exports RequestCommand, RequestChannel */
var SecuritiesChannel;
(function(SecuritiesChannel) {
    SecuritiesChannel["PING"] = "ping";
    SecuritiesChannel["AUTH"] = "auth";
    SecuritiesChannel["SECURITIES"] = "securities";
})(SecuritiesChannel || (SecuritiesChannel = {}));
var PayloadCase;
(function(PayloadCase) {
    PayloadCase["COMMAND"] = "command";
    PayloadCase["SUBSCRIBE"] = "subscribe";
    PayloadCase["UNSUBSCRIBE"] = "unsubscribe";
})(PayloadCase || (PayloadCase = {}));
var RequestCommand;
(function(RequestCommand) {
    RequestCommand[RequestCommand["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestCommand[RequestCommand["PING"] = 1] = "PING";
    RequestCommand[RequestCommand["AUTH"] = 2] = "AUTH";
})(RequestCommand || (RequestCommand = {}));
var RequestChannel;
(function(RequestChannel) {
    RequestChannel[RequestChannel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    RequestChannel[RequestChannel["SECURITIES_LIVE_PORTO"] = 1] = "SECURITIES_LIVE_PORTO";
})(RequestChannel || (RequestChannel = {}));


/***/ }),

/***/ 46238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c$": function() { return /* binding */ createPingPayload; },
/* harmony export */   "cH": function() { return /* binding */ getAccountNumber; },
/* harmony export */   "y_": function() { return /* binding */ generateWSCookie; }
/* harmony export */ });
/* unused harmony exports createUint8Array, createSubscribePayload, createUnsubscribePayload */
/* harmony import */ var utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11763);
/* harmony import */ var _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17985);


var getAccountNumber = function() {
    var accountNumber = utils_securitiesLocalStorage__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getSecuritiesAccountInfo */ .Z.getSecuritiesAccountInfo().accountNumber;
    return accountNumber !== null && accountNumber !== void 0 ? accountNumber : null;
};
var createUint8Array = function(value) {
    var textEncoder = new TextEncoder();
    return textEncoder.encode(value);
};
var createPingPayload = function() {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.COMMAND */ .e7.COMMAND,
            value: 1
        },
        value: new Uint8Array()
    };
};
var createSubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.SUBSCRIBE */ .e7.SUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var createUnsubscribePayload = function(accountNumber) {
    return {
        action: {
            case: _store_securities_store_types__WEBPACK_IMPORTED_MODULE_1__/* .PayloadCase.UNSUBSCRIBE */ .e7.UNSUBSCRIBE,
            value: 1
        },
        value: createUint8Array(accountNumber)
    };
};
var generateWSCookie = function(value) {
    return "gen-websocket=".concat(value, "; domain=stockbit.com; path=/v1; Secure;");
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    createPingPayload: createPingPayload,
    createSubscribePayload: createSubscribePayload,
    createUnsubscribePayload: createUnsubscribePayload,
    generateWSCookie: generateWSCookie
});


/***/ }),

/***/ 33908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);




// Action type
var CONTEXT = "@global/searchCompany";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: []
};
var searchCompanyState = function(state) {
    return state.searchCompany;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(searchCompanyState, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result
    };
}, function(state) {
    return state;
});
// Effects
var effects = {
    getSearchResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(keyword) {
            var response;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearch */ .Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    resetResult: function(state) {
        state.result = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state, action) {
        state.isLoading = true;
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        var ref, ref1;
        state.result = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.company;
        state.isLoading = false;
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload;
    });
};
// Slice
var searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "searchCompany",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (searchSlice);


/***/ }),

/***/ 29962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ UnleashContext; },
  "d": function() { return /* binding */ UnleashProvider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/utils/auth.js
var auth = __webpack_require__(14229);
// EXTERNAL MODULE: ./src/global/Unleash/store.ts + 1 modules
var store = __webpack_require__(18763);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(45785);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(76166);
// EXTERNAL MODULE: ./node_modules/unleash-proxy-client/build/index.js
var build = __webpack_require__(14009);
;// CONCATENATED MODULE: ./src/global/Unleash/UnleashInstance.ts








var UnleashInstance = /*#__PURE__*/ function(UnleashClient) {
    "use strict";
    (0,_inherits/* default */.Z)(UnleashInstance, UnleashClient);
    var _super = (0,_create_super/* default */.Z)(UnleashInstance);
    function UnleashInstance(config) {
        (0,_class_call_check/* default */.Z)(this, UnleashInstance);
        var _this;
        _this = _super.call(this, config);
        _this.isAlive = false;
        return _this;
    }
    var _proto = UnleashInstance.prototype;
    _proto.start = function start() {
        var _this = this;
        var _this1 = this, _superprop_get_start = function() {
            return (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(UnleashInstance.prototype), "start", _this);
        };
        return (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _superprop_get_start().call(_this1);
                    case 2:
                        _this1.isAlive = true;
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.stop = function stop() {
        (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(UnleashInstance.prototype), "stop", this).call(this);
        this.isAlive = false;
    };
    return UnleashInstance;
}(build.UnleashClient);

;// CONCATENATED MODULE: ./src/global/Unleash/index.tsx








var UnleashContext = /*#__PURE__*/ (0,react.createContext)(undefined);
var UnleashProvider = function(param) {
    var isLoggedIn = param.isLoggedIn, userId = param.userId, children = param.children;
    var unleashInstance = (0,react.useRef)(new UnleashInstance(app/* PROXY_CLIENT_CONFIG */.X$));
    var ref = (0,store/* default */.Z)(), setAllFlagValue = ref.setAllFlagValue, setReady = ref.setReady;
    var getUserId = (0,react.useCallback)(function() {
        var ref;
        if (!isLoggedIn) return null;
        //  @ts-ignore: Property 'id' does not exist on type 'string'.
        return userId || ((ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.id);
    }, [
        userId,
        isLoggedIn
    ]);
    var updateUnleashUserId = (0,react.useCallback)(function() {
        unleashInstance.current.setContextField("userId", getUserId());
    }, [
        getUserId
    ]);
    var stopUnleash = function() {
        unleashInstance.current.stop();
        updateUnleashUserId();
    };
    var startUnleash = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!unleashInstance.current.isAlive) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        updateUnleashUserId();
                        unleashInstance.current.on("ready", function() {
                            setReady(true);
                            setAllFlagValue(unleashInstance.current);
                        });
                        unleashInstance.current.on("update", function() {
                            setAllFlagValue(unleashInstance.current);
                        });
                        _ctx.next = 7;
                        return unleashInstance.current.start();
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function startUnleash() {
            return _ref.apply(this, arguments);
        };
    }();
    // Update user id when side-effects triggered
    (0,react.useEffect)(function() {
        updateUnleashUserId();
    }, [
        updateUnleashUserId
    ]);
    (0,react.useEffect)(function() {
        startUnleash();
        return function() {
            stopUnleash();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UnleashContext.Provider, {
        value: unleashInstance.current,
        children: children
    });
};


/***/ }),

/***/ 18763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./src/constants/featureFlags.ts
/* harmony default export */ var featureFlags = ({
    CHARTBIT_MAINTENANCE_WARNING: "chartbit_maintenance_warning",
    CHARTBIT_MAINTENANCE_ON: "chartbit_maintenance_on",
    CHARTBIT_DISABLE_AUTOSAVE: "chartbit_disable_autosave",
    CHARTBIT_IFRAME_LOGGING: "chartbit_iframe_logging",
    CHARTBIT_DEBUG: "chartbit_debug"
});

// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
;// CONCATENATED MODULE: ./src/global/Unleash/store.ts






var initialState = {
    flagList: Object.values(featureFlags).reduce(function(prev, curr) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, curr, false));
    }, {}),
    isReady: false
};
var actions = function(set) {
    return {
        setReady: function(value) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    draft.isReady = value;
                });
            });
        },
        setAllFlagValue: function(instance) {
            set(function(state) {
                return (0,immer_esm/* default */.ZP)(state, function(draft) {
                    Object.values(featureFlags).forEach(function(key) {
                        draft.flagList[key] = instance.isEnabled(key);
                    });
                });
            });
        }
    };
};
var useFeatureFlagStore = (0,esm/* default */.ZP)(function(set, get, store, storeMutation) {
    return (0,_object_spread/* default */.Z)({}, initialState, actions(set, get, store, storeMutation));
});
/* harmony default export */ var store = (useFeatureFlagStore);


/***/ }),

/***/ 23985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$4": function() { return /* binding */ wsKeySelector; },
/* harmony export */   "Fy": function() { return /* binding */ streamWsSelector; },
/* harmony export */   "Nw": function() { return /* binding */ actions; },
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "i9": function() { return /* binding */ notifWsSelector; },
/* harmony export */   "m5": function() { return /* binding */ alertWsSelector; },
/* harmony export */   "mD": function() { return /* binding */ wsStatusSelector; }
/* harmony export */ });
/* unused harmony exports selectors, channelsSelector, websocketListeningSelector, actionType */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36305);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(61876);
/* harmony import */ var lib_api_ws__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66679);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14229);
/* harmony import */ var utils_webSocket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92953);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2497);
/* harmony import */ var global_Notification__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77667);
/* harmony import */ var global_MainLayout_SideWidget_PriceAlert_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16835);
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-plusplus */ /* eslint-disable no-console */ 







// APIs


// Utils





var PRICE_ALERT_KEY = "price-alert";
var setPriceAlertToLocalStorage = function(alert) {
    try {
        var ref;
        window === null || window === void 0 ? void 0 : (ref = window.localStorage) === null || ref === void 0 ? void 0 : ref.setItem(PRICE_ALERT_KEY, JSON.stringify(alert));
        return true;
    } catch (e) {
        return false;
    }
};
// Initial state
var initialState = {
    wskey: null,
    status: "3",
    auth: 0,
    listening: false,
    livedata_channels: {
        stream: [],
        company: [],
        orderbook: [],
        hotlist: false
    },
    // socket data may be wrong, dependent on how it will be used
    // feel free to adjust it
    socket_data: {
        stream: null,
        notification: [],
        alert: null
    }
};
var wsSelector = function(state) {
    return state.websocket;
};
// selectors
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(wsSelector, function(ws) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, ws);
});
var wsKeySelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.wskey;
}, function(state) {
    return state;
});
var notifWsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.socket_data.notification;
}, function(state) {
    return state;
});
var alertWsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.socket_data.alert;
}, function(state) {
    return state;
});
var channelsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.livedata_channels;
}, function(state) {
    return state;
});
var websocketListeningSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.listening;
}, function(state) {
    return state;
});
var wsStatusSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.status;
}, function(state) {
    return state;
});
var streamWsSelector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_8__/* .createSelector */ .P1)(function(state) {
    return state.websocket.socket_data.stream;
}, function(state) {
    return state;
});
// Actions
var CONTEXT = "@redux/websocket";
var actionType = {
    INIT_WEBSOCKET: "".concat(CONTEXT, "/INIT_WEBSOCKET"),
    INIT_LISTEN_DATA: "".concat(CONTEXT, "/INIT_LISTEN_DATA"),
    INIT_CONFIG: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/INIT_CONFIG")),
    UPDATE_ACTIVE_STATUS: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/UPDATE_ACTIVE_STATUS")),
    UPDATE_CHANNELS_CONFIG: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/UPDATE_CHANNELS_CONFIG")),
    ADD_SOCKET_DATA: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAction */ .PH)("".concat(CONTEXT, "/ADD_SOCKET_DATA"))
};
var actions = actionType;
// API actions
var getWskey = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var response, _data, _$error, message, data, wsKey;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return lib_api_ws__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getWSKey */ .Z.getWSKey();
                case 3:
                    response = _ctx.sent;
                    if (response.data) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("Attempt to get wskey failed");
                case 6:
                    _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                    if (!_$error) {
                        _ctx.next = 9;
                        break;
                    }
                    // @ts-ignore
                    throw new Error({
                        error: _$error,
                        message: message
                    });
                case 9:
                    wsKey = utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].convertWSKeyArray */ .Z.convertWSKeyArray(data.key);
                    utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].setLocalWskey */ .Z.setLocalWskey(wsKey);
                    return _ctx.abrupt("return", wsKey);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](0);
                    console.error(_ctx.t0);
                    return _ctx.abrupt("return", null);
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                14
            ]
        ]);
    }));
    return function getWskey() {
        return _ref.apply(this, arguments);
    };
}();
// effects
var attempt = 0;
var effects = {
    initWebsocket: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.INIT_WEBSOCKET, /**
     * Initiate websocket
     * @param {Object} param
     * @param {Object} param.primus - primus
     * @param {boolean} param.isUserLogin - flag if user is logged in
     */ // @ts-ignore
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var primus, ref, dispatch, getState, ref1, _entities, _credentials, isUserLogin, status, parsedCookie, token, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    primus = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null, ref = _args.length > 1 ? _args[1] : void 0, dispatch = ref.dispatch, getState = ref.getState;
                    ref1 = getState(), _entities = ref1.// @ts-ignore
                    entities, _credentials = _entities.credentials, isUserLogin = _credentials.isLoggedIn, // @ts-ignore
                    status = ref1.websocket.status;
                    parsedCookie = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                    token = parsedCookie.accessToken.token;
                    if (!(primus === null || !isUserLogin || !token)) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error("No websocket active");
                case 6:
                    if (token) {
                        // @ts-ignore
                        primus.on("open", function() {
                            console.log("Initiate websocket connection");
                            var cookie = utils_auth__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getToken */ .Z.getToken();
                            var _accessToken = cookie.accessToken, accessToken = _accessToken.token;
                            if (accessToken) {
                                getWskey().then(function(key) {
                                    if (Array.isArray(key)) {
                                        var _key = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(key, 1), useWsKey = _key[0];
                                        // @ts-ignore
                                        dispatch(actionType.INIT_CONFIG({
                                            primus: primus,
                                            wskey: useWsKey
                                        }));
                                        console.log("Connection socket is alive and kicking");
                                    // on connection open, get websocket key
                                    // every time we refresh the page we will re-fetch ws key
                                    // thus we always get wskey from api
                                    }
                                });
                            }
                            return true;
                        });
                        // @ts-ignore
                        primus.on("end", function(e) {
                            console.warn("Web Socket is dying, re-open another connection after 3 second");
                            console.log("Web Socket is dying");
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            // update status
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                            return false;
                        });
                        // @ts-ignore
                        primus.on("reconnect", function() {
                            console.info("Web Socket trying to reconnect ".concat(attempt++));
                            console.log("Web Socket reconnecting");
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                            // Close primus connection if attempt reconnection >= 3 times
                            if (attempt >= 3) {
                                // @ts-ignore
                                primus.end();
                            }
                        });
                        // @ts-ignore
                        primus.on("reconnected", function() {
                            console.info("Web Socket reconnected!");
                        });
                        // @ts-ignore
                        primus.on("reconnect failed", function() {
                            console.info("Web Socket failed to reconnect");
                            console.log("Web Socket reconnect failed");
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                        });
                        // @ts-ignore
                        primus.on("error", function(e) {
                            console.error("Web Socket unexpectedly error , here's the message ", e);
                            console.log("Web Socket unexpectedly error");
                            var onlineStatus = window.navigator.onLine ? "2" : "1";
                            if (status !== onlineStatus) {
                                // @ts-ignore
                                dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                            }
                        });
                    }
                    return _ctx.abrupt("return", true);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    initListenData: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createAsyncThunk */ .hg)(actionType.INIT_LISTEN_DATA, // @ts-ignore
    (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var primus, ref, dispatch, getState, ref1, _websocket, statusWebsocket, currentPages, batchPages, isBatch, batchOperation, INTERVAL_DURATION, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    primus = _args.length > 0 && _args[0] !== void 0 ? _args[0] : null, ref = _args.length > 1 ? _args[1] : void 0, dispatch = ref.dispatch, getState = ref.getState;
                    if (primus) {
                        _ctx.next = 3;
                        break;
                    }
                    return _ctx.abrupt("return", false);
                case 3:
                    ref1 = getState(), _websocket = ref1.// @ts-ignore
                    websocket, statusWebsocket = _websocket.status;
                    currentPages = (next_router__WEBPACK_IMPORTED_MODULE_4___default().asPath);
                    batchPages = [
                        "catalog",
                        "sector",
                        "stream"
                    ];
                    isBatch = batchPages.some(function(item) {
                        return currentPages.includes(item);
                    });
                    batchOperation = [];
                    INTERVAL_DURATION = 700;
                    if (currentPages.includes("watchlist")) {
                        INTERVAL_DURATION = 200;
                    }
                    if (isBatch) {
                        setInterval(function() {
                            if (batchOperation.length > 0) {
                                (0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .batch */ .dC)(function() {
                                    batchOperation.map(function(action) {
                                        return dispatch(action);
                                    });
                                    batchOperation = [];
                                });
                            }
                        }, INTERVAL_DURATION);
                    }
                    // @ts-ignore
                    primus.on("data", function() {
                        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
                            var ref, authtext, onlineStatus, alert;
                            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        ;
                                        if (statusWebsocket !== "3" && data.__i) {
                                            authtext = data.__i.toLowerCase();
                                            if (authtext === "auth_ok") {
                                                console.log("==== AUTH_OK! ====");
                                                // @ts-ignore
                                                dispatch(actionType.UPDATE_ACTIVE_STATUS("3"));
                                            }
                                        }
                                        if (statusWebsocket === "3" && data.__e) {
                                            if (data.__e.includes("Unauthorized Connection")) {
                                                onlineStatus = window.navigator.onLine ? "2" : "1";
                                                // @ts-ignore
                                                if (statusWebsocket !== onlineStatus) {
                                                    // @ts-ignore
                                                    dispatch(actionType.UPDATE_ACTIVE_STATUS(onlineStatus));
                                                }
                                            }
                                        }
                                        if (((ref = data.S) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                            dispatch(// @ts-ignore
                                            actionType.ADD_SOCKET_DATA({
                                                stream: data.S[0]
                                            }));
                                        }
                                        if (data.A) {
                                            alert = data.A;
                                            dispatch(// @ts-ignore
                                            actionType.ADD_SOCKET_DATA({
                                                alert: alert
                                            }));
                                            if (alert && alert.msg) {
                                                // eslint-disable-next-line @typescript-eslint/no-empty-function
                                                (0,global_Notification__WEBPACK_IMPORTED_MODULE_6__/* .showAlertNotification */ .fi)(alert, function() {});
                                                dispatch(global_MainLayout_SideWidget_PriceAlert_slice__WEBPACK_IMPORTED_MODULE_7__/* ["default"].actions.setPriceAlert */ .ZP.actions.setPriceAlert(alert));
                                                dispatch(global_MainLayout_SideWidget_PriceAlert_slice__WEBPACK_IMPORTED_MODULE_7__/* .effects.getAlertLog */ .Sz.getAlertLog());
                                                setPriceAlertToLocalStorage(alert);
                                            }
                                        }
                                        if (data.N2) {
                                            dispatch(// @ts-ignore
                                            actionType.ADD_SOCKET_DATA({
                                                notification: data.N2
                                            }));
                                        }
                                    case 6:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(data) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return _ctx.abrupt("return", true);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })))
};
// reducers
var reducers = {
    clearAlert: function(state) {
        state.socket_data.alert = null;
    },
    clearNotification: function(state, action) {
        var newNotification = state.socket_data.notification.filter(function(notif) {
            return notif.id !== action.payload;
        });
        state.socket_data.notification = newNotification;
    },
    resetNotification: function(state) {
        state.socket_data.notification = [];
    },
    setAlert: function(state, action) {
        state.socket_data.alert = action.payload;
    }
};
// Extra reducers
var extraReducers = function(builder) {
    builder.addCase(actionType.INIT_CONFIG, function(state, action) {
        var _payload = action.payload, primus = _payload.primus, wskey = _payload.wskey;
        var currentState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state);
        state.wskey = wskey;
        state.status = "3";
        // initiate config to ws
        utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].initConfig */ .Z.initConfig(primus, currentState, wskey);
    }).addCase(actionType.INIT_LISTEN_DATA, function(state) {
        state.listening = true;
    }).addCase(actionType.UPDATE_ACTIVE_STATUS, function(state, action) {
        var status = action.payload;
        if (state.status !== status) {
            state.status = status;
        }
    })// update current live channels config
    .addCase(actionType.UPDATE_CHANNELS_CONFIG, function(state, action) {
        var newChannelsConfig = action.payload;
        var currentState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state);
        var _livedata_channels = currentState.livedata_channels, orderbook = _livedata_channels.orderbook, company = _livedata_channels.company;
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.livedata_channels, newChannelsConfig);
        // TODO: Improve state update from multiple components
        if (Array.isArray(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.company)) {
            var newCompanies = Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(company).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.company))));
            newState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, newState), {
                company: newCompanies
            });
        }
        if (Array.isArray(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.orderbook)) {
            var newOrderbook = Array.from(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(orderbook).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(newChannelsConfig === null || newChannelsConfig === void 0 ? void 0 : newChannelsConfig.orderbook))));
            newState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, newState), {
                orderbook: newOrderbook
            });
        }
        var shouldUpdateConfig = utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateGeneralWsConfig */ .Z.updateGeneralWsConfig(currentState, newState);
        var updatedChannel = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.livedata_channels, shouldUpdateConfig || {});
        if (shouldUpdateConfig) {
            state.livedata_channels = updatedChannel;
        }
        // update and write websocket
        utils_webSocket__WEBPACK_IMPORTED_MODULE_3__/* ["default"].updateConfig */ .Z.updateConfig(window === null || window === void 0 ? void 0 : window.primus, updatedChannel, currentState.wskey);
    }).addCase(actionType.ADD_SOCKET_DATA, function(state, action) {
        var _payload = action.payload, notification = _payload.notification, socketData = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_payload, [
            "notification"
        ]);
        if (notification) {
            if (!state.socket_data.notification.find(function(notif) {
                return notif.id === notification.id;
            })) {
                state.socket_data.notification = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(state.socket_data.notification).concat([
                    notification, 
                ]);
            }
        }
        state.socket_data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, state.socket_data, socketData);
    });
};
var webSocketSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSlice */ .oM)({
    name: "websocket",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (webSocketSlice);


/***/ }),

/***/ 56703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97373);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ /* eslint-disable max-len */ 



var alertURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/alert");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getDataPriceAlert = function(params) {
    return request.get("".concat(alertURL, "/status/active"), {
        params: params
    });
};
var getDataAlertLog = function() {
    var statusNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", opt = arguments.length > 1 ? arguments[1] : void 0;
    var status = statusNumber;
    return request.get("".concat(alertURL), {
        params: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, opt), {
            status: status
        })
    });
};
var getDetailAlert = function(alertId) {
    return request.get("".concat(alertURL, "/").concat(alertId));
};
// command is a string of {"stock": [stock], "value": [value], "operator": [opt], "item": "[item]}
var addPriceAlert = function(name, command) {
    var options = {
        name: name,
        command: command
    };
    return request.post("".concat(alertURL), options);
};
var editPriceAlert = function(alertId, name, command) {
    var options = {
        name: name,
        command: command
    };
    return request.put("".concat(alertURL, "/").concat(alertId), options);
};
var cancelPriceAlert = function(id) {
    return request.delete("".concat(alertURL, "/").concat(id));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getDataPriceAlert: getDataPriceAlert,
    getDataAlertLog: getDataAlertLog,
    getDetailAlert: getDetailAlert,
    addPriceAlert: addPriceAlert,
    editPriceAlert: editPriceAlert,
    cancelPriceAlert: cancelPriceAlert
});


/***/ }),

/***/ 99368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O7": function() { return /* binding */ getUnreadNotificationNumber; },
/* harmony export */   "v6": function() { return /* binding */ getNotification; },
/* harmony export */   "zJ": function() { return /* binding */ markAsRead; }
/* harmony export */ });
/* unused harmony exports getNotificationSetting, setNotificationSettings */
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var utils_notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25178);
/* eslint-disable import/named */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 



var request = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
var NOTIFICATION_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/notification");
var NOTIFICATION_READ_V2 = "".concat(NOTIFICATION_URL, "s/read");
var NOTIFICATION_SETTINGS = "".concat(NOTIFICATION_URL, "/settings");
var NOTIFICATION_UNREAD_COUNT_V2 = "".concat(NOTIFICATION_URL, "/count/unread");
/**
 * Get notification
 * @param {Array|null=} types - notification types
 * @param {number|string=} limit - limit
 * @param {number|string=} last_id - last id
 * @returns {APIResponse}
 */ var getNotification = function() {
    var types = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, limit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 25, last_id = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    // Using URLSearchParams to prevent types params converted to ?types[]=any&types[]=any
    // Because it shoulbe ?types=any&types=any
    var params = (0,utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .convertParams */ .h$)({
        types: types,
        limit: limit,
        last_id: last_id
    });
    return request.get("".concat(NOTIFICATION_URL), {
        params: params
    });
};
/**
 * Read unread notification
 * @param {string} type - notification types
 * @returns {APIResponse}
 */ var markAsRead = function() {
    var types = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return request.patch(NOTIFICATION_READ_V2, {
        types: types
    });
};
/**
 * Get notification settings
 * @param {string} type - notification types
 * @param {string} categories - setting categories
 * @returns {APIResponse}
 */ var getNotificationSetting = function(type, categories) {
    return request.get(NOTIFICATION_SETTINGS, {
        params: {
            type: type,
            categories: categories
        }
    });
};
/**
 * Set up notification settings per category
 * @param {string} type - notification types
 * @param {string} category - setting's category
 * @param {boolean} value - setting's category value (true | false)
 * @returns {APIResponse}
 */ var setNotificationSettings = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", category = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", value = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return request.put("".concat(NOTIFICATION_SETTINGS, "/update"), {
        type: type,
        setting: _define_property({}, category, value)
    });
};
/**
 * Get unread notification count
 * @returns {APIResponse}
 */ var getUnreadNotificationNumber = function() {
    var types = utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .notificationTypeUnreadParams */ .Wj;
    var params = (0,utils_notification__WEBPACK_IMPORTED_MODULE_2__/* .convertParams */ .h$)({
        types: types
    });
    return request.get(NOTIFICATION_UNREAD_COUNT_V2, {
        params: params
    });
};


/***/ }),

/***/ 83384:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97373);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37213);
/* eslint-disable import/named */ /* eslint-disable no-undef */ 


var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
// APIs
var ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// EXODUS APIs
var EXODUS_ORDERBOOK_API = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/orderbook");
// Should be replaced with get company orderbook data but the exodus endpoint
// doesn't support special symbols e.g. IHSG
var getOrderbookPreviewBySymbol = function(symbol) {
    return requestExodus.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/company-price-feed/v2/orderbook/companies/").concat(symbol));
};
var getOrderbookList = function() {
    return requestExodus.get(EXODUS_ORDERBOOK_API);
};
var createOrderbookList = function(param) {
    var orderbookName = param.orderbookName;
    return requestExodus.post(EXODUS_ORDERBOOK_API, {
        name: orderbookName
    });
};
var editOrderbookList = function(param) {
    var id = param.id, orderbookName = param.orderbookName, symbols = param.symbols;
    var params = {
        name: orderbookName
    };
    if (symbols) params.symbols = symbols;
    return requestExodus.put("".concat(EXODUS_ORDERBOOK_API, "/").concat(id), params);
};
var deleteOrderbookList = function(param) {
    var id = param.id;
    return requestExodus.delete("".concat(EXODUS_ORDERBOOK_API, "/").concat(id));
};
var getOrderbookListItem = function(id) {
    if (id) {
        return requestExodus.get("/company-price-feed/v2/orderbook/template/".concat(id));
    }
    // Get default orderbook if ID is not passed
    // Harusnya nantinya ada lebih lanjut terkait ini sih, gimana kalo enggak ada ID nya
    return requestExodus.get(ORDERBOOK_API);
};
var getCompanyInfo = function(symbol) {
    var reqDetail = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(false);
    return reqDetail.get("".concat(constants_api__WEBPACK_IMPORTED_MODULE_2__/* .API_EXODUS_URL */ .q7, "/emitten/").concat(symbol, "/info"));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getOrderbookPreviewBySymbol: getOrderbookPreviewBySymbol,
    getOrderbookList: getOrderbookList,
    createOrderbookList: createOrderbookList,
    editOrderbookList: editOrderbookList,
    deleteOrderbookList: deleteOrderbookList,
    getOrderbookListItem: getOrderbookListItem,
    getCompanyInfo: getCompanyInfo
});


/***/ }),

/***/ 70735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97373);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);


var screenerURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/screener");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getScreenerCustom = function() {
    return request.get("".concat(screenerURL, "/templates"));
};
var getScreenerMetrics = function() {
    return request.get("".concat(screenerURL, "/preset"));
};
var getLoadPresetScreener = function(id, type) {
    var queryString = type ? "?type=".concat(type) : "";
    return request.get("".concat(screenerURL, "/templates/").concat(id).concat(queryString));
};
var getScreenerUniverse = function() {
    return request.get("".concat(screenerURL, "/universe"));
};
var postScreenerListResult = function(data) {
    return request.post("".concat(screenerURL, "/templates"), data);
};
var getScreenerFavorites = function() {
    return request.get("".concat(screenerURL, "/favorites"));
};
var addScreenerFavorite = function(screenerid, type) {
    return request.post("".concat(screenerURL, "/favorites"), {
        screenerid: screenerid,
        type: type
    });
};
var removeScreenerFavorite = function(screenerid, type) {
    return request.delete("".concat(screenerURL, "/favorites/").concat(screenerid, "?type=").concat(type));
};
var getScreenerFinancial = function() {
    return request.get("".concat(screenerURL, "/metric"));
};
var removeScreenerCustom = function(screenerID) {
    return request.delete("".concat(screenerURL, "/templates/").concat(screenerID));
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getScreenerCustom: getScreenerCustom,
    getScreenerMetrics: getScreenerMetrics,
    getLoadPresetScreener: getLoadPresetScreener,
    getScreenerUniverse: getScreenerUniverse,
    postScreenerListResult: postScreenerListResult,
    getScreenerFavorites: getScreenerFavorites,
    addScreenerFavorite: addScreenerFavorite,
    removeScreenerFavorite: removeScreenerFavorite,
    getScreenerFinancial: getScreenerFinancial,
    removeScreenerCustom: removeScreenerCustom
});


/***/ }),

/***/ 45621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78372);


var requestExodusDefault = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_1__/* ["default"].noAlert */ .Z.noAlert;
var USER_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/user/setting");
var INVITATION_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/chat/v2/invitations/setting");
var NOTIFICATION_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/notification/settings");
var NOTIF_V2_SETTING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_0__/* .API_EXODUS_URL */ .q7, "/notification/v2/settings");
var getChangePasswordToken = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/token"), data);
};
var updatePassword = function(data) {
    return requestExodusDefault.put("".concat(USER_SETTING_URL, "/password"), data);
};
var getNotificationSettings = function() {
    return requestExodusDefault.get("".concat(NOTIF_V2_SETTING_URL));
};
var updateNotificationSetting = function(data) {
    return requestExodus.put("".concat(NOTIFICATION_SETTING_URL), data);
};
var getInvitationSetting = function() {
    return requestExodus.get("".concat(INVITATION_SETTING_URL));
};
var updateInvitationSetting = function(data) {
    return requestExodusDefault.put("".concat(INVITATION_SETTING_URL), data);
};
// Update email
var updateEmail = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/email"), data);
};
var confirmEmailOTP = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/email/confirm"), data);
};
// Update phone
var updatePhone = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/phone"), data);
};
var confirmPhoneOTP = function(data) {
    return requestExodusDefault.post("".concat(USER_SETTING_URL, "/phone/confirm"), data);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getChangePasswordToken: getChangePasswordToken,
    updatePassword: updatePassword,
    getNotificationSettings: getNotificationSettings,
    updateNotificationSetting: updateNotificationSetting,
    getInvitationSetting: getInvitationSetting,
    updateInvitationSetting: updateInvitationSetting,
    updateEmail: updateEmail,
    confirmEmailOTP: confirmEmailOTP,
    updatePhone: updatePhone,
    confirmPhoneOTP: confirmPhoneOTP
});


/***/ }),

/***/ 17065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var config_requestExodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97373);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable import/named */ 



var valuationURL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/valuation");
var request = (0,config_requestExodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
var getValuationTemplate = function() {
    return request.get("".concat(valuationURL, "/all/templates"));
};
var getValuationMetrics = function() {
    return request.get("".concat(valuationURL, "/metrics/lists"));
};
var postDeleteValuationTemplate = function(valuationId) {
    return request.delete("".concat(valuationURL, "/").concat(valuationId));
};
var postValuationResult = function(_param) {
    var symbol = _param.symbol, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol"
    ]);
    return request.post("".concat(valuationURL, "/company/").concat(symbol), data);
};
var postValuationTemplateSave = function(templateId, data) {
    return request.put("".concat(valuationURL, "/").concat(templateId), data);
};
var postValuationTemplateAdd = function(data) {
    return request.post("".concat(valuationURL), data);
};
var getValuationTemplateLoad = function(templateId) {
    return request.get("".concat(valuationURL, "/").concat(templateId));
};
var getValuationMetricsDefault = function(_param) {
    var symbol = _param.symbol, data = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "symbol"
    ]);
    return request.get("".concat(valuationURL, "/company/").concat(symbol, "/metrics"), {
        params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data)
    });
};
var getValuationMetricPerID = function(symbol, metricID) {
    return request.get("".concat(valuationURL, "/company/").concat(symbol, "/metrics"), {
        params: {
            metric: metricID
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getValuationTemplate: getValuationTemplate,
    getValuationMetrics: getValuationMetrics,
    postDeleteValuationTemplate: postDeleteValuationTemplate,
    postValuationResult: postValuationResult,
    postValuationTemplateSave: postValuationTemplateSave,
    postValuationTemplateAdd: postValuationTemplateAdd,
    getValuationTemplateLoad: getValuationTemplateLoad,
    getValuationMetricsDefault: getValuationMetricsDefault,
    getValuationMetricPerID: getValuationMetricPerID
});


/***/ }),

/***/ 21939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; }
/* harmony export */ });
/* unused harmony export selectors */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61876);
/* harmony import */ var lib_api_user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1955);
/* harmony import */ var _profile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(333);



// api

// module profile

// initial state
var initialState = {
    data: {},
    isLoading: false,
    error: null,
    message: "",
    userSkipOnboarding: {
        data: [],
        success: false,
        isLoading: true,
        error: null,
        message: ""
    }
};
// Selectors -------------------------------------------------------------------
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSelector */ .P1)(function(state) {
    return {
        data: state.entities.onboarding.data,
        isLoading: state.entities.onboarding.isLoading,
        error: state.entities.onboarding.error,
        message: state.entities.onboarding.message,
        userSkipOnboarding: state.entities.onboarding.userSkipOnboarding
    };
}, function(state) {
    return state;
});
// Actions ---------------------------------------------------------------------
// types
var CONTEXT = "@redux/user";
var actionType = {
    ONBOARDING_SKIP: "".concat(CONTEXT, "/ONBOARDING_SKIP"),
    UPLOAD_IMAGE_AVATAR: "".concat(CONTEXT, "/UPLOAD_IMAGE_AVATAR")
};
// effects
var effects = {
    // userSkipOnboarding -------------------------------------------------------------------
    userSkipOnboarding: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createAsyncThunk */ .hg)(actionType.ONBOARDING_SKIP, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(step, param) {
            var dispatch, response, _data, data, message, _$error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        dispatch = param.dispatch;
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return lib_api_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"].userSkipOnboarding */ .Z.userSkipOnboarding(step);
                    case 4:
                        response = _ctx.sent;
                        if (!response.data) {
                            _ctx.next = 11;
                            break;
                        }
                        _data = response.data, data = _data.data, message = _data.message, _$error = _data.error;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            message: message,
                            error: _$error
                        });
                    case 9:
                        // to update state profile
                        dispatch(// @ts-ignore
                        _profile__WEBPACK_IMPORTED_MODULE_2__/* ["default"].actions.updateOnboardingStep */ .ZP.actions.updateOnboardingStep({
                            step: step,
                            isClickedPreviousButton: false
                        }));
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 11:
                        throw new Error("Attempt to skip step onboarding Failed");
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14
                ]
            ]);
        }));
        return function(step, _) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducer ---------------------------------------------------------------------
var reducers = {
    /**
   * resetUserSkipOnBoarding
   * change resetUserSkipOnBoarding state to initialState
   */ resetUserSkipOnBoarding: function(draft) {
        draft.userSkipOnboarding.data = [];
        draft.userSkipOnboarding.success = false;
        draft.userSkipOnboarding.isLoading = true;
        draft.userSkipOnboarding.error = null;
        draft.userSkipOnboarding.message = "";
    }
};
// Extra Reducer ---------------------------------------------------------------
var extraReducers = function(builder) {
    builder.addCase(effects.userSkipOnboarding.pending, function(state, action) {
        state.userSkipOnboarding.isLoading = true;
    }).addCase(effects.userSkipOnboarding.fulfilled, function(state, action) {
        var _payload = action.payload, data = _payload.data, message = _payload.message, error = _payload.error;
        if (error) {
            state.userSkipOnboarding.error = error;
        } else {
            // to know response API is success or not
            state.userSkipOnboarding.success = true;
            state.userSkipOnboarding.data = data;
        }
        state.userSkipOnboarding.message = message;
        state.userSkipOnboarding.isLoading = false;
    }).addCase(effects.userSkipOnboarding.rejected, function(state, action) {
        state.userSkipOnboarding.error = action.payload.error;
        state.userSkipOnboarding.isLoading = false;
    });
};
// Slice -----------------------------------------------------------------------
var onboardingSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_4__/* .createSlice */ .oM)({
    name: "onboarding",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (onboardingSlice);


/***/ }),

/***/ 11733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ entities_shop; },
  "wl": function() { return /* binding */ selectors; },
  "CJ": function() { return /* binding */ thunks; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(61876);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
// EXTERNAL MODULE: ./src/config/requestExodus.ts
var requestExodus = __webpack_require__(97373);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
;// CONCATENATED MODULE: ./src/lib/api/shop.ts


// init request config
var request = (0,requestExodus/* default */.Z)();
// constants
var SHOP_URL = "".concat(api/* API_EXODUS_URL */.q7, "/pro-sub");
// api wrappers
var getProducts = function() {
    return request.get("".concat(SHOP_URL, "/products"));
};
var addItems = function(id, quantity) {
    return request.post("".concat(SHOP_URL, "/cart/item"), {
        id: id,
        quantity: quantity
    });
};
var removeItem = function() {
    return request.delete("".concat(SHOP_URL, "/cart"));
};
var getCart = function() {
    return request.get("".concat(SHOP_URL, "/cart"));
};
var checkout = function(gateway) {
    return request.post("".concat(SHOP_URL, "/cart/checkout"), {
        gateway: gateway
    });
};
var applyCoupon = function(coupon) {
    return request.post("".concat(SHOP_URL, "/coupon"), {
        coupon: coupon
    });
};
var removeCoupon = function() {
    return request.delete("".concat(SHOP_URL, "/coupon"));
};
var applyVoucher = function(voucher) {
    return request.post("".concat(SHOP_URL, "/voucher"), {
        voucher: voucher
    });
};
var removePromo = function(type) {
    return request.delete("".concat(SHOP_URL, "/").concat(type));
};
var getSubscriptions = function() {
    return request.get("".concat(SHOP_URL, "/subscription"));
};
var activateFreeTrial = function() {
    return request.post("".concat(SHOP_URL, "/free-trial/activate"));
};
var getPurchaseHistory = function(params) {
    return request.get("".concat(SHOP_URL, "/order/history"), {
        params: params
    });
};
/* harmony default export */ var shop = ({
    getProducts: getProducts,
    getCart: getCart,
    addItems: addItems,
    checkout: checkout,
    applyCoupon: applyCoupon,
    removeCoupon: removeCoupon,
    applyVoucher: applyVoucher,
    removeItem: removeItem,
    removePromo: removePromo,
    getSubscriptions: getSubscriptions,
    getPurchaseHistory: getPurchaseHistory,
    activateFreeTrial: activateFreeTrial
});

// EXTERNAL MODULE: ./src/features/shop-revamp/utils.ts
var utils = __webpack_require__(31366);
;// CONCATENATED MODULE: ./src/lib/entities/shop.ts









// lib

// types

// constants
var CONTEXT = "@entity/shop";
var actionType = {
    GET_PRODUCTS: "".concat(CONTEXT, "/GET_PRODUCTS"),
    CART_ADD_ITEM: "".concat(CONTEXT, "/CART_ADD_ITEM"),
    CONTINUE_SUBSCRIBE: "".concat(CONTEXT, "/CONTINUE_SUBSCRIBE"),
    CART_ADD_RECENT_ITEM: "".concat(CONTEXT, "/CART_ADD_RECENT_ITEM"),
    CART_REMOVE_ITEM: "".concat(CONTEXT, "/CART_REMOVE_ITEM"),
    CART_FETCH: "".concat(CONTEXT, "/CART_FETCH"),
    PAYMENT_CHECKOUT: "".concat(CONTEXT, "/PAYMENT_CHECKOUT"),
    APPLY_COUPON: "".concat(CONTEXT, "/APPLY_COUPON"),
    APPLY_VOUCHER: "".concat(CONTEXT, "/APPLY_VOUCHER"),
    REMOVE_PROMO: "".concat(CONTEXT, "/REMOVE_PROMO"),
    REMOVE_COUPON: "".concat(CONTEXT, "/REMOVE_COUPON"),
    GET_PURCHASE: "".concat(CONTEXT, "/GET_PURCHASE"),
    ACTIVATE_FREE: "".concat(CONTEXT, "/ACTIVATE_FREE"),
    GET_PURCHASE_HISTORY: "".concat(CONTEXT, "/GET_PURCHASE_HISTORY")
};
var initialState = {
    products: {
        isLoading: false,
        list: [],
        error: null,
        message: null
    },
    cart: {
        isLoading: false,
        error: null,
        products: [],
        promos: null,
        totals: null
    },
    payment: {
        isLoading: false,
        error: null,
        gateway: "bca_va",
        paymentURL: null,
        paymentType: "popup",
        orderId: ""
    },
    purchase: {
        isLoading: true,
        error: null,
        purchases: []
    },
    activateFreeTrial: {
        isLoading: true,
        error: null
    },
    history: {
        isLoading: false,
        orders: {},
        subscription: null
    }
};
// reducers
var reducers = {
    setGateway: function(draft, actions) {
        draft.payment.gateway = actions.payload;
    }
};
// thunks
var thunks = {
    // -- Fetch products
    fetchProducts: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PRODUCTS, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getProducts();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data, message = _data.message;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        products: data,
                        message: message
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Add items
    addItems: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_ADD_ITEM, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var selected, rejectWithValue, code, id, quantity, response, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selected = param.selected, rejectWithValue = param1.rejectWithValue;
                        code = selected.code, id = selected.id;
                        quantity = parseInt(code.substring(5, 7), 10);
                        if (quantity) {
                            _ctx.next = 6;
                            break;
                        }
                        rejectWithValue(quantity);
                        throw new Error("Invalid quantity format!");
                    case 6:
                        _ctx.next = 8;
                        return shop.addItems(id, quantity);
                    case 8:
                        response = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 12;
                            break;
                        }
                        throw new Error(error);
                    case 12:
                        return _ctx.abrupt("return", {
                            data: [
                                response.data.data
                            ]
                        });
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    continueSubscribe: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CONTINUE_SUBSCRIBE, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param, param1) {
            var selected, rejectWithValue, code, id, quantity, response, responseCart, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        selected = param.selected, rejectWithValue = param1.rejectWithValue;
                        code = selected.code, id = selected.id;
                        quantity = parseInt(code.substring(5, 7), 10);
                        if (quantity) {
                            _ctx.next = 6;
                            break;
                        }
                        rejectWithValue(quantity);
                        throw new Error("Invalid quantity format!");
                    case 6:
                        _ctx.next = 8;
                        return shop.addItems(id, quantity);
                    case 8:
                        response = _ctx.sent;
                        _ctx.next = 11;
                        return shop.getCart();
                    case 11:
                        responseCart = _ctx.sent;
                        error = response.data.error;
                        if (!error) {
                            _ctx.next = 15;
                            break;
                        }
                        throw new Error(error);
                    case 15:
                        return _ctx.abrupt("return", {
                            data: [
                                response.data.data
                            ],
                            cart: responseCart.data.data
                        });
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_, _1) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Add items
    removeItem: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_REMOVE_ITEM, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.removeItem();
                case 2:
                    response = _ctx.sent;
                    data = response.data;
                    error = data.error;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        message: "success"
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch Cart
    fetchCart: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.CART_FETCH, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getCart();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        products: data.products,
                        promos: data.promos,
                        totals: data.totals
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Checkout
    checkout: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.PAYMENT_CHECKOUT, function() {
        var _ref = // @ts-ignore
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(gateway) {
            var response, _data, data, error, apiURL, paymentType;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.checkout(gateway);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        if (!(data === null || data === void 0 ? void 0 : data.action)) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            paymentType: "popup",
                            snapToken: data.action.snap_token,
                            clientKey: data.action.client_key,
                            orderId: data.action.order_id
                        });
                    case 8:
                        apiURL = new URL(data.url);
                        paymentType = gateway === "veritrans" ? "redirect" : "popup";
                        return _ctx.abrupt("return", {
                            gateway: data.gateway,
                            url: data.url,
                            paymentType: paymentType,
                            snapToken: apiURL.searchParams.get("snap_token"),
                            clientKey: apiURL.searchParams.get("client_key")
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(gateway) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    applyCoupon: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.APPLY_COUPON, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(coupon) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.applyCoupon(coupon);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(coupon) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    applyVoucher: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.APPLY_VOUCHER, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(coupon) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.applyVoucher(coupon);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(coupon) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Apply Coupon
    removePromo: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.REMOVE_PROMO, function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(type) {
            var response, _data, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return shop.removePromo(type);
                    case 2:
                        response = _ctx.sent;
                        _data = response.data, data = _data.data, error = _data.error;
                        if (!error) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error(error);
                    case 6:
                        return _ctx.abrupt("return", {
                            data: data
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(type) {
            return _ref.apply(this, arguments);
        };
    }()),
    // -- Remove Coupon
    removeCoupon: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.REMOVE_COUPON, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, data, error;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.removeCoupon();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, data = _data.data, error = _data.error;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch products
    getPurchase: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PURCHASE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.getSubscriptions();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data, message = _data.message;
                    if (!error) {
                        _ctx.next = 6;
                        break;
                    }
                    throw new Error(error);
                case 6:
                    return _ctx.abrupt("return", {
                        purchases: data
                    });
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    // -- Fetch products
    activateFreeTrial: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.ACTIVATE_FREE, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, _data, error, data, message, error_type;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return shop.activateFreeTrial();
                case 2:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data;
                    message = data.message, error_type = data.error_type;
                    if (!(error || error_type)) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    (0,AlertErrorMessage/* default */.Z)(message, successMessage/* default.ALERT_GREEN */.Z.ALERT_GREEN);
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }))),
    fetchPurchaseHistory: (0,redux_toolkit_esm/* createAsyncThunk */.hg)(actionType.GET_PURCHASE_HISTORY, (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var params, response, _data, error, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = {
                        last_id: 0,
                        limit: 10
                    };
                    _ctx.next = 3;
                    return shop.getPurchaseHistory(params);
                case 3:
                    response = _ctx.sent;
                    _data = response.data, error = _data.error, data = _data.data;
                    if (!error) {
                        _ctx.next = 7;
                        break;
                    }
                    throw new Error(error);
                case 7:
                    return _ctx.abrupt("return", {
                        data: data
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })))
};
var extraReducers = function(builder) {
    return builder// Fetch products
    .addCase(thunks.fetchProducts.pending, function(draft) {
        draft.products.isLoading = true;
    }).addCase(thunks.fetchProducts.fulfilled, function(draft, actions) {
        draft.products.isLoading = false;
        draft.products.list = actions.payload.products;
        draft.products.message = actions.payload.message;
        draft.products.error = null;
    }).addCase(thunks.fetchProducts.rejected, function(draft, actions) {
        draft.products.isLoading = false;
        draft.products.error = actions.error;
    })// -- Add to cart
    .addCase(thunks.addItems.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.addItems.fulfilled, function(draft, actions) {
        draft.cart.error = null;
        draft.cart.isLoading = false;
        draft.cart.products = actions.payload.data;
        router_default().push("/shop/cart");
    }).addCase(thunks.addItems.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// Continue Subscribe
    .addCase(thunks.continueSubscribe.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.continueSubscribe.fulfilled, function(draft, actions) {
        draft.cart.error = null;
        draft.cart.isLoading = false;
        draft.cart.products = actions.payload.cart.products;
        router_default().push("/shop/cart");
    }).addCase(thunks.continueSubscribe.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// -- Fetch cart
    .addCase(thunks.fetchCart.pending, function(draft) {
        draft.cart.isLoading = true;
    }).addCase(thunks.fetchCart.fulfilled, function(draft, actions) {
        draft.cart = {
            isLoading: false,
            error: null,
            products: actions.payload.products,
            promos: actions.payload.promos,
            totals: actions.payload.totals,
            applyingVoucher: false
        };
    }).addCase(thunks.fetchCart.rejected, function(draft, actions) {
        draft.cart.isLoading = false;
        draft.cart.error = actions.error;
    })// -- Checkout
    .addCase(thunks.checkout.pending, function(draft) {
        draft.payment.isLoading = true;
    }).addCase(thunks.checkout.fulfilled, function(draft, actions) {
        draft.payment.error = null;
        draft.payment.isLoading = false;
        draft.payment.paymentType = actions.payload.paymentType;
        draft.payment.gateway = actions.payload.gateway;
        draft.payment.paymentURL = actions.payload.url;
        draft.payment.snapToken = actions.payload.snapToken;
        draft.payment.clientKey = actions.payload.clientKey;
    }).addCase(thunks.checkout.rejected, function(draft, actions) {
        draft.payment.isLoading = false;
        draft.payment.error = actions.error;
    }).addCase(thunks.removeItem.fulfilled, function() {
        router_default().push("/shop");
    }).addCase(thunks.applyCoupon.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    }).addCase(thunks.applyVoucher.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    }).addCase(thunks.removePromo.fulfilled, function(draft) {
        draft.cart.applyingVoucher = true;
    })// Fetch Purchases
    .addCase(thunks.getPurchase.pending, function(draft) {
        draft.purchase.isLoading = true;
    }).addCase(thunks.getPurchase.fulfilled, function(draft, actions) {
        draft.purchase.isLoading = false;
        draft.purchase.purchases = actions.payload.purchases;
    }).addCase(thunks.getPurchase.rejected, function(draft, actions) {
        draft.purchase.isLoading = false;
        draft.purchase.error = actions.error;
    })// Fetch Purchases
    .addCase(thunks.activateFreeTrial.pending, function(draft) {
        draft.activateFreeTrial.isLoading = true;
    }).addCase(thunks.activateFreeTrial.fulfilled, function(draft, actions) {
        draft.activateFreeTrial.isLoading = false;
    }).addCase(thunks.activateFreeTrial.rejected, function(draft, actions) {
        draft.activateFreeTrial.isLoading = false;
    })// Fetch Purchase History
    .addCase(thunks.fetchPurchaseHistory.pending, function(draft) {
        draft.history.isLoading = true;
    }).addCase(thunks.fetchPurchaseHistory.fulfilled, function(draft, actions) {
        draft.history.isLoading = false;
        draft.history.orders = (0,utils/* createMonthlyStatements */.gs)(actions.payload.data.orders);
        draft.history.subscription = actions.payload.data.subscription;
    }).addCase(thunks.fetchPurchaseHistory.rejected, function(draft, actions) {
        draft.history.isLoading = false;
    });
};
// selectors
var shopEntitySelector = function(state) {
    return state.entities.shop;
};
var selectProductList = function(state) {
    return state.products.list.map(function(param) {
        var description = param.description, keyword = param.keyword, price = param.price;
        return {
            duration: description,
            price: (numeral_default()(price).value() / 1000).toString(),
            description: keyword,
            features: "Full Features"
        };
    });
};
var selectors = (0,es/* createSelector */.P1)(shopEntitySelector, function(state) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
        products: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.products), {
            availableProducts: selectProductList(state)
        })
    });
});
// slice
var shopSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
    initialState: initialState,
    name: "shop",
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ var entities_shop = (shopSlice);


/***/ }),

/***/ 25178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "In": function() { return /* binding */ notificationCategories; },
/* harmony export */   "QV": function() { return /* binding */ disorganizeNormalizedNotification; },
/* harmony export */   "UC": function() { return /* binding */ notificationTypesWithAvatar; },
/* harmony export */   "WE": function() { return /* binding */ normalizeNotification; },
/* harmony export */   "Wj": function() { return /* binding */ notificationTypeUnreadParams; },
/* harmony export */   "h$": function() { return /* binding */ convertParams; },
/* harmony export */   "jg": function() { return /* binding */ notificationTabsAttrs; },
/* harmony export */   "x8": function() { return /* binding */ parseNotificationMessage; }
/* harmony export */ });
/* unused harmony exports notificationTypesMap, mergeNotificationCategories, filterNotificationItems */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36305);
/* harmony import */ var react_string_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59632);
/* harmony import */ var react_string_replace__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_string_replace__WEBPACK_IMPORTED_MODULE_0__);


/**
 * Notification types mapping
 */ var notificationTypesMap = {
    company: [
        "NOTIF_TYPE_NEW_REPORT"
    ],
    stream: [
        "NOTIF_TYPE_MENTIONS",
        "NOTIF_TYPE_REPLY"
    ],
    other: [
        "NOTIF_TYPE_FOLLOWING",
        "NOTIF_TYPE_RETWEET",
        "NOTIF_TYPE_LIKE",
        "NOTIF_TYPE_STREAMS_UPDATE",
        "NOTIF_TYPE_POSTALERT",
        "NOTIF_TYPE_STOCK_ALERT",
        "NOTIF_TYPE_TARGETPRICE",
        "NOTIF_TYPE_TRADING_MATCH_ORDER",
        "NOTIF_TYPE_TRADING_COMMUNITY",
        "NOTIF_TYPE_STREAMS_UPDATE",
        "NOTIF_TYPE_NEW_TRENDING",
        "NOTIF_TYPE_CALENDAR",
        "NOTIF_TYPE_NEWSFEED",
        "NOTIF_TYPE_GROUPCHAT_INVITE",
        "NOTIF_TYPE_VERIFIED_BADGE",
        "NOTIF_TYPE_SAVE",
        "NOTIF_TYPE_SECURITIES_DAY_TRADE",
        "NOTIF_TYPE_SHARIA_STOCK_DELISTED", 
    ],
    tipping: [
        "NOTIF_TYPE_TIPPING_RECEIVER",
        "NOTIF_TYPE_TIPPING_SENDER",
        "NOTIF_TYPE_CLAIM", 
    ]
};
var notificationTypeUnreadParams = [
    "NOTIF_TYPE_INBOX",
    "NOTIF_TYPE_MENTIONS",
    "NOTIF_TYPE_FOLLOWING",
    "NOTIF_TYPE_RETWEET",
    "NOTIF_TYPE_REPLY",
    "NOTIF_TYPE_LIKE",
    "NOTIF_TYPE_SAVE",
    "NOTIF_TYPE_POSTALERT",
    "NOTIF_TYPE_TRADING_MATCH_ORDER",
    "NOTIF_TYPE_NEW_TRENDING",
    "NOTIF_TYPE_STOCK_ALERT",
    "NOTIF_TYPE_NEWUSERJOIN",
    "NOTIF_TYPE_TARGETPRICE",
    "NOTIF_TYPE_TIPPING_RECEIVER",
    "NOTIF_TYPE_TIPPING_SENDER",
    "NOTIF_TYPE_CLAIM",
    "NOTIF_TYPE_VERIFIED_BADGE",
    "NOTIF_TYPE_SECURITIES_DAY_TRADE",
    "NOTIF_TYPE_SHARIA_STOCK_DELISTED",
    "NOTIF_TYPE_SECURITIES_DEPOSIT",
    "NOTIF_TYPE_SECURITIES_WITHDRAW",
    "NOTIF_TYPE_SECURITIES_REFERRAL",
    "NOTIF_TYPE_SECURITIES_MATCH",
    "NOTIF_TYPE_SECURITIES_REJECT",
    "NOTIF_TYPE_MESSAGE_REQUEST",
    "NOTIF_TYPE_EIPO_CONFIRMATION",
    "NOTIF_TYPE_GROUPCHAT",
    "NOTIF_TYPE_NEW_REPORT",
    "NOTIF_TYPE_NEWSFEED",
    "NOTIF_TYPE_COMPANY_PUBLIC_EXPOSE",
    "NOTIF_TYPE_COMPANY_SHAREHOLDING",
    "NOTIF_TYPE_COMPANY_DIVIDEND",
    "NOTIF_TYPE_COMPANY_CORP_ACTION",
    "NOTIF_TYPE_COMPANY_OTHERS",
    "NOTIF_TYPE_TRADING_COMMUNITY", 
];
var notificationReportType = [
    "NOTIF_TYPE_NEW_REPORT",
    "NOTIF_TYPE_NEWSFEED",
    "NOTIF_TYPE_COMPANY_PUBLIC_EXPOSE",
    "NOTIF_TYPE_COMPANY_SHAREHOLDING",
    "NOTIF_TYPE_COMPANY_DIVIDEND",
    "NOTIF_TYPE_COMPANY_CORP_ACTION",
    "NOTIF_TYPE_COMPANY_OTHERS", 
];
/**
 * Tabs attributes (className, name, typeCodes)
 */ var notificationTabsAttrs = [
    {
        name: "notification",
        className: "icon-notification_activity",
        // typeCodes: '3,5,6,7,9,12,16',
        typeCodes: notificationTypeUnreadParams
    },
    {
        name: "mention",
        className: "icon-notification_mention",
        typeCodes: [
            "NOTIF_TYPE_MENTIONS"
        ]
    },
    {
        name: "report",
        className: "icon-notification_report",
        typeCodes: notificationReportType
    },
    {
        name: "tipping",
        className: "icon-notification_tip",
        typeCodes: [
            "NOTIF_TYPE_TIPPING_RECEIVER",
            "NOTIF_TYPE_TIPPING_SENDER",
            "NOTIF_TYPE_CLAIM", 
        ]
    }, 
];
/**
 * Notification categories
 */ var notificationCategories = {
    reports: notificationReportType,
    replies: [
        "NOTIF_TYPE_REPLY"
    ],
    tipping: [
        "NOTIF_TYPE_TIPPING_RECEIVER",
        "NOTIF_TYPE_TIPPING_SENDER"
    ],
    tradingMatchOrder: [
        "NOTIF_TYPE_TRADING_MATCH_ORDER"
    ],
    trending: [
        "NOTIF_TYPE_NEW_TRENDING"
    ],
    verified: [
        "NOTIF_TYPE_VERIFIED_BADGE"
    ],
    dayTrade: [
        "NOTIF_TYPE_SECURITIES_DAY_TRADE"
    ]
};
/**
 * Notification types that includes avatar
 */ // export const notificationTypesWithAvatar = [1, 2, 3, 5, 7, 9, 12, 20, 42];
var notificationTypesWithAvatar = [
    "NOTIF_TYPE_INBOX",
    "NOTIF_TYPE_MENTIONS",
    "NOTIF_TYPE_FOLLOWING",
    "NOTIF_TYPE_RETWEET",
    "NOTIF_TYPE_LIKE",
    "NOTIF_TYPE_SAVE",
    "NOTIF_TYPE_POSTALERT",
    "NOTIF_TYPE_TARGETPRICE",
    "NOTIF_TYPE_REPLY",
    "NOTIF_TYPE_TRADING_COMMUNITY", 
];
/**
 * Normalize notification data (copy-pasted from legacy code)
 * @param {Object} data - raw data
 * @returns {Object}
 */ var normalizeNotification = function(data) {
    var generated = {
        count: {
            company: 0,
            stream: 0,
            other: 0,
            tipping: 0
        },
        content: {
            company: [],
            stream: [],
            other: [],
            tipping: []
        }
    };
    if (!data) {
        return generated;
    }
    if (data.length === 0) {
        return generated;
    }
    var hashmap = {};
    data.forEach(function(v) {
        if (!hashmap[v.id]) {
            // check if hashmap data not found
            hashmap[v.id] = true;
            Object.keys(notificationTypesMap).forEach(function(name) {
                var index = notificationTypesMap[name].findIndex(function(mapv) {
                    return mapv === v.type;
                });
                if (index > -1) {
                    generated.count[name] += 1;
                    generated.content[name].push(v);
                }
            });
        }
    });
    return generated;
};
/**
 * Turn normalized data to its origin form
 * @param {Object} data - normalized data
 * @returns {Object}
 */ var disorganizeNormalizedNotification = function(data) {
    if (!data.company || !data.stream || !data.other) {
        return [];
    }
    var map = [];
    Object.keys(data).forEach(function(name) {
        map = map.concat(data[name]);
    });
    return map;
};
/*
 * Parse notification message
 * @Author: stockbit6
 * @Date:   2017-10-17 13:19:47
 * @Last Modified by:   stockbit6
 * @Last Modified time: 2018-01-10 10:02:20
 *
 * TODO:
 *
 * This is copy pasted from legacy code. Only
 * renaming some variables to match with properties
 * passed down from parent component or save myself
 * from linter error.
 *
 * It is unreadable but battle-tested since 2017.
 * I need to consult the author of this snippet and
 * then come back here knowing what this parser is
 * trying to do. No explanation whatsoever.
 *
 * UPDATED:
 * This function is used for format message from masked
 * property response.
 */ var parseNotificationMessage = function(props) {
    var selection = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var message = props.message, mask = props.mask, render = props.render;
    var tag = props.tag;
    // reset mask
    mask = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(mask);
    if (selection) {
        var selected = props[selection];
        if (selected.message) {
            message = selected.message || "";
            mask = selected.mask || {};
        }
    }
    if (!render) render = function(currentContent) {
        return currentContent;
    };
    if (!message) message = "";
    if (message.indexOf("\n") > -1) {
        mask.push({
            key: "brbrbr",
            payload: {
                tag: "br",
                text: ""
            }
        });
        message = message.replace(/[\r\n]{2,}/g, "\n\n");
        message = message.split("\n").map(function(value) {
            return "".concat(value, " [%brbrbr%] ");
        }).join("");
    }
    var currentContent = message;
    if (message.indexOf("[%") < 0 || message.indexOf("%]") < 0) {
        if (typeof currentContent === "string" && typeof props.renderParseString === "function") {
            return props.renderParseString(currentContent);
        }
        return render(message, tag);
    }
    // eslint-disable-next-line array-callback-return
    mask.map(function(item) {
        var search = "[%".concat(item.key, "%]");
        var result = message.indexOf(search) > -1;
        if (result) {
            currentContent = react_string_replace__WEBPACK_IMPORTED_MODULE_0___default()(currentContent, search, function() {
                var text = "";
                var tagInside = "";
                text = item.payload.text ? item.payload.text : text;
                // Convert PAYLOAD_MASK_TAG_BOLD to b
                tagInside = item.payload.tag === "PAYLOAD_MASK_TAG_BOLD" ? "b" : item.payload.tag;
                return parseNotificationMessage({
                    message: text,
                    tag: tagInside,
                    mask: mask,
                    render: render
                });
            });
        }
    });
    if (typeof currentContent.map === "function") {
        currentContent = currentContent.map(function(item) {
            if (typeof item === "string" && typeof props.renderParseString === "function" && item) {
                return props.renderParseString(item);
            }
            return item;
        });
    }
    if (typeof currentContent === "string" && typeof props.renderParseString === "function" && currentContent) {
        return props.renderParseString(currentContent);
    }
    return currentContent;
};
/**
 *
 * @param {object} content - Broadcast content. See
 * @returns
 */ var mergeNotificationCategories = function(content) {
    return [].concat(content.stream, content.company, content.other, content.tipping)// @ts-ignore
    .sort(function(a, b) {
        return new Date(b.created) - new Date(a.created);
    });
}; // Sorted by most recent
/**
 * Filter out notification items
 * @param {string} tab - Notification tab name (activity, mention, report, tipping)
 * @returns (content: {}) => {array}
 */ var filterNotificationItems = function(tab) {
    return function(content) {
        var list = [];
        switch(tab){
            case "notification":
                return mergeNotificationCategories(content);
            case "mention":
                return content.stream;
            case "report":
                return content.company;
            case "tipping":
                return content.tipping;
            default:
                return list;
        }
    };
};
var convertParams = function(params) {
    var convertedParams = new URLSearchParams();
    if (params.types && params.types.length > 0) {
        params.types.map(function(type) {
            return convertedParams.append("types", type);
        });
    }
    if (params.limit) {
        convertedParams.append("limit", params.limit);
    }
    if (params.last_id) {
        convertedParams.append("last_id", params.last_id);
    }
    return convertedParams;
};


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "ps": function() { return /* binding */ parseCountAbbrv3; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += " K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += " M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += " B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += " T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var nNumber = (number >= 0 ? Math.floor : Math.ceil)(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n1) {
    return Number(n1) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    // eslint-disable-next-line eqeqeq
    if (newNumber && newNumber.toString().indexOf("-") == 0) {
        minus = true;
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += " ".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n1) {
    return !Number.isNaN(parseFloat(n1)) && Number.isFinite(n1);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += " ".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += " K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(n))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal
});


/***/ }),

/***/ 78603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IL": function() { return /* binding */ uploadFiles; },
/* harmony export */   "Ox": function() { return /* binding */ generateId; }
/* harmony export */ });
/* unused harmony exports convertToSlug, formatUploadFileName */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82670);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37213);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61608);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25516);
/* harmony import */ var lib_api_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51679);
/* eslint-disable no-console */ /* eslint-disable no-useless-escape */ 




function convertToSlug(text) {
    if (!text) return text;
    return text.toString().toLowerCase().replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-$/, ""); // Trim - from end of text
}
var generateId = function() {
    // @ts-ignore
    var crypto = (window === null || window === void 0 ? void 0 : window.crypto) || (window === null || window === void 0 ? void 0 : window.msCrypto);
    var array = new Uint32Array(1);
    crypto.getRandomValues(array); // Compliant for security-sensitive use cases
    var id = array[0];
    return id;
};
var formatUploadFileName = function(file) {
    // eslint-disable-next-line no-bitwise
    var extension = file.slice((file.lastIndexOf(".") - 1 >>> 0) + 2); // Returning only file extension, safeguarding from 'filename' or '.filename'
    var filename = file.substr(0, file.lastIndexOf("."));
    var randomId = generateId();
    var d = new Date();
    var currDate = String("00".concat(d.getDate())).slice(-2); // Get today's date with leading zero
    var currMonth = String("00".concat(d.getMonth() + 1)).slice(-2); // Get today's month with leading zero
    var currYear = d.getFullYear();
    return "".concat(convertToSlug("".concat(filename, " ").concat(randomId).concat(currYear).concat(currMonth).concat(currDate)), ".").concat(extension);
};
/**
 * Creating upload file promise object
 * @param {Object} file
 * @param {String} token
 * @returns {Promise}
 */ var createUploadPromise = function(file, token) {
    var bucket = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "stockbit";
    /**
   * If an old url file is being passed, return the passed url instead.
   * The old file validation process works by checking if the filename sent is
   * a string and an url with http or https
   */ if (typeof file === "string" && file.indexOf("http") !== -1) {
        return Promise.resolve({
            data: {
                url: file
            }
        });
    }
    // Generate unique filename
    var fileName = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(file, File) ? file.name : String(file.split("/").pop());
    var newFileName = formatUploadFileName(fileName);
    var fd = new FormData();
    var formerFile = null;
    // eslint-disable-next-line no-underscore-dangle
    if (file._file) formerFile = file._file;
    fd.append("key", newFileName);
    fd.append("AWSAccessKeyId", token.AWSAccessKeyId);
    fd.append("acl", "public-read");
    fd.append("success_action_redirect", token.success_action_redirect);
    fd.append("policy", token.policy);
    fd.append("signature", token.signature);
    fd.append("Content-Type", "");
    if (!formerFile) {
        fd.append("file", file);
    } else {
        fd.append("file", formerFile);
    }
    var awsBucket = constants_api__WEBPACK_IMPORTED_MODULE_0__/* .AWS_IMAGES_BUCKET */ .Me;
    if (bucket === "simasreg") awsBucket = constants_api__WEBPACK_IMPORTED_MODULE_0__/* .AWS_TRADE_REG_BUCKET */ .vw;
    if (bucket === "avatar") awsBucket = constants_api__WEBPACK_IMPORTED_MODULE_0__/* .AWS_AVATAR_BUCKET */ .cU;
    return fetch(awsBucket, {
        method: "POST",
        cache: "default",
        body: fd,
        mode: "cors"
    }).then(function(response) {
        return response.json();
    }).catch(function(err) {
        console.error("SINGLE FILE ERROR", err);
        (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].STREAM_ERROR_UPLOAD_FILE */ .Z.STREAM_ERROR_UPLOAD_FILE, constants_errorMessage__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
        return err;
    });
};
/**
 * Upload files stacked into Amazon S3
 * @param {Array} files
 * @returns {Object}
 */ var uploadFiles = function() {
    var files = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], bucket = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "stockbit";
    return lib_api_stream__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getUploadToken */ .Z.getUploadToken(bucket).then(function(res) {
        var _data = res.data, token = _data.data;
        var collection = [];
        // eslint-disable-next-line no-unused-vars
        var mappingFiles = files.map(function(file) {
            var uploadPromise = createUploadPromise(file, token, bucket);
            collection.push(uploadPromise);
            return file;
        });
        return Promise.all(collection).then(function(data) {
            return data;
        }).catch(function(err) {
            return console.error("MUNCUL ERROR", err);
        });
    });
};


/***/ }),

/***/ 92953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var _auth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14229);
/* harmony import */ var _general__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42227);
/* eslint-disable no-param-reassign */ /* eslint-disable no-console */ /* eslint-disable camelcase */ /* eslint-disable no-plusplus */ 




// WS CONFIG VARIABLES
var WS_LIVEPRICE = true;
var WS_STREAM = true;
var WS_TRADING = true;
/**
 * Parse new socket string data, identified with # property
 * @param  {String} socketString - String you want to parse, returned from socket
 * @return {Object} Parsed socket string in object form
 */ function parseSocketString() {
    var socketString = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var parsedRawObject = socketString.split("|");
    var parsedObject = {};
    var priceObjectList = [];
    var hotlistData = [];
    switch(parsedRawObject[0]){
        case "#C":
            parsedObject = {
                C: {
                    sym: parsedRawObject[1],
                    date_unix: Number(parsedRawObject[2]),
                    ohlc: {
                        Adj_Close: Number(parsedRawObject[4]),
                        Close: Number(parsedRawObject[8]),
                        High: Number(parsedRawObject[6]),
                        Low: Number(parsedRawObject[7]),
                        Open: Number(parsedRawObject[5]),
                        volume: Number(parsedRawObject[9]),
                        date_unix: Number(parsedRawObject[2]),
                        date_formated: parsedRawObject[3],
                        dividend: Number(parsedRawObject[13]),
                        foreign_buy: Number(parsedRawObject[14]),
                        foreign_flow: Number(parsedRawObject[15]),
                        foreign_sell: Number(parsedRawObject[16]),
                        frequency: Number(parsedRawObject[17]),
                        marketcap: Number(parsedRawObject[18]),
                        value: Number(parsedRawObject[19]),
                        shareoutstanding: Number(parsedRawObject[20]),
                        ann_eps: Number(parsedRawObject[21]),
                        ann_pe: Number(parsedRawObject[22]),
                        avg_price: Number(parsedRawObject[23]),
                        previous: Number(parsedRawObject[24]),
                        freq_analyzer: Number(parsedRawObject[25])
                    },
                    widget: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, parsedRawObject[1], {
                        lastprice: Number(parsedRawObject[10]),
                        price_change: Number(parsedRawObject[11]),
                        percentage_change: Number(parsedRawObject[12])
                    }),
                    "OFFER-RG": {},
                    "BID-RG": {},
                    __t: parsedRawObject[26]
                },
                __t: parsedRawObject[26]
            };
            break;
        case "#O":
            // eslint-disable-next-line no-case-declarations
            var arrayLength = parsedRawObject.length - 2;
            for(var i = 3; i <= arrayLength; i++){
                // eslint-disable-line no-plusplus
                if (parsedRawObject[i] && typeof parsedRawObject[i] === "string" && parsedRawObject[i].includes(";")) {
                    var splittedPrice = parsedRawObject[i].split(";");
                    var _splittedPrice = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(splittedPrice, 3), price = _splittedPrice[0], queue = _splittedPrice[1], volume = _splittedPrice[2];
                    var priceObject = {
                        price: price,
                        queue: queue,
                        volume: volume
                    };
                    priceObjectList.push(priceObject);
                }
            }
            parsedObject = {
                O: {
                    sym: parsedRawObject[1]
                },
                __t: parsedRawObject[13]
            };
            if (parsedRawObject[2] === "OFFER") {
                parsedObject.O["OFFER-RG"] = {};
                priceObjectList.forEach(function(priceObject, index) {
                    parsedObject.O["OFFER-RG"]["price".concat(index + 1)] = Number(priceObject.price);
                    parsedObject.O["OFFER-RG"]["que_num".concat(index + 1)] = Number(priceObject.queue);
                    parsedObject.O["OFFER-RG"]["volume".concat(index + 1)] = Number(priceObject.volume);
                });
            }
            if (parsedRawObject[2] === "BID") {
                parsedObject.O["BID-RG"] = {};
                priceObjectList.forEach(function(priceObject, index) {
                    parsedObject.O["BID-RG"]["price".concat(index + 1)] = Number(priceObject.price);
                    parsedObject.O["BID-RG"]["que_num".concat(index + 1)] = Number(priceObject.queue);
                    parsedObject.O["BID-RG"]["volume".concat(index + 1)] = Number(priceObject.volume);
                });
            }
            break;
        case "#H":
            for(var i1 = 2; i1 < parsedRawObject.length; i1++){
                // eslint-disable-line no-plusplus
                var companyData = parsedRawObject[i1].split(";");
                if (companyData[0]) {
                    hotlistData[i1 - 2] = {
                        symbol: companyData[0],
                        name: companyData[1],
                        change: Number(companyData[2]),
                        lastprice: Number(companyData[3]),
                        percentage_change: Number(companyData[4]),
                        // for notation and corporate action
                        company_id: Number(companyData[5]),
                        withNotation: Number(companyData[6]) === 1,
                        withUMA: Number(companyData[7]) === 1,
                        withCorpAction: Number(companyData[8]) === 1
                    };
                }
            }
            parsedObject = {
                H: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, parsedRawObject[1], hotlistData)
            };
            break;
        case "#I":
            parsedObject = {
                I: {
                    sym: parsedRawObject[1],
                    date_unix: Number(parsedRawObject[2]),
                    ohlc: {
                        close: Number(parsedRawObject[8]),
                        high: Number(parsedRawObject[6]),
                        low: Number(parsedRawObject[7]),
                        open: Number(parsedRawObject[5]),
                        volume: Number(parsedRawObject[9])
                    }
                }
            };
            break;
        default:
            parsedObject = {
                info: parsedRawObject
            };
            break;
    }
    return parsedObject;
}
var setLocalWskey = function(access_wskey) {
    return (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .saveObject */ .Ex)("ws", access_wskey);
};
var getLocalWskey = function() {
    var ls = window.localStorage;
    try {
        return ls.ws ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .decodeBase64ToJS */ .OB)(ls.ws) : null;
    } catch (e) {
        console.error(e);
        return null;
    }
};
var useLocalWskey = function() {
    var ls = window.localStorage;
    var toSend = "";
    var wskey = ls.ws ? (0,_general__WEBPACK_IMPORTED_MODULE_1__/* .decodeBase64ToJS */ .OB)(ls.ws) : null;
    if (wskey) {
        toSend = wskey.pop();
        setLocalWskey(wskey); // update wskey local
    }
    return toSend;
};
// websocket config methods
/**
 * Get primus config
 * @param {*} c - subscribe company
 * @param {*} s - subscribe stream -> main stream , symbol stream, profile stream
 * @param {*} o - subscribe orderbook
 * @param {*} h - subscribe hotlist
 * @param {*} t - subscribe trading
 * @returns {Object}
 */ function getConfig(c, s, o) {
    var h = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, t = arguments.length > 4 ? arguments[4] : void 0;
    var user = _auth__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getUserAccess */ .Z.getUserAccess();
    var config = {
        loggedInUser: user === null || user === void 0 ? void 0 : user.id,
        chname: {
            C: [],
            S: [],
            O: [],
            // "C": c || [], // to subscribe company
            // "C": [], // 1 , orderbook , chartbit , company profile, sector
            // "S": ["*.news"], // main stream , symbol stream, profile stream
            // "S": [], // main stream , symbol stream, profile stream
            // "S": s || ["*"], // main stream , symbol stream, profile stream
            // "H": false, // hotlist
            T: [],
            H2: h
        }
    };
    if (WS_LIVEPRICE) config.chname.C = c || [];
    if (WS_STREAM) {
        config.chname.S = s || [];
    }
    if (WS_TRADING) config.chname.T = t || [];
    config.chname.O = o || [];
    return config;
}
/**
 * Write/send/emit subscription data to backend websocket
 * @param {Object} primus - Primus websocket
 * @param {Object} config - WS config
 */ function extendWrite(primus, config) {
    if (!primus) return;
    if (!WS_STREAM) config.chname.S = [];
    if (config.chname.S.length > 0 && config.chname.S[0].toLowerCase().includes("all")) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(config.chname.S[0].split("."), 1), category = ref[0];
        var newConfigChnameS = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(config.chname.S);
        newConfigChnameS[0] = category;
        config.chname.S = newConfigChnameS;
    }
    primus.write(config);
}
/**
 * Initiate websocket subscription
 * @param {Object} primus - Primus websocket
 * @param {Object} state - Websocket reducer
 * @param {string} wskey
 */ var initConfig = function(primus, state, wskey) {
    var ch = {};
    if (!ch.S) ch.S = state.livedata_channels.stream;
    if (!ch.C) ch.C = state.livedata_channels.company;
    if (!ch.O) ch.O = state.livedata_channels.orderbook;
    var socket_config = getConfig(ch.C, ch.S, ch.O);
    if (wskey) socket_config.wskey = wskey;
    socket_config.chname.O = socket_config.chname.O.filter(Boolean);
    socket_config.chname.C = socket_config.chname.C.filter(Boolean);
    extendWrite(primus, socket_config);
};
/**
 * Update websocket subscription config
 * @param {object} primus
 * @param {object} state - Websocket reducer state
 * @param {string} wskey
 */ var updateConfig = function(primus, state, wskey) {
    var ch = {};
    if (!ch.S) ch.S = state.stream;
    if (!ch.C) ch.C = state.company || [];
    if (!ch.O) ch.O = state.orderbook || [];
    if (!ch.H2) ch.H2 = state.hotlist;
    var socket_config = getConfig(ch.C, ch.S, ch.O, ch.H2);
    if (wskey) socket_config.wskey = wskey;
    socket_config.chname.O = socket_config.chname.O.filter(Boolean);
    socket_config.chname.C = socket_config.chname.C.filter(Boolean);
    extendWrite(primus, socket_config);
};
function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(var i = arr1.length; i--;){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
/**
 * To re evaluate config
 * @param  {[type]} state [description]
 * @return {[type]}       [description]
 */ var updateGeneralWsConfig = function(state, newConfig) {
    var config = composeGeneralWsConfig(newConfig); // generate new config
    var result = needRerender(state, config); // need rerender ?
    if (!result) return false; // difference not found
    return config;
};
var needRerender = function(state, next) {
    var livedata_channels = (state || {}).livedata_channels;
    if (!livedata_channels) livedata_channels = {};
    var toCompare = {
        stream: livedata_channels.stream || [],
        company: livedata_channels.company || [],
        orderbook: livedata_channels.orderbook || [],
        hotlist: livedata_channels.hotlist || false
    };
    var orderbook_diff = !arraysEqual(toCompare.orderbook, next.orderbook); // company difference
    var company_diff = !arraysEqual(toCompare.company, next.company); // company difference
    var stream_diff = !arraysEqual(toCompare.stream, next.stream); // stream difference
    var hotlist_diff = toCompare.hotlist !== next.hotlist;
    if (stream_diff || company_diff || orderbook_diff || hotlist_diff) return true;
    return false; // no need to re render
};
var composeGeneralWsConfig = function(state) {
    var config = {};
    /**
   * config for company
   */ config.company = [];
    var merged = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.company) || []).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.orderbook) || []));
    var merged_orderbook = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.orderbook) || []);
    var unique = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(merged)); // uniq array
    var unique_orderbook = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(merged_orderbook)); // uniq array orderbook
    var new_map = unique.filter(function(v) {
        return v !== undefined;
    }).map(function(v) {
        return typeof v === "string" ? v.toUpperCase() : v;
    });
    var new_orderbook = unique_orderbook.filter(function(v) {
        return v !== undefined;
    }).map(function(v) {
        return typeof v === "string" ? v.toUpperCase() : v;
    });
    // console.log('::-- new_map ', new_map) // unique
    // console.log('::-- new_orderbook', new_orderbook) // unique
    config.company = new_map;
    config.orderbook = new_orderbook;
    // console.log('::@@ Socket O SUBSCRIBE', new_orderbook)
    // console.log('::@@ Socket C SUBSCRIBE', new_map)
    /**
   * end config for company
   */ /**
   * config for stream
   */ var stream = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((state === null || state === void 0 ? void 0 : state.stream) || []);
    config.stream = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(stream));
    /**
   * end config for stream
   */ // Socket config for Hotlist, only available if widget has data
    config.hotlist = state === null || state === void 0 ? void 0 : state.hotlist;
    return config;
};
var convertWSKeyArray = function(wskey) {
    if (wskey && typeof wskey === "string") {
        return [
            wskey
        ];
    }
    return wskey;
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    parseSocketString: parseSocketString,
    setLocalWskey: setLocalWskey,
    getLocalWskey: getLocalWskey,
    useLocalWskey: useLocalWskey,
    getConfig: getConfig,
    extendWrite: extendWrite,
    initConfig: initConfig,
    updateConfig: updateConfig,
    updateGeneralWsConfig: updateGeneralWsConfig,
    convertWSKeyArray: convertWSKeyArray
});


/***/ })

}]);